import { assertCalculatedPrintLayout } from "../utils/calculatedPrintGuard";
import { isCalculatedPricing, projectCustomerPricingPayload } from "../utils/calculatedPricing";
import { createContractRevisionStore, guardContractPutRequest, mapContractWriteError, withSelectedContractInvoice } from "../utils/pricingContractSaveUtils";
import jsreport from "jsreport-browser-client-dist";
import AWS from "aws-sdk";
import _ from "lodash";
import moment from "moment";

// import * as utils from "../utils/utils";
import {
	getKeyPrefix,
	generateUUID,
	fixFileNameForS3,
	normalizeActivity,
	setFullSessionName,
	recurseReplaceSpeeds,
	recurseConvertChecklistToMarkdown,
	recurseDriveRefsToUrls,
	isMobile,
	filterLearningActivities,
	isChecklistItems,
	isChecklistSections,
	isChecklistLists,
	createBlobCsv2,
	recurseToFlatArray,
	recurseToFlatArrayAdvanced,
	arrayToMap,
	exportContentDumpToJson
} from "../utils/utils";
import state from "../state/state";
import env from "../constants/env";
import * as utils from "../utils/utils";
import { refreshCredentials } from "../utils/securityUtil";
import { showError, showSuccess, showError2, showSuccessToast, showInfo, showWarningToast } from "../actions/alertActions";
import { updateSharedDocument } from "../actions/shareActivityActions";
import { getOrgId } from "../actions/orgsActions";
import { updateAttribute, getIdentityId, getEmail, isOrganizationAdministrator, isOrganizationAuthor, getJwtToken } from "../actions/user";
import { getExternalResource, putLock } from "../actions/activityActions";
import { getActivityById, setActivities, updateActivity, initializeInventory, INVENTORY_EXTERNAL_CONTENT_PERSISTENT_PROPS } from "../actions/inventoryActions";
import { sendInventoryAndUserInfoMessage, postMessage } from "../actions/mobileAppCommunicationActions";
import PlayerPaths from "../constants/paths/playerPaths";
import { associateActivityWithWorkflow } from "../actions/workflowActions";
import { showStatusSpinner, hideStatusSpinner } from "../actions/actions";
import { hidePlayerSpinner, reloadActivities, showPlayerSpinner } from "../actions/playerActions";

import { publishActivityForPrintInvoice, publishActivityForPrint, publishActivityToSignedUrls } from "../actions/publish";

import FileSaver from "file-saver";
import { getContent, getDriveForActivity, getDriveObject } from "../actions/drive";

import request from "superagent";
import { assertCurrentJobTarget } from "../search/algolia";
import { rememberJobReassignment } from "../utils/jobReassignmentTargets";

import { createExperiencesInventoryFromActivities, createExperiencesInventoryItemFromActivity } from "../utils/activity";
import { getChatCompletions } from "../ai/aiAssistant";
import { getMediaPanelRequiredProperties } from "../utils/mediaUtils";
import { getReadOnlyAuthoringMessage, isCurrentTabAuthoringReadOnly } from "../utils/multiTabAuthoringGuard";
import { preparePdfDataEmojiImages } from "../utils/printEmojiUtils";
import { getProjectOpsContributionPricingSummary } from "../utils/pricingUtils";
import { computeBudgetAwarePricingTotal } from "../utils/pricingTotalUtils";
import { isProjectOpsEnabledForOrg } from "../utils/projectOpsUtils";
import {
	applyPricingModeToInvoiceItems,
	getActivityPricingContext as getNormalizedActivityPricingContext,
	getRetailModePolicy,
	hasRetailTiersConfig,
	normalizePricingMode,
	PRICING_MODE_RETAIL
} from "../utils/retailPricingUtils";
import { getActivityItemValueById, getEstimatePrintOptions } from "../utils/estimateUtils";
import {
	applyEstimatePrintCurrentDraft,
	normalizeEstimatePrintCurrentDraft
} from "../utils/estimatePrintUtils";
import {
	buildRetailEstimateReportData,
	RETAIL_ESTIMATE_JSREPORT_TEMPLATE
} from "../reporting/estimateRetailReport";
import { extractS3ResponseDiagnosticContext } from "../utils/s3DiagnosticUtils";
import { buildContentReviewV2Model } from "../utils/contentReviewUtils";
import { prepareSharedTaskIdentityReportFields } from "../utils/sharedTaskIdentityReportUtils";
import { buildInvoicePrintFilename } from "../utils/invoiceNumberUtils";
import { applyAdvanceOnAcknowledgeStrategyMigration } from "../utils/advanceOnAcknowledgeStrategyUtils";
import { applyMoveForwardMigration } from "../utils/moveForwardUtils";
import { getActivityInventoryMediaFields, getActivityHeroMediaFields } from "../utils/activityInventoryMediaUtils";
import { preserveInventorySharingMetadata } from "../utils/activitySharingMetadata";
import { isPricingSessionActive, validatePricingChecklistForSession } from "../utils/pricingSessionUtils";
import {
	buildAuthorizedContentReviewV2LambdaEvent,
	buildContentReviewV2ImportRequest,
	isValidContentReviewV2ImportAuthorization,
	shouldUseContentReviewImportCapability
} from "../utils/contentReviewImportUtils";
import {
	buildCustomerIdentityMaps,
	fetchFreshJabCustomers,
	isJabOrganization,
	resolveInvoiceCustomerIdentityOrThrow
} from "../utils/customerIdentityUtils";
import {
	buildJobReassignmentEdge,
	getCurrentInstanceOwnerIdentityId,
	isCompleteCustomerIdentitySnapshot,
	normalizeCustomerIdentitySnapshot
} from "../utils/jobReassignmentUtils";

// import timerTemplates from "../data/timerTemplates.json";

AWS.config.update({ region: env.aws.defaultRegion });

const PRINT_SIGNABLE_MEDIA_PROPS = _.uniq([].concat(
	getMediaPanelRequiredProperties(),
	["heroImage", "heroImageUrl", "logoImage", "logoImageSmall"]
));

const PUBLISHED_SOURCE_METADATA_KEYS = [
	"powerPointImport",
	"sourcePresentation",
	"sourcePresentationSlide",
	"sourcePresentationSlideMatch"
];
const WEB_DIAGNOSTICS_GLOBAL_KEY = "__AMBIFI_WEB_DIAGNOSTICS__";

function getWebDiagnosticsApi() {
	if (typeof window === "undefined") {
		return null;
	}
	return window[WEB_DIAGNOSTICS_GLOBAL_KEY] || null;
}

function recordWebDiagnosticEvent(eventType, detail = {}) {
	try {
		const api = getWebDiagnosticsApi();
		if (api && _.isFunction(api.recordEvent)) {
			return api.recordEvent(eventType, detail);
		}
		if (typeof window !== "undefined" && _.isFunction(window.ambifiRecordDiagnosticEvent)) {
			return window.ambifiRecordDiagnosticEvent(eventType, detail);
		}
	} catch (err) {
		console.warn("Unable to record diagnostic event", err);
	}
	return null;
}

function recordWebDiagnosticNetworkEntry(detail = {}) {
	try {
		const api = getWebDiagnosticsApi();
		if (api && _.isFunction(api.recordNetworkEntry)) {
			return api.recordNetworkEntry(detail);
		}
		if (typeof window !== "undefined" && _.isFunction(window.ambifiRecordDiagnosticNetworkEntry)) {
			return window.ambifiRecordDiagnosticNetworkEntry(detail);
		}
	} catch (err) {
		console.warn("Unable to record diagnostic network entry", err);
	}
	return null;
}

function enableTemporaryWebDiagnosticCapture(reason, durationMs, context = {}) {
	try {
		const api = getWebDiagnosticsApi();
		if (api && _.isFunction(api.enableTemporaryCapture)) {
			return api.enableTemporaryCapture(reason, durationMs, context);
		}
		if (typeof window !== "undefined" && _.isFunction(window.ambifiEnableDiagnosticCapture)) {
			return window.ambifiEnableDiagnosticCapture(reason, durationMs, context);
		}
	} catch (err) {
		console.warn("Unable to enable diagnostic capture", err);
	}
	return null;
}

function disableTemporaryWebDiagnosticCapture(reason, context = {}) {
	try {
		const api = getWebDiagnosticsApi();
		if (api && _.isFunction(api.disableTemporaryCapture)) {
			return api.disableTemporaryCapture(reason, context);
		}
		if (typeof window !== "undefined" && _.isFunction(window.ambifiDisableDiagnosticCapture)) {
			return window.ambifiDisableDiagnosticCapture(reason, context);
		}
	} catch (err) {
		console.warn("Unable to disable diagnostic capture", err);
	}
	return null;
}

function getUtf8ByteLength(value) {
	const text = _.toString(value || "");
	if (typeof TextEncoder !== "undefined") {
		try {
			return new TextEncoder().encode(text).length;
		} catch (_err) {
			// Fall through to browser-compatible fallback.
		}
	}
	try {
		return unescape(encodeURIComponent(text)).length;
	} catch (_err) {
		return text.length;
	}
}

function shouldCaptureS3SaveBatch(files = []) {
	return _.some(files, file => file && (file.activityId || file.saveArtifactLabel));
}

function notifySaveStatus(onStatus, message, detail = {}) {
	if (!_.isFunction(onStatus) || !_.isString(message) || message.trim() === "") {
		return;
	}

	try {
		onStatus(_.assign({}, detail, { message }));
	} catch (err) {
		console.warn("Unable to update save status", err);
	}
}

function formatSaveDuration(elapsedMs) {
	const safeElapsedMs = Math.max(0, Number(elapsedMs) || 0);
	if (safeElapsedMs < 1000) {
		return `${Math.round(safeElapsedMs)}ms`;
	}
	const elapsedSeconds = safeElapsedMs / 1000;
	if (elapsedSeconds < 10) {
		return `${elapsedSeconds.toFixed(1)}s`;
	}
	return `${Math.round(elapsedSeconds)}s`;
}

function recordSaveTimingEvent(eventType, phase, startedAt, detail = {}) {
	const elapsedMs = Math.max(0, Date.now() - startedAt);
	recordWebDiagnosticEvent(eventType, _.assign({}, detail, {
		phase,
		elapsedMs,
		elapsed: formatSaveDuration(elapsedMs)
	}));
	return elapsedMs;
}

function startLongRunningSaveStatus(onStatus, messageFactory, detail = {}, intervals = [15000, 30000, 60000, 120000, 180000, 240000, 300000]) {
	const startedAt = Date.now();
	const timers = intervals.map(delayMs => setTimeout(() => {
		const elapsedMs = Math.max(0, Date.now() - startedAt);
		const message = _.isFunction(messageFactory)
			? messageFactory(elapsedMs)
			: _.toString(messageFactory || "");
		const eventDetail = _.assign({}, detail, {
			elapsedMs,
			elapsed: formatSaveDuration(elapsedMs),
			thresholdMs: delayMs
		});
		notifySaveStatus(onStatus, message, eventDetail);
		recordWebDiagnosticEvent("authoringSaveLongRunningPhase", _.assign({}, eventDetail, { message }));
	}, delayMs));

	return () => {
		timers.forEach(timer => clearTimeout(timer));
		return Math.max(0, Date.now() - startedAt);
	};
}

function buildS3SaveBatchDiagnosticContext(bucketName, keyPrefix, files = [], saveAttemptId = "") {
	return {
		saveAttemptId,
		bucket: bucketName,
		defaultKeyPrefix: keyPrefix,
		fileCount: files.length,
		files: files.map(file => ({
			fileName: file.fileName || "",
			prefix: file.prefix || file.keyPrefix || keyPrefix || "",
			saveArtifactLabel: file.saveArtifactLabel || "",
			activityId: file.activityId || "",
			activityName: file.activityName || ""
		}))
	};
}

function buildS3SaveFileDiagnosticContext(bucketName, key, file = {}, body, fileCount, endpoint = {}, saveAttemptId = "") {
	return {
		saveAttemptId,
		operation: "putObject",
		bucket: bucketName,
		key,
		fileName: file.fileName || "",
		saveArtifactLabel: file.saveArtifactLabel || file.fileName || "activity JSON",
		activityId: file.activityId || "",
		activityName: file.activityName || "",
		bodyType: typeof body,
		bodyLength: _.isString(body) ? body.length : 0,
		bodyByteLength: _.isString(body) ? getUtf8ByteLength(body) : 0,
		fileCount,
		endpointHostname: _.get(endpoint, "hostname", ""),
		endpointProtocol: _.get(endpoint, "protocol", ""),
		endpointPort: _.get(endpoint, "port", "")
	};
}

function attachS3ResponseDiagnostics(err, response) {
	if (!_.isObject(err)) {
		return err;
	}

	const responseDiagnostics = extractS3ResponseDiagnosticContext(response);
	err.s3ResponseDiagnostics = _.assign({}, _.get(err, "s3ResponseDiagnostics", {}), responseDiagnostics);
	err.expectedDigest = err.expectedDigest || responseDiagnostics.expectedDigest || "";
	err.calculatedDigest = err.calculatedDigest || responseDiagnostics.calculatedDigest || "";
	err.requestId = err.requestId || responseDiagnostics.requestId || "";
	err.extendedRequestId = err.extendedRequestId || responseDiagnostics.extendedRequestId || "";
	return err;
}

function putObjectWithResponseDiagnostics(bucket, params) {
	const request = bucket.putObject(params);
	if (request && _.isFunction(request.on)) {
		request.on("extractError", (response) => {
			if (response && response.error) {
				attachS3ResponseDiagnostics(response.error, response);
			}
		});
	}

	return request.promise().catch((err) => {
		attachS3ResponseDiagnostics(err, request && request.response ? request.response : {});
		throw err;
	});
}

function annotateS3SaveError(err, context = {}) {
	const annotatedError = _.isObject(err) ? err : new Error(`${err}`);
	annotatedError.s3Operation = context.operation || "putObject";
	annotatedError.saveAttemptId = context.saveAttemptId || annotatedError.saveAttemptId || "";
	annotatedError.s3Bucket = context.bucket || "";
	annotatedError.s3Key = context.key || "";
	annotatedError.saveArtifactLabel = context.saveArtifactLabel || "activity JSON";
	annotatedError.activityId = context.activityId || "";
	annotatedError.activityName = context.activityName || "";
	annotatedError.fileName = context.fileName || "";
	annotatedError.bodyType = context.bodyType || "";
	annotatedError.bodyLength = context.bodyLength || "";
	annotatedError.bodyByteLength = context.bodyByteLength || "";
	annotatedError.fileCount = context.fileCount || "";
	annotatedError.s3EndpointHostname = context.endpointHostname || annotatedError.s3EndpointHostname || _.get(annotatedError, "s3ResponseDiagnostics.endpointHostname", "");
	annotatedError.s3EndpointProtocol = context.endpointProtocol || annotatedError.s3EndpointProtocol || _.get(annotatedError, "s3ResponseDiagnostics.endpointProtocol", "");
	annotatedError.s3EndpointPort = context.endpointPort || annotatedError.s3EndpointPort || _.get(annotatedError, "s3ResponseDiagnostics.endpointPort", "");
	annotatedError.retryAttempt = _.has(context, "retryAttempt") ? context.retryAttempt : _.get(annotatedError, "retryAttempt", 0);
	annotatedError.attemptNumber = _.has(context, "attemptNumber") ? context.attemptNumber : _.get(annotatedError, "attemptNumber", annotatedError.retryAttempt + 1);
	annotatedError.maxAttempts = context.maxAttempts || annotatedError.maxAttempts || "";
	annotatedError.s3UploadElapsedMs = context.uploadElapsedMs || annotatedError.s3UploadElapsedMs || "";
	annotatedError.s3BatchElapsedMs = context.batchElapsedMs || annotatedError.s3BatchElapsedMs || "";
	return annotatedError;
}

function buildSimulatedS3BadDigestError(context = {}) {
	const err = new Error("The Content-MD5 you specified did not match what we received.");
	err.name = "BadDigest";
	err.code = "BadDigest";
	err.statusCode = 400;
	err.status = 400;
	err.requestId = `simulated-${new Date().getTime()}`;
	err.extendedRequestId = "simulated-authoring-save-bad-digest";
	err.region = env.aws && env.aws.defaultRegion ? env.aws.defaultRegion : "";
	err.retryable = false;
	err.simulated = true;
	err.simulatedS3BadDigest = true;
	return annotateS3SaveError(err, context);
}

function buildS3ErrorDiagnosticContext(err) {
	const response = _.get(err, "s3ResponseDiagnostics", {});
	return {
		name: _.get(err, "name", ""),
		code: _.get(err, "code", ""),
		message: _.get(err, "message", ""),
		status: _.get(err, "status") || _.get(err, "statusCode") || "",
		requestId: _.get(err, "requestId") || _.get(err, "s3RequestId") || "",
		extendedRequestId: _.get(err, "extendedRequestId") || "",
		cfId: _.get(err, "cfId") || "",
		region: _.get(err, "region") || "",
		retryable: _.get(err, "retryable"),
		retryAttempt: _.get(err, "retryAttempt", 0),
		attemptNumber: _.get(err, "attemptNumber", _.get(err, "retryAttempt", 0) + 1),
		maxAttempts: _.get(err, "maxAttempts", ""),
		uploadElapsedMs: _.get(err, "s3UploadElapsedMs", ""),
		batchElapsedMs: _.get(err, "s3BatchElapsedMs", ""),
		expectedDigest: _.get(err, "expectedDigest") || response.expectedDigest || "",
		calculatedDigest: _.get(err, "calculatedDigest") || response.calculatedDigest || "",
		endpointHostname: _.get(err, "s3EndpointHostname") || response.endpointHostname || "",
		endpointProtocol: _.get(err, "s3EndpointProtocol") || response.endpointProtocol || "",
		endpointPort: _.get(err, "s3EndpointPort") || response.endpointPort || "",
		requestContentMd5: response.requestContentMd5 || "",
		requestContentSha256: response.requestContentSha256 || "",
		requestContentLength: response.requestContentLength || "",
		requestPath: response.requestPath || "",
		httpMethod: response.httpMethod || "",
		time: _.get(err, "time") ? `${_.get(err, "time")}` : "",
		response
	};
}

function isS3BadDigestSaveError(err) {
	const code = `${_.get(err, "code", "")}`.trim();
	const message = `${_.get(err, "message", "")}`.trim();
	return code === "BadDigest" || message.includes("Content-MD5") || message.includes("BadDigest");
}

function waitMs(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

function putObjectWithBadDigestRetry(bucket, params, diagnosticContext, maxRetries = 3, onStatus = null, options = {}) {
	const { simulateS3BadDigestFailure = false } = options || {};
	const attemptPut = (attempt) => {
		const attemptStartedAt = Date.now();
		const attemptNumber = attempt + 1;
		const maxAttempts = maxRetries + 1;
		recordWebDiagnosticEvent("authoringS3JsonPutObjectAttemptStarted", {
			save: diagnosticContext,
			attemptNumber,
			maxAttempts,
			startedAt: new Date(attemptStartedAt).toISOString()
		});
		const putObjectPromise = simulateS3BadDigestFailure
			? Promise.reject(buildSimulatedS3BadDigestError(_.assign({}, diagnosticContext, { retryAttempt: attempt, attemptNumber, maxAttempts })))
			: putObjectWithResponseDiagnostics(bucket, params);
		return putObjectPromise.then((result) => {
			const elapsedMs = Math.max(0, Date.now() - attemptStartedAt);
			recordWebDiagnosticEvent("authoringS3JsonPutObjectAttemptCompleted", {
				save: diagnosticContext,
				attemptNumber,
				maxAttempts,
				elapsedMs,
				elapsed: formatSaveDuration(elapsedMs)
			});
			recordWebDiagnosticNetworkEntry({
				type: "aws-sdk-s3",
				method: "PUT",
				url: `${diagnosticContext.endpointProtocol || "https:"}//${diagnosticContext.endpointHostname || "s3"}`,
				status: 200,
				ok: true,
				outcome: "completed",
				durationMs: elapsedMs,
				attemptNumber,
				maxAttempts,
				artifact: diagnosticContext.saveArtifactLabel,
				key: diagnosticContext.key
			});
			return result;
		}).catch((err) => {
			const elapsedMs = Math.max(0, Date.now() - attemptStartedAt);
			const annotatedError = annotateS3SaveError(err, _.assign({}, diagnosticContext, {
				retryAttempt: attempt,
				attemptNumber,
				maxAttempts,
				uploadElapsedMs: elapsedMs
			}));
			const errorContext = buildS3ErrorDiagnosticContext(annotatedError);
			recordWebDiagnosticEvent("authoringS3JsonPutObjectAttemptFailed", {
				save: diagnosticContext,
				attemptNumber,
				maxAttempts,
				elapsedMs,
				elapsed: formatSaveDuration(elapsedMs),
				error: errorContext
			});
			recordWebDiagnosticNetworkEntry({
				type: "aws-sdk-s3",
				method: errorContext.httpMethod || "PUT",
				url: `${errorContext.endpointProtocol || diagnosticContext.endpointProtocol || "https:"}//${errorContext.endpointHostname || diagnosticContext.endpointHostname || "s3"}`,
				status: errorContext.status || errorContext.response.httpStatus || 0,
				ok: false,
				outcome: "error",
				error: errorContext.code || errorContext.message || "S3 upload failed",
				durationMs: elapsedMs,
				attemptNumber,
				maxAttempts,
				artifact: diagnosticContext.saveArtifactLabel,
				key: diagnosticContext.key,
				requestId: errorContext.requestId
			});
			if (isS3BadDigestSaveError(annotatedError) && attempt < maxRetries) {
				const nextAttempt = attempt + 1;
				notifySaveStatus(
					onStatus,
					`Checksum mismatch while uploading ${diagnosticContext.saveArtifactLabel}. Retrying ${nextAttempt} of ${maxRetries}...`,
					{
						phase: "s3BadDigestRetry",
						artifact: diagnosticContext.saveArtifactLabel,
						attempt: nextAttempt,
						maxRetries,
						key: diagnosticContext.key
					}
				);
				recordWebDiagnosticEvent("authoringS3JsonPutObjectBadDigestRetry", {
					save: diagnosticContext,
					error: errorContext,
					nextAttempt
				});
				return waitMs(750).then(() => attemptPut(attempt + 1));
			}

			notifySaveStatus(onStatus, `Upload failed for ${diagnosticContext.saveArtifactLabel}.`, {
				phase: "s3UploadFailed",
				artifact: diagnosticContext.saveArtifactLabel,
				key: diagnosticContext.key
			});
			recordWebDiagnosticEvent("authoringS3JsonPutObjectFailed", {
				save: diagnosticContext,
				error: errorContext
			});
			throw annotatedError;
		});
	};

	return attemptPut(0);
}

export const PUBLIC_KEY_PREFIX = "public";
// const TIMER_TEMPLATES_FILE_NAME = "timerTemplates.json";

function stripPublishedSourceMetadataFromObject(value) {
	let normalizedValue = value;
	if (_.isString(normalizedValue)) {
		try {
			normalizedValue = JSON.parse(normalizedValue);
		} catch (err) {
			return value;
		}
	}

	if (!_.isPlainObject(normalizedValue)) {
		return normalizedValue;
	}

	const sanitized = _.omit(normalizedValue, PUBLISHED_SOURCE_METADATA_KEYS);
	return _.isEmpty(sanitized) ? {} : sanitized;
}

function stripPublishedSourceMetadataFromNode(node) {
	if (!_.isObject(node)) {
		return node;
	}

	if (_.has(node, "authorProperties")) {
		const sanitizedAuthorProperties = stripPublishedSourceMetadataFromObject(node.authorProperties);
		if (_.isPlainObject(sanitizedAuthorProperties) && _.isEmpty(sanitizedAuthorProperties)) {
			delete node.authorProperties;
		} else if (!_.isUndefined(sanitizedAuthorProperties)) {
			node.authorProperties = sanitizedAuthorProperties;
		}
	}

	const children = _.isArray(node.children) ? node.children : [];
	for (let i = 0; i < children.length; i += 1) {
		stripPublishedSourceMetadataFromNode(children[i]);
	}

	return node;
}

function stripPublishedSourceMetadataFromExternalResources(externalResources = []) {
	if (!_.isArray(externalResources)) {
		return externalResources;
	}

	return externalResources.map((resource) => {
		if (!_.isObject(resource)) {
			return resource;
		}

		const sanitizedResource = _.cloneDeep(resource);
		if (_.has(sanitizedResource, "metaData")) {
			sanitizedResource.metaData = stripPublishedSourceMetadataFromObject(sanitizedResource.metaData);
		}
		return sanitizedResource;
	});
}

function buildPublishedChecklistPayload(checklist) {
	if (!_.isObject(checklist)) {
		return checklist;
	}

	const publishedChecklist = _.cloneDeep(checklist);
	applyAdvanceOnAcknowledgeStrategyMigration(publishedChecklist);
	applyMoveForwardMigration(publishedChecklist);
	stripPublishedSourceMetadataFromNode(publishedChecklist);
	if (_.isArray(publishedChecklist.externalResources)) {
		publishedChecklist.externalResources = stripPublishedSourceMetadataFromExternalResources(publishedChecklist.externalResources);
	}
	return publishedChecklist;
}

export function createImportedActivityInventoryEntry(checklist) {
	return {
		id: checklist.id,
		orgId: getOrgId(),
		ownerIdentityId: getIdentityId(),
		name: checklist.name,
		description: checklist.description,
		cloned: checklist.cloned === true,
		genre: checklist.genre,
		tags: checklist.tags,
		contributors: checklist.hasOwnProperty("contributors") ? checklist.contributors : [{ name: state.get(["user", "name"]), username: state.get(["user", "username"]), nickname: state.get(["user", "nickname"]) }],
		publisher: checklist.publisher,
		shareCode: "",
		shareCodeReceived: "",
		version: "1.0",
		revision: 1,
		revisionTs: new Date().getTime(),
		visible: true,
		speedType: checklist.speedType ? checklist.speedType : "KIAS",
		...getActivityInventoryMediaFields(checklist),
		checklistId: checklist.checklistId ? checklist.checklistId : null,
		driveRootPath: checklist.driveRootPath ? checklist.driveRootPath : "",
		category: checklist.category ? checklist.category : "",
		trackData: checklist.trackData,
		externalResources: checklist.hasOwnProperty("externalResources") ? checklist.externalResources : [],
		owner: true
	};
}

export function normalizeImportedActivityForLocalOwnership(checklist, opts = {}) {
	if (!_.isObject(checklist)) {
		return checklist;
	}

	const { forceNewIdentity = false } = opts;

	const normalizedChecklist = _.cloneDeep(checklist);
	const currentActivities = _.isArray(state.get(["activities"])) ? state.get(["activities"]) : [];
	const currentIdentityId = getIdentityId();
	const currentContributor = {
		name: state.get(["user", "name"]),
		username: state.get(["user", "username"]),
		nickname: state.get(["user", "nickname"])
	};

	[
		"share",
		"sharedWithType",
		"authoringGranted",
		"shareCode",
		"shareCodeReceived",
		"privacy",
		"orgPrivacy",
		"workflowId",
		"workflowGuid",
		"currentWorkflowStageId",
		"currentWorkflowStageGuid",
		"workflowStageLock",
		"workflowStagePermissions",
		"participatesInWorkflow",
		"fetchPublication",
		"latestPublicationId",
		"publicationCompleted",
		"publicationVersion",
		"publicationRevision",
		"publicationApprovedForUse",
		"publicationApprovedForUseChangeDate",
		"publicationApprovedForUseChangeReason",
		"publicationReleaseNotes",
		"revisionTs",
		"orgId",
		"ownerIdentityId"
	].forEach((prop) => {
		if (normalizedChecklist.hasOwnProperty(prop)) {
			delete normalizedChecklist[prop];
		}
	});

	normalizedChecklist.identityId = currentIdentityId;
	normalizedChecklist.orgId = getOrgId();
	normalizedChecklist.ownerIdentityId = currentIdentityId;
	normalizedChecklist.owner = true;
	normalizedChecklist.publisher = "self";
	normalizedChecklist.visible = true;
	normalizedChecklist.hasShares = false;
	normalizedChecklist.contributors = [currentContributor];
	normalizedChecklist.baseIds = [];

	if (forceNewIdentity) {
		normalizedChecklist.id = generateUUID();
		normalizedChecklist.guid = generateUUID();
		return normalizedChecklist;
	}

	const importedGuid = _.trim(_.toString(normalizedChecklist.guid || ""));
	const hasRootGuidCollision = importedGuid !== "" && _.some(currentActivities, (activity) => {
		if (!activity || activity.id === normalizedChecklist.id) {
			return false;
		}

		return _.trim(_.toString(activity.guid || "")) === importedGuid;
	});

	if (importedGuid === "" || hasRootGuidCollision) {
		normalizedChecklist.guid = generateUUID();
	}

	return normalizedChecklist;
}

function getAssetsKeyFromUrl(assetUrl) {
	if (!assetUrl || assetUrl === "none") {
		return "";
	}

	try {
		const parsedUrl = new URL(assetUrl);
		const host = parsedUrl.hostname;
		const pathname = decodeDriveAssetUrlPath(parsedUrl.pathname.replace(/^\/+/, ""));

		if (!pathname) {
			return "";
		}

		if (host.includes("private-assets.ambifi.com")) {
			return `private/${pathname}`;
		}

		if (host.includes("public-assets.ambifi.com")) {
			return `public/${pathname}`;
		}

		return pathname;
	} catch (_err) {
		return "";
	}
}

function getSignedAssetUrl(assetUrl, expires = 600) {
	const key = getAssetsKeyFromUrl(assetUrl);

	if (!key) {
		return assetUrl;
	}

	const s3 = new AWS.S3({ useDualStack: true });
	return s3.getSignedUrl("getObject", {
		Bucket: env.s3.assetsBucket,
		Key: key,
		Expires: expires
	});
}

function decodeUrlPathPart(part = "") {
	let decoded = _.toString(part || "");
	for (let index = 0; index < 4; index += 1) {
		try {
			const next = decodeURIComponent(decoded);
			if (next === decoded) {
				break;
			}
			decoded = next;
		} catch (_err) {
			break;
		}
	}
	return decoded;
}

function decodeDriveAssetUrlPath(path = "") {
	return _.toString(path || "")
		.split("/")
		.map(part => decodeUrlPathPart(part))
		.join("/");
}

function encodeS3CopySourceKey(sourceKey = "") {
	return _.toString(sourceKey || "")
		.split("/")
		.map(part => encodeURIComponent(part))
		.join("/");
}

function getAmbifiAssetKeyFromValue(assetValue) {
	if (!_.isString(assetValue) || assetValue === "none") {
		return "";
	}

	const trimmedValue = assetValue.trim();
	if (!trimmedValue) {
		return "";
	}

	if (trimmedValue.startsWith("private/") || trimmedValue.startsWith("public/")) {
		return trimmedValue;
	}

	try {
		const parsedUrl = new URL(trimmedValue);
		const host = _.toString(parsedUrl.hostname).toLowerCase();
		const pathname = decodeDriveAssetUrlPath(_.toString(parsedUrl.pathname).replace(/^\/+/, ""));

		if (!pathname) {
			return "";
		}

		if (host.includes("private-assets.ambifi.com")) {
			return `private/${pathname}`;
		}

		if (host.includes("public-assets.ambifi.com")) {
			return `public/${pathname}`;
		}

		if (host.includes(env.s3.assetsBucket) || (host.includes("amazonaws.com") && (pathname.startsWith("private/") || pathname.startsWith("public/")))) {
			return pathname;
		}
		if (host.includes("amazonaws.com") && _.isString(env.s3.assetsBucket) && env.s3.assetsBucket !== "") {
			const bucketPrefix = `${env.s3.assetsBucket}/`;
			if (pathname.startsWith(bucketPrefix)) {
				const key = pathname.substring(bucketPrefix.length);
				if (key.startsWith("private/") || key.startsWith("public/")) {
					return key;
				}
			}
		}

		return "";
	} catch (_err) {
		return "";
	}
}

export function getSignedAmbifiAssetUrl(assetValue, expires = 600) {
	const key = getAmbifiAssetKeyFromValue(assetValue);

	if (!key) {
		return assetValue;
	}

	const s3 = new AWS.S3({ useDualStack: true });
	return s3.getSignedUrl("getObject", {
		Bucket: env.s3.assetsBucket,
		Key: key,
		Expires: expires
	});
}

export function getSignedDriveResourceUrl(driveResource, expires = 600, options = {}) {
	if (!driveResource || !driveResource.path) {
		return "";
	}

	const normalizedPath = _.toString(driveResource.path).replace(/^\/+/, "");
	if (!normalizedPath) {
		return "";
	}

	const {
		responseContentDisposition,
		responseContentType
	} = options || {};
	const params = {
		Bucket: env.s3.assetsBucket,
		Key: normalizedPath,
		Expires: expires
	};

	if (_.toString(responseContentDisposition).trim()) {
		params.ResponseContentDisposition = _.toString(responseContentDisposition).trim();
	}
	if (_.toString(responseContentType).trim()) {
		params.ResponseContentType = _.toString(responseContentType).trim();
	}

	const s3 = new AWS.S3({ useDualStack: true });
	return s3.getSignedUrl("getObject", params);
}

export function getSignedContentObjectUrl(bucketName, key, expires = 600) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			try {
				const normalizedBucketName = _.toString(bucketName || env.s3.contentBucket).trim() || env.s3.contentBucket;
				const normalizedKey = _.toString(key || "").trim();
				if (!normalizedKey) {
					resolve("");
					return;
				}

				const s3 = new AWS.S3({ useDualStack: true });
				resolve(s3.getSignedUrl("getObject", {
					Bucket: normalizedBucketName,
					Key: normalizedKey,
					Expires: expires
				}));
			} catch (err) {
				reject(err);
			}
		}).catch(reject);
	});
}

function resolvePrintableMediaValue(value, activity, driveResourcesByGuid = {}) {
	if (!value) {
		return value;
	}

	if (_.isString(value)) {
		return getSignedAmbifiAssetUrl(value);
	}

	if (!_.isPlainObject(value)) {
		return value;
	}

	if (value.type === "resource/ref" && value.refId) {
		const externalResource = _.find(_.get(activity, "externalResources", []), { id: value.refId });
		if (!externalResource || !externalResource.guid) {
			return "";
		}

		const driveResource = driveResourcesByGuid[externalResource.guid];
		return getSignedDriveResourceUrl(driveResource);
	}

	if (value.type === "resource/external/drive" && value.guid) {
		return getSignedDriveResourceUrl(driveResourcesByGuid[value.guid] || value);
	}

	return value;
}

function recursePrepareActivityForSignedPrintUrls(node, activity, driveResourcesByGuid = {}) {
	if (!_.isPlainObject(node)) {
		return;
	}

	PRINT_SIGNABLE_MEDIA_PROPS.forEach((propName) => {
		if (node[propName]) {
			node[propName] = resolvePrintableMediaValue(node[propName], activity, driveResourcesByGuid);
		}
	});

	if (_.isArray(node.children)) {
		node.children.forEach((child) => {
			recursePrepareActivityForSignedPrintUrls(child, activity, driveResourcesByGuid);
		});
	}
}

export async function prepareActivityForDirectSignedPrintUrls(activity) {
	const driveResourcesByGuid = await getDriveForActivity(activity);
	recursePrepareActivityForSignedPrintUrls(activity, activity, driveResourcesByGuid);
	return activity;
}

function getDocumentPrintName(document = {}, checklist = {}) {
	return _.toString(_.get(document, "name") || _.get(checklist, "name") || _.get(document, "id") || _.get(checklist, "id") || "activity");
}

function getDocumentPrintKeyPrefix(document = {}) {
	return getKeyPrefix(state.select(["user", "identityId"]).get(), document);
}

function getChecklistStandardTemplateId(checklist, columns = false) {
	const publisher = _.toString(_.get(checklist, "publisher", "")).toLowerCase();

	if (columns) {
		if (isChecklistItems(checklist)) {
			return "ambifi-items-columns";
		}
		if (isChecklistSections(checklist)) {
			return "ambifi-sections-columns";
		}
		if (isChecklistLists(checklist)) {
			return "ambifi-lists-columns";
		}
		return "";
	}

	if (isChecklistItems(checklist)) {
		return publisher === "checkmate" ? "miracheck-items-checkmate" : "ambifi-items";
	}
	if (isChecklistSections(checklist)) {
		return publisher === "checkmate" ? "miracheck-sections-checkmate" : "ambifi-sections";
	}
	if (isChecklistLists(checklist)) {
		return publisher === "checkmate" ? "miracheck-lists-checkmate" : "ambifi-lists";
	}

	return "";
}

function getChecklistShowModeTemplateId(checklist) {
	if (getOrgId() === "641d5a7f-4a87-11e9-a392-061714f61e3e" && isChecklistItems(checklist)) {
		return "chop-orientation";
	}

	if (getOrgId() === "57c412f1-83a5-11e8-a392-061714f61e3e" || getOrgId() === "421433d6-c0d4-11e9-b530-066917b38554") {
		if (isChecklistItems(checklist)) {
			return "ambifi-items-orientation";
		}
		if (isChecklistSections(checklist)) {
			return "ambifi-sections-orientation";
		}
		if (isChecklistLists(checklist)) {
			return "ambifi-lists-orientation";
		}
		return "";
	}

	if (isChecklistItems(checklist)) {
		return "ambifi-items-show-mode";
	}
	if (isChecklistSections(checklist)) {
		return "ambifi-sections-show-mode";
	}
	if (isChecklistLists(checklist)) {
		return "ambifi-lists-show-mode";
	}

	return "";
}

async function getActivityForPrint(document) {
	await refreshCredentials();

	const keyPrefix = getDocumentPrintKeyPrefix(document);
	const bucket = new AWS.S3({
		useDualStack: true,
		params: {
			Bucket: env.s3.contentBucket,
			ResponseContentType: "application/json",
			ResponseCacheControl: "no-cache"
		}
	});

	return new Promise((resolve, reject) => {
		bucket.getObject({ Key: `${keyPrefix}/${document.id}.json` }, (err, data) => {
			if (err) {
				reject(err);
				return;
			}

			try {
				resolve(JSON.parse(data.Body.toString()));
			} catch (parseErr) {
				reject(parseErr);
			}
		});
	});
}

function prepareChecklistForPrintRender(checklist) {
	if (_.isArray(_.get(checklist, "children"))) {
		recurseReplaceSpeeds(checklist.children);
		recurseConvertChecklistToMarkdown(checklist.children, true, { checklist });
	}

	return checklist;
}

export async function printActivityByType(document, opts = {}) {
	const {
		reportType = "aiReport",
		manageSpinner = false,
		preview = false,
		preferredPreviewHost = ""
	} = opts || {};
	const printConfig = {
		manageSpinner,
		preview
	};

	if (preferredPreviewHost) {
		printConfig.preferredPreviewHost = preferredPreviewHost;
	}

	let checklist = await getActivityForPrint(document);
	checklist = await prepareActivityForDirectSignedPrintUrls(checklist);
	prepareChecklistForPrintRender(checklist);

	const activityName = getDocumentPrintName(document, checklist);

	switch (reportType) {
		case "standard": {
			const templateId = getChecklistStandardTemplateId(checklist, false);
			if (!templateId) {
				throw new Error("Unable to determine the standard print template for this activity.");
			}
			await printTemplate(activityName, checklist, templateId, printConfig);
			return;
		}
		case "columns": {
			const templateId = getChecklistStandardTemplateId(checklist, true);
			if (!templateId) {
				throw new Error("Unable to determine the columns print template for this activity.");
			}
			await printTemplate(activityName, checklist, templateId, printConfig);
			return;
		}
		case "withMedia": {
			const templateId = getChecklistShowModeTemplateId(checklist);
			if (!templateId) {
				throw new Error("Unable to determine the with-media print template for this activity.");
			}
			await printTemplate(activityName, checklist, templateId, printConfig);
			return;
		}
		case "customPortrait":
		case "customLandscape": {
			const template = _.toString(_.get(checklist, "printTemplate", "")).trim();
			if (!template) {
				throw new Error("This activity does not have a custom print template.");
			}
			removeAlternatives(checklist);
			await printTemplateWithContent(activityName, checklist, template, reportType === "customLandscape" ? "landscape" : "portrait", printConfig);
			return;
		}
		case "aiReport":
			await printTemplate(activityName, checklist, "ambifi-ai-report", printConfig);
			return;
		default:
			throw new Error(`Unsupported bulk print report type: ${reportType}`);
	}
}

function setGenericPrintSpinnerMessage(message) {
	state.set(["appState", "documents", "spinnerMessage"], message);
	state.set(["appState", "editor", "spinnerMessage"], message);
}

function setGenericPrintSpinnerVisible(show) {
	state.set(["appState", "documents", "showSpinner"], show);
	state.set(["appState", "status", "showSpinner"], show);
	state.set(["appState", "editor", "showSpinner"], show);
}

function showGenericPrintSpinner(message = "Preparing print...") {
	setGenericPrintSpinnerMessage(message);
	setGenericPrintSpinnerVisible(true);
}

function hideGenericPrintSpinner() {
	setGenericPrintSpinnerMessage("");
	setGenericPrintSpinnerVisible(false);
}

export function promoteChecklist(keyPrefix, srcChecklistId) {
	refreshCredentials().then(() => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${srcChecklistId}.json` }, (_err2, data) => {
			if (_err2) {
				alert(_err2, _err2.stack);
			} else {
				const checklist = JSON.parse(data.Body.toString());
				addChecklistForPromote(checklist);
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("Add failed", err);
	});
}

function addChecklistForPromote(checklist) {
	const baseId = checklist.id;
	checklist.id = generateUUID();
	if (checklist.hasOwnProperty("baseIds")) {
		checklist.baseIds.push(baseId);
	} else {
		const baseIds = [];
		baseIds.push(baseId);
		checklist.baseIds = baseIds;
	}
	// Need to think through all scenarios...for now allow people to delete anything
	checklist.cloned = false;

	const newDocument = {
		id: checklist.id,
		orgId: getOrgId(),
		ownerIdentityId: getIdentityId(),
		name: checklist.name,
		description: checklist.description,
		cloned: false,
		genre: checklist.genre,
		tags: checklist.tags,
		contributors: checklist.hasOwnProperty("contributors") ? checklist.contributors : [{ name: state.get(["user", "name"]), username: state.get(["user", "username"]), nickname: state.get("user", "nickname") }],
		publisher: checklist.publisher,
		version: "1.0",
		revision: 1,
		revisionTs: new Date().getTime(),
		visible: true,
		speedType: "KIAS",
	};

	updateChecklistsAndPushToS3(checklist, newDocument);

	showSuccess("Added", "This activity has been successfuly added to My Activities.");
}

export function getHistory(tree, identityId) {
	refreshCredentials().then(async () => {

		const checklistHistory = [];

		const keyPrefix = getKeyPrefix(identityId);

		const s3 = new AWS.S3({ useDualStack: true });

		const params = {
			Bucket: env.s3.contentBucket,
			Delimiter: "/",
			Prefix: `${keyPrefix}/`,
		};

		const listFoldersData = await s3.listObjects(params).promise();

		const folders = listFoldersData.CommonPrefixes;
		for (let i = 0; i < folders.length; i++) {
			const folder = folders[i];
			// Ignore assets folders
			if (!folder.Prefix.includes("/assets/") && !folder.Prefix.includes("/userAssets/")) {
				params.Prefix = folder.Prefix;

				const checklistId = folder.Prefix.split("/")[1];
				// console.log("Checklist ID: " + checklistId);

				const checklistHistoryItem = {
					type: "checklistHistory",
					id: checklistId,
					name: "",
					description: "",
					instances: [],
				};

				checklistHistory.push(checklistHistoryItem);

				const filesData = await s3.listObjects(params).promise();

				// console.log(filesData);
				const files = filesData.Contents;
				for (let j = 0; j < files.length; j++) {
					const file = files[j].Key;

					// Need to get checklist instance using async await
					// console.log("File: " + file);
					const data = await s3.getObject({ Bucket: env.s3.contentBucket, Key: file }).promise();

					const checklistInstance = JSON.parse(data.Body.toString());
					checklistHistoryItem.name = checklistInstance.name;
					checklistHistoryItem.description = checklistInstance.description;
					checklistHistoryItem.instances.push(checklistInstance);
				}

			}
		}

		tree.set(["checklistHistory"], checklistHistory);
	}).catch((err) => {
		console.error(err);
		showError2("Get History", err);
	});
}

// export function updateMp3Metadata(prefix) {
// 	return new Promise((resolve, reject) => {
// 		refreshCredentials().then(() => {
// 			recursiveListObjectsUpdateMp3Metadata(env.s3.assetsBucket, prefix, (err, data) => {
// 				if (err) {
// 					reject(err);
// 				} else {
// 					data.forEach(async (fileObj) => {
// 						console.log("!@#$% MP3 METADATA", fileObj.Key);
// 						const s3 = new AWS.S3({ useDualStack: true });
// 						await s3.copyObject({ MetadataDirective: "REPLACE", CopySource: `${env.s3.assetsBucket}/` + fileObj.Key, Bucket: env.s3.contentBucket, Key: fileObj.Key, ContentType: 'audio/mpeg' }).promise();
// 					})

// 					resolve(data);
// 				}
// 			});
// 		}).catch((err) => {
// 			reject(err);
// 		});
// 	});
// }

// function recursiveListObjectsUpdateMp3Metadata(bucketName, prefix = null, cb = () => { }, marker = null, files = []) {
// 	const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
// 	const params = {
// 		Bucket: bucketName
// 	};

// 	// are we paging from a specific point?
// 	if (marker) {
// 		params.Marker = marker;
// 	}

// 	if (prefix) {
// 		params.Prefix = prefix;
// 	}

// 	bucket.listObjects(params, function (err, data) {
// 		if (err) {
// 			return cb(err);
// 		}

// 		// concat the list of files into our collection
// 		files = files.concat(data.Contents);

// 		// are we paging?
// 		if (data.IsTruncated) {
// 			let length = data.Contents.length;
// 			let marker = data.Contents[length - 1].Key;
// 			// recursion!
// 			recursiveListObjectsUpdateMp3Metadata(bucketName, prefix, cb, marker, files);
// 		} else {
// 			cb(undefined, files);
// 		}
// 	});
// }

// export function updateMp3Metadata2(prefix) {
// 	refreshCredentials().then(async ({ cognitoUser }) => {
// 		let s3 = new AWS.S3({ useDualStack: true });

// 		let params = {
// 			Bucket: env.s3.assetsBucket,
// 			Delimiter: "/",
// 			Prefix: prefix
// 		};

// 		let listFoldersData = await s3.listObjects(params).promise();

// 		let folders = listFoldersData.CommonPrefixes;
// 		for (let i = 0; i < folders.length; i++) {
// 			let folder = folders[i];

// 			params.Prefix = folder.Prefix;

// 			let filesData = await s3.listObjects(params).promise();

// 			let files = filesData.Contents;
// 			for (let j = 0; j < files.length; j++) {
// 				let file = files[j].Key;

// 				if (file.toLowerCase().endsWith(".mp3")) {
// 					console.log("!@#$% COPY", `${env.s3.assetsBucket}/` + file);
// 					// await s3.copyObject({ MetadataDirective: "REPLACE", CopySource: `${env.s3.assetsBucket}/` + file, Bucket: env.s3.contentBucket, Key: file, ContentType: 'audio/mpeg' }).promise();
// 				}
// 			}
// 		}
// 	}).catch((err) => {
// 		console.error(err);
// 		showError2("History", err);
// 	});
// }

export function touchHistoryFiles(identityId) {
	refreshCredentials().then(async ({ cognitoUser }) => {
		let keyPrefix = getKeyPrefix(identityId);

		let s3 = new AWS.S3({ useDualStack: true });

		let params = {
			Bucket: env.s3.contentBucket,
			Delimiter: "/",
			Prefix: keyPrefix + "/"
		};

		let listFoldersData = await s3.listObjects(params).promise();

		let folders = listFoldersData.CommonPrefixes;
		for (let i = 0; i < folders.length; i++) {
			let folder = folders[i];
			// Ignore assets folders
			if (!folder.Prefix.includes("/assets/") && !folder.Prefix.includes("/userAssets/")) {
				params.Prefix = folder.Prefix;

				let filesData = await s3.listObjects(params).promise();

				let files = filesData.Contents;
				for (let j = 0; j < files.length; j++) {
					let file = files[j].Key;

					// Need to get checklist instance using async await
					console.log("File: " + file);

					await s3.copyObject({ MetadataDirective: "REPLACE", CopySource: `${env.s3.contentBucket}/${encodeS3CopySourceKey(file)}`, Bucket: env.s3.contentBucket, Key: file }).promise();
				}

			}
		}

		updateAttribute(cognitoUser, "custom:historyUpdated", "true");
	}).catch((err) => {
		console.error(err);
		showError2("History", err);
	});
}

export function uploadFileToS3(bucket, keyPrefix, file, emptyBody = false, ignoreFileName = false, overrides = {}) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			// Instantiate aws sdk service objects now that the credentials have been updated.
			let fileName = (overrides.fileName) ? overrides.fileName : (file && file.name) ? file.name : "";

			if (overrides.extension) {
				let ext = utils.getFileNameExtension(fileName);
				fileName = fileName.replace(`.${ext}`, `.${overrides.extension}`);
			}

			const _bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucket } });
			const params = { Key: `${keyPrefix}${file && fileName && !ignoreFileName ? `/${fixFileNameForS3(fileName)}` : ""}` };
			if (!emptyBody) {
				params.ContentType = file.type;
				params.Body = file;
			} else {
				// params.Body = "Empty";
				params.ContentLength = 0;
				params.Body = "";
			}
			_bucket.upload(params, (err) => {
				if (err) {
					reject(err);
				} else {
					resolve();
				}
			}).on("httpUploadProgress", function (evt) {
				const loaded = Number(evt.loaded) || 0;
				const total = Number(evt.total) || 0;
				const progressPercent = total > 0 ? parseInt((loaded * 100) / total, 10) : 0;
				const normalizedFileName = fixFileNameForS3(fileName);

				if (typeof overrides.onUploadProgress === "function") {
					try {
						overrides.onUploadProgress({
							loaded,
							total,
							progressPercent,
							fileName: normalizedFileName,
							key: params.Key
						});
					} catch (progressError) {
						console.warn("Unable to update upload progress", progressError);
					}
				}

				if (overrides.suppressDriveUploadProgress === true) {
					return;
				}

				if (total > 0) {
					state.set(["drive", "showSpinner", "progressPercent"], progressPercent);
				}
				state.set(["drive", "showSpinner", "progressMessage"], normalizedFileName);
			});
		}).catch((err) => {
			console.error(err);
			showError2("Failed to obtain session to upload file to S3", err);
			reject(err);
		});
	});

}


export function uploadFilesToS3(bucketName, files) {
	refreshCredentials().then(() => {

		const keyPrefix = `${getKeyPrefix(state.select(["user", "identityId"]).get())}/assets`;

		// Instantiate aws sdk service objects now that the credentials have been updated.
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });

		for (let i = 0; i < files.length; i++) {
			const file = files[i];
			if (file) {
				// get file contents in memory
				const reader = new FileReader();
				reader.readAsText(file, "UTF-8");
				reader.onload = (evt) => {
					const csvContent = evt.target.result;

					const event = {
						csvContent,
						name: file.name.split(".")[0],
						checklistId: generateUUID(),
					};

					console.log(csvContent);
					// invoke lambda to do import
					const lambda = new AWS.Lambda({ region: env.aws.defaultRegion, apiVersion: "2015-03-31" });

					const params = {
						FunctionName: env.lambda.importCsvFunction,
						InvocationType: "RequestResponse",
						LogType: "None",
						Payload: JSON.stringify(event),
					};

					lambda.invoke(params, (error, data) => {
						if (error) {
							alert(error);
						} else {
							console.log(data.Payload);
							const checklist = JSON.parse(data.Payload);

							checklist.contributors = [{ name: state.get("user", "name"), username: state.get("user", "username"), nickname: state.get("user", "nickname") }];

							// Upload new file
							importChecklistFromCsv(checklist);
						}
					});
				};
				reader.onerror = () => {
					alert("Error reading file");
				};

				const ts = Date.now();

				// Upload to S3 and S3 triggers conversion
				const params = { Key: `${keyPrefix}/${ts}-${file.name}`, ContentType: file.type, Body: file };
				bucket.upload(params, (err) => {
					// Successfully have file on S3
					const result = err ? "ERROR!" : "SAVED.";
					console.log(result);
				});
			}
		}

	}).catch((err) => {
		console.error(err);
		showError2("Upload file to S3 failed", err);
	});
}


export function uploadFilesFromContentReviewToS3(bucketName, files, srcFormat, options = {}) {
	const suppressSuccessAlert = options.suppressSuccessAlert === true;
	const templateJson = options.templateJson;
	const makeCheckboxes = options.makeCheckboxes === true;

	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			state.set(["import", "showSpinner"], true);

			const identityPrefix = getKeyPrefix(state.get(["user", "identityId"]));
			const keyPrefix = `${getKeyPrefix(state.select(["user", "identityId"]).get())}/assets`;

			// Instantiate aws sdk service objects now that the credentials have been updated.
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });

			const ts = Date.now();
			const file = files[0];

			if (file && file.name) {
				const params = { Key: `${keyPrefix}/${ts}-${file.name}`, ContentType: file.type, Body: file };
				bucket.upload(params, (err) => {
					// Successfully have file on S3
					if (err) {
						state.set(["import", "showSpinner"], false);

						showError2("Upload file to S3 failed", err);
						reject(err);
					} else {
						const importFilePath = `${keyPrefix}/${ts}-${file.name}`;

						if (shouldUseContentReviewImportCapability(srcFormat)) {
							const endpoint = _.get(
								env,
								["apiGateway", "endpoints", "user", "contentReviewImportCapability"]
							);
							const jwtToken = getJwtToken();
							if (!endpoint || !jwtToken) {
								const configurationError = new Error(
									"Authenticated content-review import is not available for this session."
								);
								state.set(["import", "showSpinner"], false);
								showError2("Content import failed", configurationError);
								reject(configurationError);
								return;
							}

							request.post(`${env.apiGateway.baseUrl}${endpoint}`)
								.set({ Authorization: jwtToken, "Content-Type": "application/json" })
								.send(buildContentReviewV2ImportRequest(importFilePath, srcFormat))
								.then((response) => {
									const authorization = response && response.body;
									if (!isValidContentReviewV2ImportAuthorization(authorization)) {
										const authorizationError = new Error(
											_.get(authorization, "message")
											|| "The content import authorization response was invalid."
										);
										state.set(["import", "showSpinner"], false);
										showError2("Content import failed", authorizationError);
										reject(authorizationError);
										return;
									}

									const lambda = new AWS.Lambda({
										region: env.aws.defaultRegion,
										apiVersion: "2015-03-31"
									});
									const invokeParams = {
										FunctionName: env.lambda.importFunction,
										InvocationType: "RequestResponse",
										LogType: "None",
										Payload: JSON.stringify(
											buildAuthorizedContentReviewV2LambdaEvent(authorization)
										)
									};

									lambda.invoke(invokeParams, (error, data) => {
										state.set(["import", "showSpinner"], false);

										if (error) {
											showError2("Content import failed", error);
											reject(error);
											return;
										}

										let payload = null;
										try {
											if (data && data.Payload) {
												payload = typeof data.Payload === "string"
													? JSON.parse(data.Payload)
													: data.Payload;
												if (typeof payload === "string") {
													payload = JSON.parse(payload);
												}
											}
										} catch (parseError) {
											const importError = new Error("The content import returned an invalid response.");
											showError2("Content import failed", importError);
											reject(importError);
											return;
										}

										const payloadError = payload && (
											payload.error
											|| payload.errorMessage
											|| (payload.success === false && payload.message)
										);
										if ((data && data.FunctionError) || payloadError) {
											const payloadErrorMessage = _.isString(payloadError)
												? payloadError
												: _.get(payloadError, "message", "");
											const importError = new Error(
												payloadErrorMessage || "The content import Lambda failed."
											);
											showError2("Content import failed", importError);
											reject(importError);
											return;
										}

										if (!suppressSuccessAlert) {
											alert("The content has been successfully imported.");
										}
										resolve(payload);
									});
								})
								.catch((error) => {
									state.set(["import", "showSpinner"], false);
									const responseMessage = _.get(error, "response.body.message")
										|| _.get(error, "response.body.error")
										|| _.get(error, "message");
									const importError = new Error(responseMessage || "The content import failed.");
									showError2("Content import failed", importError);
									reject(importError);
								});
							return;
						}

						invokeLegacyContentReviewImport();

						// Kept local so the legacy callback flow remains unchanged.
						// eslint-disable-next-line no-inner-declarations
						function invokeLegacyContentReviewImport() {
							const event = {
								identityPrefix: identityPrefix,
								importFilePath,
								srcFormat: srcFormat,
								destFormat: "json",
								templateJson: templateJson || undefined,
								makeCheckboxes
							};

							const lambda = new AWS.Lambda({ region: env.aws.defaultRegion, apiVersion: "2015-03-31" });

							const params = {
								FunctionName: env.lambda.importFunction,
								InvocationType: "RequestResponse",
								LogType: "None",
								Payload: JSON.stringify(event),
							};

							lambda.invoke(params, (error, data) => {
								state.set(["import", "showSpinner"], false);

								if (error) {
									alert(error);
									reject(error);
								} else {
									let payload = null;
									try {
										if (data && data.Payload) {
											let raw = data.Payload;
											if (typeof raw === "string") {
												payload = JSON.parse(raw);
												// In case the payload is double-encoded
												if (typeof payload === "string") {
													try {
														payload = JSON.parse(payload);
													} catch (e) {
														// ignore
													}
												}
											} else {
												payload = raw;
											}
										}
									} catch (e) {
										// ignore parse error, continue with null payload
									}

									const payloadError = payload && (payload.error || payload.errorMessage);
									if ((data && data.FunctionError) || payloadError) {
										const payloadErrorMessage = _.isString(payloadError)
											? payloadError
											: _.get(payloadError, "message", "");
										const importError = new Error(payloadErrorMessage || "The content import Lambda failed.");
										showError2("Content import failed", importError);
										reject(importError);
										return;
									}

									if (!suppressSuccessAlert && srcFormat !== "docxActivity") {
										alert("The content has been successfully imported.");
									}
									resolve(payload);
								}
							});
						}
					}
				});
			} else {
				state.set(["import", "showSpinner"], false);

				const err = new Error("There was an unknown error uploading a file to S3");
				showError2(err.message);
				reject(err);
			}
		}).catch((err) => {
			state.set(["import", "showSpinner"], false);
			reject(err);
		});
	});
}


export function uploadFilesFromOrgImportToS3(bucketName, files, method) {
	refreshCredentials().then(() => {
		state.set(["import", "showSpinner"], true);

		const keyPrefix = `${getKeyPrefix(state.select(["user", "identityId"]).get())}/assets`;

		// Instantiate aws sdk service objects now that the credentials have been updated.
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });

		const ts = Date.now();
		const file = files[0];

		if (file && file.name) {
			const params = { Key: `${keyPrefix}/${ts}-${file.name}`, ContentType: file.type, Body: file };
			bucket.upload(params, (err) => {
				// Successfully have file on S3
				if (err) {
					state.set(["import", "showSpinner"], false);

					showError2("Upload file to S3 failed", err);
				} else {
					const event = {
						method: method,
						orgId: getOrgId(),
						importFilePath: `${keyPrefix}/${ts}-${file.name}`
					};

					const lambda = new AWS.Lambda({ region: env.aws.defaultRegion, apiVersion: "2015-03-31" });

					const params = {
						FunctionName: env.lambda.importFunctionForOrg,
						InvocationType: "RequestResponse",
						LogType: "None",
						Payload: JSON.stringify(event),
					};

					lambda.invoke(params, (error) => {
						state.set(["import", "showSpinner"], false);

						if (error) {
							alert(error);
						} else {

							// console.log(data.Payload);

							// const convertedJson = JSON.parse(data.Payload);

							alert("The content has been successfully imported.");
							// alert(JSON.stringify(convertedJson, null, 3));
						}
					});
				}
			});
		} else {
			state.set(["import", "showSpinner"], false);

			showError2("There was an unknown error uploading a file to S3");
		}
	});
}

export async function getStatusQueries(identityId) {
	return new Promise(async (resolve, reject) => {
		try {
			const event = {
				method: "getStatusQueries",
				identityId
			};

			const lambda = new AWS.Lambda({ region: env.aws.defaultRegion, apiVersion: "2015-03-31" });

			console.log("*** GET STATUS QUERIES FUNCTION", env.lambda);

			const params = {
				FunctionName: env.lambda.getStatusQueries,
				InvocationType: "RequestResponse",
				LogType: "None",
				Payload: JSON.stringify(event),
			};

			lambda.invoke(params, (error, data) => {
				if (error) {
					alert(error);
					reject(error);
				} else {
					resolve(JSON.parse(data.Payload));
				}
			});
		} catch (err) {
			reject(err);
		}
	});
}

export async function saveStatusQuery(identityId, queryName, searchState) {
	return new Promise(async (resolve, reject) => {
		try {
			const event = {
				method: "saveStatusQuery",
				identityId,
				queryName,
				searchState
			};

			const lambda = new AWS.Lambda({ region: env.aws.defaultRegion, apiVersion: "2015-03-31" });

			console.log("*** SAVE STATUS QUERY FUNCTION", env.lambda);

			const params = {
				FunctionName: env.lambda.saveStatusQuery,
				InvocationType: "RequestResponse",
				LogType: "None",
				Payload: JSON.stringify(event),
			};

			lambda.invoke(params, (error, data) => {
				if (error) {
					alert(error);
					reject(error);
				} else {
					resolve(JSON.parse(data.Payload));
				}
			});
		} catch (err) {
			reject(err);
		}
	});
}

export async function deleteStatusQuery(identityId, queryId) {
	return new Promise(async (resolve, reject) => {
		try {
			const event = {
				method: "deleteStatusQuery",
				identityId,
				queryId
			};

			const lambda = new AWS.Lambda({ region: env.aws.defaultRegion, apiVersion: "2015-03-31" });

			console.log("*** DELETE STATUS QUERY FUNCTION", env.lambda);

			const params = {
				FunctionName: env.lambda.deleteStatusQuery,
				InvocationType: "RequestResponse",
				LogType: "None",
				Payload: JSON.stringify(event),
			};

			lambda.invoke(params, (error, data) => {
				if (error) {
					alert(error);
					reject(error);
				} else {
					resolve(JSON.parse(data.Payload));
				}
			});
		} catch (err) {
			reject(err);
		}
	});
}

const waitForTries = {};

export function waitForKeyExists(Bucket, Key) {
	return new Promise(async (resolve, reject) => {
		if (!waitForTries[Key]) {
			waitForTries[Key] = 0;
		}

		let result = null;
		let err = null;

		while (waitForTries[Key] <= 6 && result === null) {
			err = null;
			waitForTries[Key]++;
			console.log("Upload polling try", waitForTries[Key]);
			try {
				result = await doWaitForExists(Bucket, Key);
			} catch (_err) {
				console.warn(_err);
				err = _err;
			}
		}
		delete waitForTries[Key];
		if (!result) {
			reject(err);
		} else {
			resolve(result);
		}
	});
}

function doWaitForExists(Bucket, Key) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const s3 = new AWS.S3({ useDualStack: true });
			let params = {
				Bucket,
				Key
			};
			s3.waitFor("objectExists", params, (err, data) => {
				if (err) {
					reject(err);
				} else {
					resolve(data);
				}
			});
		});
	});
}

export function uploadMediaFileToS3(bucketName, file, fileName, type) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const keyPrefix = type;

			// Instantiate aws sdk service objects now that the credentials have been updated.
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });

			// var ts = Date.now();

			// Upload to S3 and S3 triggers conversion
			const params = { Key: `${keyPrefix}/${fileName}`, ContentType: file.type, Body: file };
			bucket.upload(params, (err) => {
				// Successfully have file on S3
				if (err) {
					reject(err);
				} else {
					resolve();
				}
			});

		}).catch((err) => {
			reject(err);
		});
	});
}

export function reportError(error, errorInfo) {

	state.set(["appState", "errorSpinner", "show"], true);
	setTimeout(async () => {
		const s3 = new AWS.S3({ useDualStack: true });

		const _errorInfo = {
			identityId: getIdentityId(),
			orgId: getOrgId(),
			url: window.location,
			error,
			errorInfo,
			browser: navigator.userAgent,
			cloudAppVersion: state.get(["version"])
		};


		await s3.putObject({
			Bucket: env.s3.errorReportsBucket, Key: "webApp/" + generateUUID() + ".json", Body: JSON.stringify(_errorInfo), ContentType: "application/json"
		}).promise();

		state.set(["appState", "errorSpinner", "show"], false);
	});


}

export function logToCloudWatch(logData) {
	refreshCredentials().then(() => {
		const event = {
			logData,
		};

		// invoke lambda to do import
		const lambda = new AWS.Lambda({ region: env.aws.defaultRegion, apiVersion: "2015-03-31" });

		const params = {
			FunctionName: "logToCloudWatch",
			InvocationType: "RequestResponse",
			LogType: "None",
			Payload: JSON.stringify(event),
		};

		lambda.invoke(params, (error, data) => {
			if (error) {
				alert(error);
			} else {
				alert(data.Payload);
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("logToCloudWatch", err);
	});
}

// Getting image data directly from S3
// Our new approach uses Cloudfront to get the image
export function showImage() {
	refreshCredentials().then(() => {
		const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get());

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: "assets.pricer.miralouaero.com" } });

		bucket.getObject({ Key: `${keyPrefix}/DSCN0008.JPG` }, (err) => {
			if (err) {
				console.log(err, err.stack);
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Error in show image", err);
	});
}

// TODO: Complete one-off...can reuse function above if make async/await
export function previewJsonFromS3(tree, bucketName, fileName, scope, hit) {
	return new Promise((resolve, reject) => {
		console.log("PREVIEW activity", scope, bucketName, fileName);
		refreshCredentials().then(async () => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });

			const Key = scope === "learning" ? `${env.s3.ambiFiLearningKey}/${fileName}` : scope === "org" ? `${getOrgId()}/${PUBLIC_KEY_PREFIX}/${fileName}` : `${PUBLIC_KEY_PREFIX}/${fileName}`;

			bucket.getObject({ Key }, async (err, data) => {
				if (err) {
					console.error(err);
					showError("Unable to get activity", err);
					reject(err);
				} else {
					// Set previewChecklist
					console.log("SETTING CHECKLIST FOR PREVIEW");

					let jsonChecklist = JSON.parse(data.Body.toString());
					// Should convert to make sure has at least one list and one section and set proper type
					console.log(jsonChecklist);

					jsonChecklist = normalizeActivity(jsonChecklist);

					tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, hit.id);
					tree.set(["appState", "previewChecklist", "checklist"], jsonChecklist);
					setTimeout(() => {
						tree.set(["appState", "previewChecklist", "showModal"], true);
						resolve();
					});
				}
			});

		}).catch((err) => {
			console.error(err);
			showError2("Preview failed", err);
			reject(err);
		});
	});

}

export function previewJsonForIdentityFromS3(tree, bucketName, identityId, fileName) {
	return new Promise(async (resolve, reject) => {
		try {
			await refreshCredentials();
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });

			const Key = `${identityId}/${fileName}`;

			bucket.getObject({ Key }, async (err, data) => {
				if (err) {
					showError("Activity Preview", "Unable to get activity for preview:" + err);
					reject(err);
				} else {
					// Set previewChecklist
					let activity = JSON.parse(data.Body.toString());

					// Get activity specific drive
					const activityDrive = {
						guidToResource: await getDriveForActivity(activity)
					};
					tree.set(["appState", "previewChecklist", "drive"], activityDrive);

					// Should convert to make sure has at least one list and one section and set proper type
					activity = normalizeActivity(activity);

					tree.set(["appState", "previewChecklist", "checklist"], activity);
					tree.set(["appState", "previewChecklist", "showModal"], true);
					resolve();
				}
			});
		} catch (e) {
			showError("Activity Preview", "Unable to get activity for preview: " + e);
			console.error("Preview failed", e);
			reject(e);
		}
	});
}

export function showNotes(tree, bucketName, fileName, sessionName) {
	refreshCredentials().then(() => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${fileName}` }, (err, data) => {
			if (err) {
				showError("Unable to get checklist", err);
			} else {
				// Set previewChecklist
				let jsonChecklist = JSON.parse(data.Body.toString());
				// Should convert to make sure has at least one list and one section and set proper type
				jsonChecklist = normalizeActivity(jsonChecklist);

				tree.set(["appState", "showNotes", "checklist"], jsonChecklist);
				tree.set(["appState", "showNotes", "showModal"], true);
				tree.set(["appState", "showNotes", "sessionName"], sessionName);
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("Preview failed", err);
	});
}



export async function setActivitySummary(tree, bucketName, fileName, showAll = false, jsonChecklist, expectedChatSession = null) {
	const canApplyChecklistToChat = (checklist) => !expectedChatSession || (
		expectedChatSession.url === fileName
		&& isPricingSessionActive(tree.get(["appState", "showCreateChatChannel"]) || {}, expectedChatSession)
		&& validatePricingChecklistForSession(checklist, expectedChatSession).valid
	);
	if (expectedChatSession && (
		expectedChatSession.url !== fileName
		|| !isPricingSessionActive(tree.get(["appState", "showCreateChatChannel"]) || {}, expectedChatSession)
	)) {
		return null;
	}
	if (jsonChecklist) {
		if (!canApplyChecklistToChat(jsonChecklist)) {
			return null;
		}
		// This allows showing attachments in summary
		tree.set(["appState", "showNotes", "checklist"], jsonChecklist);

		let jsonChecklistForSummary = _.cloneDeep(jsonChecklist);

		// Summarize
		if (!showAll) {
			utils.summarizeActivity(jsonChecklistForSummary);
		}
		tree.set(["appState", "activitySummary"], jsonChecklistForSummary);
	} else {
		return new Promise((resolve, reject) => {
			refreshCredentials().then(() => {
				if (expectedChatSession
					&& !isPricingSessionActive(tree.get(["appState", "showCreateChatChannel"]) || {}, expectedChatSession)) {
					resolve(null);
					return;
				}
				const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
				bucket.getObject({ Key: `${fileName}` }, (err, data) => {
					if (expectedChatSession
						&& !isPricingSessionActive(tree.get(["appState", "showCreateChatChannel"]) || {}, expectedChatSession)) {
						resolve(null);
						return;
					}
					if (err) {
						showError("Unable to get checklist", err);
						reject(err);
					} else {
						// Set previewChecklist
						let jsonChecklist = JSON.parse(data.Body.toString());
						// Should convert to make sure has at least one list and one section and set proper type
						jsonChecklist = normalizeActivity(jsonChecklist);
						if (!canApplyChecklistToChat(jsonChecklist)) {
							resolve(null);
							return;
						}

						// This allows showing attachments in summary
						tree.set(["appState", "showNotes", "checklist"], jsonChecklist);

						let jsonChecklistForSummary = _.cloneDeep(jsonChecklist);

						// Summarize
						if (!showAll) {
							utils.summarizeActivity(jsonChecklistForSummary);
						}
						tree.set(["appState", "activitySummary"], jsonChecklistForSummary);

						// // Also set invoice items if have them on an activity
						// if (jsonChecklist.hasOwnProperty("invoiceItems")) {
						// 	tree.set(["appState", "activityInvoiceItems"], jsonChecklist.invoiceItems);
						// } else {
						// 	tree.set(["appState", "activityInvoiceItems"], []);
						// }
						resolve(jsonChecklistForSummary);
					}
				});
			}).catch((err) => {
				console.error(err);
				showError2("Preview failed", err);
				reject(err);
			});
		});
	}
}

function hasNonEmptyJobDetails(jobDetails = null) {
	if (!jobDetails || typeof jobDetails !== "object") {
		return false;
	}
	return ["name", "description", "instructions", "notes", "parts"].some(key => _.toString(jobDetails[key] || "").trim() !== "");
}

export function getActivityAuthorProperties(activity = {}) {
	const authorProperties = _.get(activity, "authorProperties", {});
	if (_.isPlainObject(authorProperties)) {
		return authorProperties;
	}
	if (_.isString(authorProperties) && authorProperties.trim()) {
		try {
			const parsed = JSON.parse(authorProperties);
			return _.isPlainObject(parsed) ? parsed : {};
		} catch (err) {
			console.warn("Unable to parse authorProperties for pricing snapshot", err);
		}
	}
	return {};
}

export function getActivityPricingSnapshotId(activity = {}) {
	const directPricingSnapshotId = _.toString(_.get(activity, "pricingSnapshotId", "")).trim();
	if (directPricingSnapshotId) {
		return directPricingSnapshotId;
	}

	const authorProperties = getActivityAuthorProperties(activity);
	const authorPricingSnapshotId = _.toString(authorProperties.pricingSnapshotId || "").trim();
	return authorPricingSnapshotId || "base";
}

export function getActivityPricingContext(activity = {}) {
	return getNormalizedActivityPricingContext(activity);
}

export function showPricing(tree, bucketName, fileName, pricingSession) {
	showStatusSpinner();

	return new Promise((resolve) => {
		refreshCredentials().then(() => {
			if (!isPricingSessionActive(tree.get(["appState", "showPricing"]) || {}, pricingSession)) {
				resolve(null);
				return;
			}
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
			bucket.getObject({ Key: `${fileName}` }, async (err, data) => {
				const currentPricingState = tree.get(["appState", "showPricing"]) || {};
				if (!isPricingSessionActive(currentPricingState, pricingSession)) {
					resolve(null);
					return;
				}

				if (err) {
					tree.set(["appState", "showPricing", "loading"], false);
					hideStatusSpinner();
					showError("Unable to Open Pricing", "The selected job could not be loaded. No pricing data was changed.");
					resolve(null);
					return;
				}

				let jsonChecklist;
				try {
					jsonChecklist = normalizeActivity(JSON.parse(data.Body.toString()));
				} catch (parseErr) {
					console.error("Unable to parse pricing activity", parseErr);
					tree.set(["appState", "showPricing", "loading"], false);
					hideStatusSpinner();
					showError("Unable to Open Pricing", "The selected job contains invalid data. No pricing data was changed.");
					resolve(null);
					return;
				}

				const identityValidation = validatePricingChecklistForSession(jsonChecklist, pricingSession);
				if (!identityValidation.valid) {
					console.error("Refusing to open pricing for a mismatched activity instance", {
						fileName,
						reason: identityValidation.reason
					});
					tree.set(["appState", "showPricing", "loading"], false);
					hideStatusSpinner();
					showError("Unable to Open Pricing", "The job identity could not be verified. No pricing data was changed. Refresh Status and try again.");
					resolve(null);
					return;
				}

				const expectedRevision = contractRevisions.remember(`${bucketName}/${fileName}`, jsonChecklist, data.ETag);
				tree.set(["appState", "showPricing", "expectedContractRevision"], expectedRevision);
				const anchor = jsonChecklist.projectContractAnchor || jsonChecklist.projectOps?.projectContractAnchor;
				if (anchor?.instanceUrl && anchor.instanceUrl !== fileName) {
					try {
						const anchorInstance = await getObject(bucketName, anchor.instanceUrl);
						if (!isPricingSessionActive(tree.get(["appState", "showPricing"]) || {}, pricingSession)) { resolve(null); return; }
						jsonChecklist.pricingContractProto = anchorInstance.pricingContractProto || null;
					} catch (loadError) {
						tree.set(["appState", "showPricing", "loading"], false);
						hideStatusSpinner();
						showError("Unable to Open Pricing", "The current project agreement could not be loaded. Refresh and try again.");
						resolve(null);
						return;
					}
				}
				tree.set(["appState", "showPricing", "pricingContractBaseline"], _.cloneDeep(jsonChecklist.pricingContractProto || null));
				jsonChecklist = withSelectedContractInvoice(jsonChecklist);

				let hydratedJobDetails = null;
				try {
					hydratedJobDetails = utils.computeJobDetails(jsonChecklist);
				} catch (computeErr) {
					console.error("[computeJobDetails] failed", computeErr);
				}

				// The session can change while normalization or job-detail hydration is running.
				if (!isPricingSessionActive(tree.get(["appState", "showPricing"]) || {}, pricingSession)) {
					resolve(null);
					return;
				}

				tree.set(["appState", "showPricing", "checklist"], jsonChecklist);
				const pricingContext = getActivityPricingContext(jsonChecklist);
				const retailModePolicy = getRetailModePolicy(tree.get(["selectedOrg"]), {
					adminPreview: tree.get(["appState", "retailModePreview"]),
					isAdministrator: isOrganizationAdministrator()
				});
				tree.set(["appState", "showPricing", "pricingSnapshotId"], pricingContext.pricingSnapshotId);
				tree.set(["appState", "showPricing", "pricingSnapshotIdTemp"], pricingContext.pricingSnapshotId);
				tree.set(["appState", "showPricing", "pricingMode"], pricingContext.pricingMode);
				tree.set(["appState", "showPricing", "pricingModeTemp"], retailModePolicy.active ? retailModePolicy.forcedMode : pricingContext.pricingMode);
				tree.set(["appState", "showPricing", "pricingModeForced"], retailModePolicy.active);
				tree.set(["appState", "showPricing", "selectedValue"], jsonChecklist.selectedValue || "");
				tree.set(["appState", "showPricing", "selectedValueTemp"], jsonChecklist.selectedValue || "");
				tree.set(["appState", "showPricing", "invoiceItems"], jsonChecklist.invoiceItems || []);
				tree.set(["appState", "showPricing", "invoiceItemsTemp"], jsonChecklist.invoiceItems || []);
				tree.set(["appState", "showPricing", "estimates"], jsonChecklist.estimates || []);
				tree.set(["appState", "showPricing", "estimatesTemp"], jsonChecklist.estimates || []);
				const savedJobDetails = jsonChecklist.jobDetails || null;
				const defaultJobDetails = { name: "", description: "", instructions: "", notes: "", parts: "" };
				const resolvedJobDetails = hasNonEmptyJobDetails(savedJobDetails)
					? savedJobDetails
					: (hasNonEmptyJobDetails(hydratedJobDetails) ? hydratedJobDetails : (savedJobDetails || defaultJobDetails));
				tree.set(["appState", "showPricing", "jobDetails"], resolvedJobDetails);
				tree.set(["appState", "showPricing", "jobDetailsTemp"], resolvedJobDetails);
				tree.set(["appState", "showPricing", "pricingContractProto"], jsonChecklist.pricingContractProto || null);
				tree.set(["appState", "showPricing", "pricingContractProtoTemp"], jsonChecklist.pricingContractProto || null);
				tree.set(["appState", "showPricing", "loading"], false);
				tree.set(["appState", "showPricing", "showModal"], true);
				hideStatusSpinner();
				resolve(jsonChecklist);
			});
		}).catch((err) => {
			if (isPricingSessionActive(tree.get(["appState", "showPricing"]) || {}, pricingSession)) {
				tree.set(["appState", "showPricing", "loading"], false);
				hideStatusSpinner();
				console.error(err);
				showError2("Preview failed", err);
			}
			resolve(null);
		});
	});
}

function extractIdsFromKey(fileKey) {
	const [identityId, activityId, fileName] = fileKey.split("/");
	const instanceIdMatch = fileName.match(/_(.*)\.json$/);
	const instanceId = instanceIdMatch ? instanceIdMatch[1] : null;

	return { identityId, activityId, instanceId };
}

const contractRevisions = createContractRevisionStore();

export function saveInstance(bucketName, fileName, data, options = {}) {
	return new Promise((resolve, reject) => {
		try {
			refreshCredentials().then(async () => {
				await assertCurrentJobTarget(fileName, data);
				const bucket = new AWS.S3({ useDualStack: true, signatureVersion: "v4", params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });

				const revisionKey = `${bucketName}/${fileName}`;
				const expected = contractRevisions.prepare(revisionKey, data, options.expectedRevision);
				const savedInstance = withComputedPricingTotals(withSelectedContractInvoice(data));
				const body = JSON.stringify(savedInstance);
				const putRequest = bucket.putObject({
					Key: `${fileName}`,
					Body: body,
					ContentType: "application/json",
					Tagging: "skipIndexing=true"
				});
				if (expected) guardContractPutRequest(putRequest, expected.etag);
				putRequest.send((writeError, data) => {
					const err = expected ? mapContractWriteError(writeError) : writeError;
					if (!err) contractRevisions.remember(revisionKey, savedInstance, data.ETag);
					if (err) {
						showError("Unable to put activity saving pricing", err);
						reject(err);
					} else {
						const keys = extractIdsFromKey(fileName);
						const indexRequestId = `index-instance-${Date.now()}-${_.uniqueId()}`;
						const indexRequestPayload = {
							key: fileName,
							orgId: getOrgId(),
							identityId: keys.identityId,
							activityId: keys.activityId,
							instanceId: keys.instanceId,
							debugRequestId: indexRequestId
						};
						const indexRequestUrl = `${env.apiGateway.baseUrl}${env.apiGateway.endpoints.indexActivityInstance}`;

						console.log("REQUEST", indexRequestUrl, indexRequestPayload);

						// Manually trigger indexing via API Gateway
						request
							.post(indexRequestUrl)
							.set({
								Authorization: getJwtToken(),
								"Content-Type": "application/json"
							})
							.send(indexRequestPayload)
							.then(async res => {
								console.log("✅ Successfully triggered indexing via API Gateway", {
									requestId: indexRequestId,
									status: res.status,
									body: res.body,
									text: res.text,
									headers: res.headers
								});
								// The deployed indexing endpoint returns HTTP 200 even when it
								// skips an obsolete source. Check ownership again before the UI
								// treats the save as applied and discards the editor's changes.
								try {
									await assertCurrentJobTarget(fileName, JSON.parse(body));
									resolve(data);
								} catch (verificationError) {
									reject(verificationError);
								}
							})
							.catch(async err => {
								const indexErrorDetails = {
									requestId: indexRequestId,
									message: err && err.message ? err.message : err,
									status: err && err.status ? err.status : undefined,
									code: err && err.code ? err.code : undefined,
									timeout: err && err.timeout ? err.timeout : undefined,
									responseBody: _.get(err, "response.body"),
									responseText: _.get(err, "response.text"),
									responseHeaders: _.get(err, "response.headers"),
									payload: indexRequestPayload
								};
								console.error("🔥 Failed to trigger indexing", indexErrorDetails, err);
								try {
									await assertCurrentJobTarget(fileName, JSON.parse(body));
								} catch (verificationError) {
									reject(verificationError);
									return;
								}
								showWarningToast("Activity instance saved, but indexing did not complete. Status views may lag until the instance is re-indexed.");
								resolve(data);
							});
					}
				});
			}).catch((err) => {
				console.error(err);
				showError2("Save pricing failed", err);
				reject(err);
			});
		} catch (err) {
			reject(err);
		}
	});
}

function applyJabWorkflowStatesFallback(jsonChecklist = {}) {
	// Hardwire DS here to fix brothers issue? This is hardwired only to the Converge Custom Job Submission
	// If in the future he ever uses a different workflow file for this activity this needs to be removed
	if (getOrgId() === "332a9d47-6e36-11e8-a392-061714f61e3e" && jsonChecklist.id === "05382b26-9db0-45d3-b8d9-313912a26364" && !jsonChecklist.hasOwnProperty("workflowStatesDs")) {
		jsonChecklist.workflowStatesDs = [
			{
				"type": "resource/ref",
				"refId": "bf8725eb-aeac-47c6-84cc-a5702c34c513"
			}
		];
	} else if (getOrgId() === "332a9d47-6e36-11e8-a392-061714f61e3e" && jsonChecklist.id === "50d90f3d-21e4-462a-8a81-ef9656a5e4b5" && !jsonChecklist.hasOwnProperty("workflowStatesDs")) {
		jsonChecklist.workflowStatesDs = [
			{
				"type": "resource/ref",
				"refId": "8263302b-547c-4ae2-a205-3eda4b4c2e48"
			}
		];
	}
}

async function hydrateWorkflowStatesFromDataSource(jsonChecklist = {}) {
	if (jsonChecklist.hasOwnProperty("workflowStatesDs") && _.isArray(jsonChecklist.workflowStatesDs) && jsonChecklist.workflowStatesDs.length > 0 && jsonChecklist.workflowStatesDs[0].hasOwnProperty("refId")) {
		try {
			console.log("GET CONTENT BY ID", jsonChecklist.workflowStatesDs[0].refId);
			const externalResource = getExternalResource(jsonChecklist.workflowStatesDs[0].refId, jsonChecklist);
			console.log("EXTERNAL RESOURCE", externalResource);
			if (externalResource) {
				console.log("GET CONTENT WITH GUID", externalResource.guid);
				const newWorkflowData = await getContent(externalResource.guid);
				console.log("GOT CONTENT", newWorkflowData);
				if (!_.isArray(jsonChecklist.workflowStates)) {
					jsonChecklist.workflowStates = [{}];
				}
				jsonChecklist.workflowStates[0] = newWorkflowData;
			}
		} catch (err) {
			console.log("ERROR", err);
		}
	}
}

async function prepareWorkflowChecklist(jsonChecklist = {}) {
	let preparedChecklist = normalizeActivity(jsonChecklist);
	applyJabWorkflowStatesFallback(preparedChecklist);
	await hydrateWorkflowStatesFromDataSource(preparedChecklist);
	return preparedChecklist;
}

export async function getWorkflowChecklistForInstance(key) {
	const jsonChecklist = await getObject(env.s3.contentBucket, key);
	return prepareWorkflowChecklist(jsonChecklist);
}

export function showWorkflowForMultiple(tree, bucketName) {
	showStatusSpinner();

	refreshCredentials().then(() => {
		// We could get the first instance document-- there could be a scenario where multiple are selected and they have different workflows-- we could may check this as trying to update each instance document

		const selectedStatusItems = state.get(["appState", "selectedStatusItems"]);

		hideStatusSpinner();

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${selectedStatusItems[0].url}` }, async (err, data) => {
			if (err) {
				hideStatusSpinner();
				showError("Unable to get checklist", err);
			} else {
				// Set previewChecklist
				let jsonChecklist = JSON.parse(data.Body.toString());
				// Should convert to make sure has at least one list and one section and set proper type
				jsonChecklist = normalizeActivity(jsonChecklist);

				// Hardwire DS here to fix brothers issue? This is hardwired only to the Converge Custom Job Submission
				// If in the future he ever uses a different workflow file for this activity this needs to be removed
				if (getOrgId() === "332a9d47-6e36-11e8-a392-061714f61e3e" && jsonChecklist.id === "05382b26-9db0-45d3-b8d9-313912a26364" && !jsonChecklist.hasOwnProperty("workflowStatesDs")) {
					jsonChecklist.workflowStatesDs = [
						{
							"type": "resource/ref",
							"refId": "bf8725eb-aeac-47c6-84cc-a5702c34c513"
						}
					];
				} else if (getOrgId() === "332a9d47-6e36-11e8-a392-061714f61e3e" && jsonChecklist.id === "50d90f3d-21e4-462a-8a81-ef9656a5e4b5" && !jsonChecklist.hasOwnProperty("workflowStatesDs")) {
					jsonChecklist.workflowStatesDs = [
						{
							"type": "resource/ref",
							"refId": "8263302b-547c-4ae2-a205-3eda4b4c2e48"
						}
					];
				}

				// 01ac8372-65e0-4ee4-b071-8facb93c9e4d

				// If using a datasource then get the latest content instead of the cached content in the activity
				if (jsonChecklist.hasOwnProperty("workflowStatesDs") && _.isArray(jsonChecklist.workflowStatesDs) && jsonChecklist.workflowStatesDs.length > 0 && jsonChecklist.workflowStatesDs[0].hasOwnProperty("refId")) {
					try {
						console.log("GET CONTENT BY ID", jsonChecklist.workflowStatesDs[0].refId);
						const externalResource = getExternalResource(jsonChecklist.workflowStatesDs[0].refId, jsonChecklist);
						console.log("EXTERNAL RESOURCE", externalResource);
						if (!externalResource) {
						} else {
							console.log("GET CONTENT WITH GUID", externalResource.guid);
							const newWorkflowData = await getContent(externalResource.guid);
							console.log("GOT CONTENT", newWorkflowData);
							jsonChecklist.workflowStates[0] = newWorkflowData;
						}

						// Ideally should re-save this back to S3 which would fix the cached data
					} catch (err) {
						// No op
						console.log("ERROR", err);
					}
				}

				tree.set(["appState", "showWorkflowForMultiple", "checklist"], jsonChecklist);
				tree.set(["appState", "showWorkflowForMultiple", "showModal"], true);

				hideStatusSpinner();
			}
		});
	}).catch((err) => {
		hideStatusSpinner();

		console.error(err);
		showError2("Preview failed", err);
	});

}

export function showWorkflow(tree, bucketName, fileName) {
	showStatusSpinner();

	refreshCredentials().then(() => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${fileName}` }, async (err, data) => {
			if (err) {
				hideStatusSpinner();
				showError("Unable to get checklist", err);
			} else {
				// Set previewChecklist
				let jsonChecklist = JSON.parse(data.Body.toString());
				// Should convert to make sure has at least one list and one section and set proper type
				jsonChecklist = normalizeActivity(jsonChecklist);

				// Hardwire DS here to fix brothers issue? This is hardwired only to the Converge Custom Job Submission
				// If in the future he ever uses a different workflow file for this activity this needs to be removed
				if (getOrgId() === "332a9d47-6e36-11e8-a392-061714f61e3e" && jsonChecklist.id === "05382b26-9db0-45d3-b8d9-313912a26364" && !jsonChecklist.hasOwnProperty("workflowStatesDs")) {
					jsonChecklist.workflowStatesDs = [
						{
							"type": "resource/ref",
							"refId": "bf8725eb-aeac-47c6-84cc-a5702c34c513"
						}
					];
				} else if (getOrgId() === "332a9d47-6e36-11e8-a392-061714f61e3e" && jsonChecklist.id === "50d90f3d-21e4-462a-8a81-ef9656a5e4b5" && !jsonChecklist.hasOwnProperty("workflowStatesDs")) {
					jsonChecklist.workflowStatesDs = [
						{
							"type": "resource/ref",
							"refId": "8263302b-547c-4ae2-a205-3eda4b4c2e48"
						}
					];
				}

				// 01ac8372-65e0-4ee4-b071-8facb93c9e4d

				// If using a datasource then get the latest content instead of the cached content in the activity
				if (jsonChecklist.hasOwnProperty("workflowStatesDs") && _.isArray(jsonChecklist.workflowStatesDs) && jsonChecklist.workflowStatesDs.length > 0 && jsonChecklist.workflowStatesDs[0].hasOwnProperty("refId")) {
					try {
						console.log("GET CONTENT BY ID", jsonChecklist.workflowStatesDs[0].refId);
						const externalResource = getExternalResource(jsonChecklist.workflowStatesDs[0].refId, jsonChecklist);
						console.log("EXTERNAL RESOURCE", externalResource);
						if (!externalResource) {
						} else {
							console.log("GET CONTENT WITH GUID", externalResource.guid);
							const newWorkflowData = await getContent(externalResource.guid);
							console.log("GOT CONTENT", newWorkflowData);
							jsonChecklist.workflowStates[0] = newWorkflowData;
						}

						// Ideally should re-save this back to S3 which would fix the cached data
					} catch (err) {
						// No op
						console.log("ERROR", err);
					}
				}

				tree.set(["appState", "showWorkflow", "checklist"], jsonChecklist);
				tree.set(["appState", "showWorkflow", "showModal"], true);
				tree.set(["appState", "showWorkflow", "url"], fileName);

				hideStatusSpinner();
			}
		});
	}).catch((err) => {
		hideStatusSpinner();
		alert("Error in show workflow. Please try again.");
		// console.error(err);
		console.error(err);
		// showError2("Preview failed", err);
	});
}


// Specific use case
// Save to s3
// Add in algolia index
// When finished can refresh search
export function saveWorkflow(bucketName, fileName, data) {
	return saveInstance(bucketName, fileName, data);
}

export function showDetailedStatus(tree, bucketName, fileName, allowEdit = true) {
	refreshCredentials().then(() => {
		loadActivityInstanceFromS3(bucketName, fileName).then((result) => {
			tree.set(PlayerPaths.CHECKLIST, result);
			// tree.set(PlayerPaths.SELECTED_ACTIVITY_IDENTITY_ID, fileName.substring(0, fileName.indexOf("/")));
			tree.set(["appState", "showDetailedStatus", "showModal"], true);
			tree.set(["appState", "showDetailedStatus", "edit"], false);
			tree.set(["appState", "showDetailedStatus", "allowEdit"], allowEdit);
			tree.set(["appState", "status", "showSpinner"], false);
		}).catch((err) => {
			console.error(err);
			tree.set(["appState", "status", "showSpinner"], false);
			showError2("Load activity failed", err);
		});
	}).catch((err) => {
		console.error(err);
		tree.set(["appState", "status", "showSpinner"], false);
		showError2("Preview failed", err);
	});
}

export function showDetailedHistory(tree, bucketName, fileName) {
	refreshCredentials().then(() => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${fileName}` }, (err, data) => {
			if (err) {
				showError("Unable to get checklist", err);
			} else {
				// Set previewChecklist
				let jsonChecklist = JSON.parse(data.Body.toString());
				// Should convert to make sure has at least one list and one section and set proper type
				jsonChecklist = normalizeActivity(jsonChecklist);

				if (!jsonChecklist.hasOwnProperty("history")) {
					alert("Thre currently is no history for this activity.");
				} else {
					tree.set(["appState", "showDetailedHistory", "checklist"], jsonChecklist);
					tree.set(["appState", "showDetailedHistory", "showModal"], true);
				}
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("Preview failed", err);
	});
}

export function reprintInstancesForInvoice(allInvoices, template = "cc-invoices-pdf") {
	return refreshCredentials().then(async () => {
		console.log(allInvoices);

		console.log("arrInstances", { data: allInvoices }, JSON.stringify(allInvoices).length);

		const printFilename = buildInvoicePrintFilename(template, allInvoices && allInvoices.invoiceId);

		state.set(["appState", "status", "showSpinner"], false);

		return printTemplate(printFilename, allInvoices, template, { "docTypeExt": "pdf", "preview": true, "preferredPreviewHost": "publications" });
	}).catch((err) => {
		console.error(err);
		showError2("Print Instances failed", err);
		throw err;
	});
}

function hasInvoiceItemMetadataValue(value) {
	return value !== undefined
		&& value !== null
		&& (typeof value !== "string" || value.trim() !== "");
}

function resolveInvoiceItemMetadataField(item = {}, field) {
	const candidates = [
		item[field],
		item.hit && typeof item.hit === "object" ? item.hit[field] : undefined,
		item.item && typeof item.item === "object" ? item.item[field] : undefined
	];

	return candidates.find(hasInvoiceItemMetadataValue);
}

function normalizeInvoiceItemMetadata(item) {
	if (!item || typeof item !== "object") {
		return item;
	}

	const normalized = { ...item };
	[
		"manufacturer",
		"model",
		"color",
		"listId",
		"listName",
		"sectionId",
		"sectionName",
		"itemId",
		"itemName"
	].forEach((field) => {
		const value = resolveInvoiceItemMetadataField(item, field);
		if (hasInvoiceItemMetadataValue(value)) {
			normalized[field] = value;
		}
	});

	return normalized;
}

function normalizeInvoiceItemsMetadata(items) {
	if (!Array.isArray(items)) {
		return items;
	}

	return items.map(normalizeInvoiceItemMetadata);
}

function shouldIncludeInvoiceReferenceData(docTypeExt = "") {
	return String(docTypeExt || "").toLowerCase() === "xlsx";
}

function normalizeInvoiceItemsForReport(items, { includeMetadata = false } = {}) {
	const normalizedItems = projectCustomerPricingPayload(normalizeInvoiceItemsMetadata(items));
	if (!Array.isArray(normalizedItems)) {
		return [];
	}

	if (includeMetadata) {
		return normalizedItems;
	}

	return normalizedItems.map((item = {}) => ({
		...(isCalculatedPricing(item) ? { pricingBehavior: "calculatedTotal", customerDisplay: "totalOnly", value: item.value } : {}),
		description: toInvoiceFieldString(item.description || item.name || item.label || item.itemName),
		qty: toInvoiceNumber(item.qty, 1),
		rate: toInvoiceNumber(item.rate, 0),
		discount: toInvoiceNumber(item.discount, 1)
	}));
}

function normalizeInvoiceCustomerForReport(customer = {}) {
	if (!customer || typeof customer !== "object") {
		return {};
	}

	const reportCustomer = {};
	[
		"customerId",
		"customerCode",
		"customerGuid",
		"customerName",
		"billingFirstName",
		"billingLastName",
		"billingEmail",
		"billingPhone",
		"billingAddress1",
		"billingAddress2",
		"billingCity",
		"billingState",
		"billingZip",
		"billingCountry",
		"shippingContactSameAsBillTo",
		"shippingAddressSameAsBillTo",
		"shippingFirstName",
		"shippingLastName",
		"shippingEmail",
		"shippingPhone",
		"shippingAddress1",
		"shippingAddress2",
		"shippingCity",
		"shippingState",
		"shippingZip",
		"shippingCountry"
	].forEach((field) => {
		if (hasInvoiceFieldValue(customer[field]) || typeof customer[field] === "boolean") {
			reportCustomer[field] = customer[field];
		}
	});

	return reportCustomer;
}

function formatPricingTotalCurrency(total = 0) {
	return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(total) || 0);
}

const INVOICE_INSURED_VALUE_ITEM_ID = "insuredValue";
const INVOICE_INSURED_VALUE_ITEM_GUID = "8b9439e2-327c-4c91-84df-ebdb6150928d";
const INVOICE_DECLARED_VALUE_ITEM_IDS = ["declaredValue", "declardValue"];
const INVOICE_DECLARED_VALUE_ITEM_GUID = "7689521a-d8ff-46cd-84e2-04ed6ad00892";

function roundInvoiceAmount(value = 0) {
	return Math.round(((Number(value) || 0) + Number.EPSILON) * 100) / 100;
}

function roundInvoiceValueToNextHundred(value = 0) {
	const numericValue = Number(value);
	if (!Number.isFinite(numericValue) || numericValue <= 0) {
		return 0;
	}
	return Math.ceil(numericValue / 100) * 100;
}

function hasInvoiceFieldValue(value) {
	return value !== undefined
		&& value !== null
		&& (typeof value !== "string" || value.trim() !== "");
}

function toInvoiceFieldString(value) {
	if (!hasInvoiceFieldValue(value)) {
		return "";
	}
	if (typeof value === "string") {
		return value.trim();
	}
	if (typeof value === "number") {
		return Number.isFinite(value) ? formatPricingTotalCurrency(value) : "";
	}
	if (Array.isArray(value)) {
		return value.map(toInvoiceFieldString).filter(Boolean).join(", ");
	}
	if (typeof value === "object") {
		const candidate = value.label || value.value || value.name || value.text;
		if (hasInvoiceFieldValue(candidate)) {
			return toInvoiceFieldString(candidate);
		}
	}
	return String(value).trim();
}

function parseInvoiceCurrencyValue(value) {
	if (typeof value === "number") {
		return Number.isFinite(value) ? roundInvoiceAmount(value) : 0;
	}
	if (typeof value !== "string") {
		return 0;
	}

	const normalized = value.replace(/[^0-9.-]/g, "");
	const parsed = Number(normalized);
	return Number.isFinite(parsed) ? roundInvoiceAmount(parsed) : 0;
}

function parseInvoiceTrackingNumbers(value) {
	if (Array.isArray(value)) {
		return value.map((item) => toInvoiceFieldString(item)).filter(Boolean);
	}
	return String(value || "")
		.split(/[\n,;]+/)
		.map((item) => item.trim())
		.filter(Boolean);
}

function normalizeInvoiceShippingDetails({ shippingTotal, shippingDetails } = {}) {
	const rawShippingDetails = shippingDetails && typeof shippingDetails === "object" ? shippingDetails : {};
	const rawTotal = hasInvoiceFieldValue(rawShippingDetails.total) ? rawShippingDetails.total : shippingTotal;
	const totalNumber = parseInvoiceCurrencyValue(rawTotal);
	const trackingNumbers = parseInvoiceTrackingNumbers(rawShippingDetails.trackingNumbers || rawShippingDetails.trackingNumbersString || rawShippingDetails.trackingNumber);
	const carrier = toInvoiceFieldString(rawShippingDetails.carrier);
	const service = toInvoiceFieldString(rawShippingDetails.service);
	const shipDate = toInvoiceFieldString(rawShippingDetails.shipDate || rawShippingDetails.date);
	const notes = toInvoiceFieldString(rawShippingDetails.notes);

	return {
		total: totalNumber,
		totalNumber,
		totalString: formatPricingTotalCurrency(totalNumber),
		carrier,
		service,
		trackingNumbers,
		trackingNumbersString: trackingNumbers.join(", "),
		shipDate,
		notes
	};
}

function hasInvoiceShippingDetailValue(shipping = {}) {
	return Boolean(shipping && (
		shipping.totalNumber > 0
		|| hasInvoiceFieldValue(shipping.carrier)
		|| hasInvoiceFieldValue(shipping.service)
		|| hasInvoiceFieldValue(shipping.shipDate)
		|| hasInvoiceFieldValue(shipping.notes)
		|| (Array.isArray(shipping.trackingNumbers) && shipping.trackingNumbers.length > 0)
	));
}

function toInvoiceNumber(value, defaultValue = 0) {
	const numericValue = Number(value);
	return Number.isFinite(numericValue) ? numericValue : defaultValue;
}

function getInvoiceReportItemTotal(invoiceItem = {}) {
	const qty = toInvoiceNumber(invoiceItem.qty, 1);
	const rate = toInvoiceNumber(invoiceItem.rate, 0);
	const discount = toInvoiceNumber(invoiceItem.discount, 1);
	const rateAfterDiscount = roundInvoiceAmount(rate * discount);
	return roundInvoiceAmount(qty * rateAfterDiscount);
}

function computeInvoiceReportItemsTotal(invoiceItems = []) {
	if (!Array.isArray(invoiceItems)) {
		return 0;
	}

	return roundInvoiceAmount(invoiceItems.reduce((total, invoiceItem) => (
		total + getInvoiceReportItemTotal(invoiceItem)
	), 0));
}

function idsMatchBaseOrSuffixed(value, base) {
	const normalizedValue = typeof value === "string" ? value.trim() : "";
	const normalizedBase = typeof base === "string" ? base.trim() : "";
	return Boolean(normalizedValue && normalizedBase && (
		normalizedValue === normalizedBase
		|| normalizedValue.indexOf(`${normalizedBase}_`) === 0
	));
}

function anyInvoiceIdMatches(value, ids = []) {
	return Array.isArray(ids) && ids.some((id) => idsMatchBaseOrSuffixed(value, id));
}

function getInvoiceItemValue(item = {}) {
	if (!item || typeof item !== "object") {
		return "";
	}
	if (hasInvoiceFieldValue(item.value)) {
		return item.value;
	}
	if (hasInvoiceFieldValue(item.notes)) {
		return item.notes;
	}
	return "";
}

function getLatestHistoryItemValues(activity = {}, itemGuid = "") {
	const history = Array.isArray(activity?.history) ? activity.history : [];
	const values = [];
	const seenKeys = {};

	for (let i = history.length - 1; i >= 0; i -= 1) {
		const historyItem = history[i] || {};
		if (!idsMatchBaseOrSuffixed(historyItem.itemGuid, itemGuid) || !hasInvoiceFieldValue(historyItem.value)) {
			continue;
		}

		const historyKey = [historyItem.itemGuid || "", historyItem.path || ""].join(":");
		if (!seenKeys[historyKey]) {
			seenKeys[historyKey] = true;
			values.unshift(historyItem.value);
		}
	}

	return values;
}

function findInvoiceItemValues(activity = {}, { ids = [], guid = "" } = {}) {
	const foundValues = [];

	function walk(nodes) {
		if (!Array.isArray(nodes)) {
			return;
		}

		for (let i = 0; i < nodes.length; i += 1) {
			const node = nodes[i] || {};
			const type = typeof node.type === "string" ? node.type : "";
			const isItem = type.indexOf("item") === 0;

			if (isItem && node.visible !== false && node.enabled !== false) {
				const value = getInvoiceItemValue(node);
				if (hasInvoiceFieldValue(value) && (
					anyInvoiceIdMatches(node.id, ids)
					|| (guid && idsMatchBaseOrSuffixed(node.guid, guid))
				)) {
					foundValues.push(value);
				}
			}

			walk(node.children);
		}
	}

	walk(activity?.children);
	return foundValues.length > 0 ? foundValues : getLatestHistoryItemValues(activity, guid);
}

function resolveInvoiceValueField(activity = {}, { ids = [], guid = "" } = {}) {
	const rawValues = findInvoiceItemValues(activity, { ids, guid });
	const values = rawValues.map(toInvoiceFieldString).filter(Boolean);
	const valueNumber = roundInvoiceAmount(values.reduce((total, value) => (
		total + parseInvoiceCurrencyValue(value)
	), 0));

	return {
		values,
		value: values.join(", "),
		valueNumber,
		valueString: formatPricingTotalCurrency(valueNumber),
		itemIds: ids,
		itemGuid: guid
	};
}

function resolveInvoiceInsuredValue(activity = {}) {
	const valueInfo = resolveInvoiceValueField(activity, {
		ids: [INVOICE_INSURED_VALUE_ITEM_ID],
		guid: INVOICE_INSURED_VALUE_ITEM_GUID
	});

	return {
		insuredValue: valueInfo.value,
		insuredValueValues: valueInfo.values,
		insuredValueNumber: valueInfo.valueNumber,
		insuredValueString: valueInfo.valueString,
		insuredValueItemId: INVOICE_INSURED_VALUE_ITEM_ID,
		insuredValueItemGuid: INVOICE_INSURED_VALUE_ITEM_GUID
	};
}

function resolveInvoiceDeclaredValue(activity = {}) {
	const valueInfo = resolveInvoiceValueField(activity, {
		ids: INVOICE_DECLARED_VALUE_ITEM_IDS,
		guid: INVOICE_DECLARED_VALUE_ITEM_GUID
	});

	return {
		declaredValue: valueInfo.value,
		declaredValueValues: valueInfo.values,
		declaredValueNumber: valueInfo.valueNumber,
		declaredValueString: valueInfo.valueString,
		declaredValueItemIds: INVOICE_DECLARED_VALUE_ITEM_IDS,
		declaredValueItemGuid: INVOICE_DECLARED_VALUE_ITEM_GUID
	};
}

function getActivePricingContractInvoiceItems(pricingContractProto) {
	if (!pricingContractProto || typeof pricingContractProto !== "object" || !Array.isArray(pricingContractProto.documents)) {
		return null;
	}

	const activeDocument = pricingContractProto.documents.find((document) => document?.id === pricingContractProto.activeDocumentId)
		|| pricingContractProto.documents[pricingContractProto.documents.length - 1]
		|| null;

	return Array.isArray(activeDocument?.invoiceItems) ? activeDocument.invoiceItems : null;
}

function withComputedPricingTotals(data) {
	if (!data || typeof data !== "object") {
		return data;
	}

	const contractInvoiceItems = getActivePricingContractInvoiceItems(data.pricingContractProto);
	const invoiceItems = Array.isArray(contractInvoiceItems)
		? contractInvoiceItems
		: (Array.isArray(data.invoiceItems) ? data.invoiceItems : null);

	if (!Array.isArray(invoiceItems)) {
		return data;
	}

	const totalPrice = computeBudgetAwarePricingTotal(invoiceItems);
	const nextData = {
		...data,
		totalPrice,
		totalPriceString: formatPricingTotalCurrency(totalPrice)
	};
	if (!isProjectOpsEnabledForOrg(getOrgId())) {
		return nextData;
	}

	const contributionSummary = getProjectOpsContributionPricingSummary(_.omit(nextData, [
		"projectOpsContributionSummaryString",
		"projectOpsContributionDetailString",
		"pricingBudgetSummaryString",
		"pricingBudgetDetailString"
	]));
	if (!contributionSummary || !contributionSummary.primaryText) {
		return nextData;
	}

	return {
		...nextData,
		projectOpsPricingScope: "contribution",
		projectOpsContributionTotal: Number.isFinite(contributionSummary.spentTotal) ? contributionSummary.spentTotal : undefined,
		projectOpsBudgetTotal: Number.isFinite(contributionSummary.budgetTotal) ? contributionSummary.budgetTotal : undefined,
		projectOpsBudgetDelta: Number.isFinite(contributionSummary.delta) ? contributionSummary.delta : undefined,
		projectOpsContributionSummaryString: contributionSummary.primaryText,
		projectOpsContributionDetailString: contributionSummary.detailText || "",
		pricingBudgetSummaryString: contributionSummary.primaryText,
		pricingBudgetDetailString: contributionSummary.detailText || ""
	};
}

function pickFirstNonEmptyInvoiceItems(...candidates) {
	for (let i = 0; i < candidates.length; i++) {
		const candidate = candidates[i];
		if (Array.isArray(candidate) && candidate.length > 0) {
			return candidate;
		}
	}

	for (let i = 0; i < candidates.length; i++) {
		const candidate = candidates[i];
		if (Array.isArray(candidate)) {
			return candidate;
		}
	}

	return null;
}

function normalizePricingMetadataForPrint(data) {
	if (!data || typeof data !== "object") {
		return data;
	}

	const normalized = { ...data };

	if (Array.isArray(data.invoiceItems)) {
		normalized.invoiceItems = normalizeInvoiceItemsMetadata(data.invoiceItems);
	}

	if (Array.isArray(data.estimates)) {
		normalized.estimates = data.estimates.map((estimate) => {
			if (!estimate || typeof estimate !== "object") {
				return estimate;
			}

			return {
				...estimate,
				invoiceItems: normalizeInvoiceItemsMetadata(estimate.invoiceItems)
			};
		});
	}

	return normalized;
}

function resolveEstimateNameForPrint(estimate) {
	if (!estimate || typeof estimate !== "object") {
		return "Estimate";
	}

	const candidates = [
		estimate.jobDetails?.name,
		estimate.name,
		estimate.label,
		estimate.title,
		estimate.value
	];

	const resolved = candidates.find((value) => typeof value === "string" && value.trim() !== "");
	return resolved ? resolved.trim() : "Estimate";
}

function getEstimateJobDetailsForPrint(estimate) {
	if (!estimate || typeof estimate !== "object") {
		return {};
	}

	const jobDetails = estimate.jobDetails && typeof estimate.jobDetails === "object"
		? estimate.jobDetails
		: estimate;

	const instructions = typeof jobDetails.instructions === "string" ? jobDetails.instructions.trim() : "";
	const description = typeof jobDetails.description === "string" ? jobDetails.description.trim() : "";
	const notes = typeof jobDetails.notes === "string" ? jobDetails.notes.trim() : "";

	return {
		instructions,
		description,
		notes
	};
}

function resolveFallbackEstimateNameForPrint(source = {}) {
	const selectedValue = typeof source.selectedValue === "string" ? source.selectedValue.trim() : "";
	if (Array.isArray(source.estimates) && selectedValue !== "") {
		const selectedEstimate = source.estimates.find((estimate) => estimate && estimate.value === selectedValue);
		const selectedEstimateName = resolveEstimateNameForPrint(selectedEstimate);
		if (selectedEstimateName && selectedEstimateName !== "Estimate") {
			return selectedEstimateName;
		}
	}

	if (selectedValue === "original") {
		return "Original Estimate";
	}

	if (selectedValue !== "") {
		return selectedValue;
	}

	return "Estimate";
}

function resolveEstimateReportJobId(instances = [], { allowSessionNameFallback = true } = {}) {
	if (!Array.isArray(instances) || instances.length === 0) {
		return utils.generateUUID().substring(0, 8);
	}

	if (instances.length === 1) {
		const instance = instances[0] || {};
		const singleJobId = [
			instance.jobIdString,
			instance.jobId,
			allowSessionNameFallback ? instance.sessionNameResolved : null
		]
			.find((value) => value !== undefined && value !== null && String(value).trim() !== "");
		if (singleJobId) {
			return String(singleJobId).trim();
		}
	}

	return "Multiple";
}

function failEstimatePrint(title, message) {
	const error = new Error(message);
	error.name = "EstimatePrintError";
	error.estimatePrintUserNotified = true;
	state.set(["appState", "status", "showSpinner"], false);
	showError(title, message);
	throw error;
}

/**
 * Print the saved estimate state, or an explicitly supplied transient pricing
 * draft. options.currentDraft must be a complete object containing all pricing
 * contract fields consumed here: selectedValue (string), invoiceItems
 * (array), estimates (array), and jobDetails (plain object). Extra fields are
 * ignored. Activity/job/customer identity is always resolved from the Cloud
 * search hit and, when available, its S3 activity.
 *
 * options.pricingMode and options.pricingModeConfig continue to identify the
 * requested output mode. Draft invoice lines should retain their canonical
 * wholesale/base-rate metadata; this function applies Retail once while
 * preparing report lines.
 *
 * @returns {Promise<Object>} Resolves with print metadata after rendering and
 * rejects after UI cleanup when validation, hydration, or rendering fails.
 */
export function printInstancesForEstimate(tree, bucketName, template = "cc-estimates-pdf", instances, docTypeExt = "pdf", options = {}) {
	return refreshCredentials().then(async () => {
		console.log(instances);
		const requestedEstimateValue = options && typeof options.estimateValue === "string"
			? options.estimateValue.trim()
			: "";
		const requestedPricingMode = normalizePricingMode(options && options.pricingMode);
		const retailPricingConfig = options && options.pricingModeConfig;
		const isRetailPrint = requestedPricingMode === PRICING_MODE_RETAIL;
		const hasCurrentDraft = Boolean(
			options
			&& Object.prototype.hasOwnProperty.call(options, "currentDraft")
		);
		const currentDraft = hasCurrentDraft
			? normalizeEstimatePrintCurrentDraft(options.currentDraft)
			: null;

		const s3 = new AWS.S3({ useDualStack: true });

		state.set(["appState", "status", "showSpinner"], true);
		if (hasCurrentDraft && !currentDraft) {
			failEstimatePrint(
				"Print Estimate failed",
				"The current pricing draft is incomplete or invalid. Reload Price List and try again."
			);
		}

		if (isRetailPrint && !hasRetailTiersConfig(retailPricingConfig)) {
			failEstimatePrint(
				"Print Retail Estimate failed",
				"Retail pricing is unavailable. Reload the Estimate Manager and try again."
			);
		}

		if (!Array.isArray(instances) || instances.length !== 1) {
			failEstimatePrint(
				"Print Estimates failed",
				"Please select exactly one job for the estimates report."
			);
		}

		const allEstimates = {};
		const newInstances = [];
		let retailCustomerName = "";
		const prepareInvoiceItemsForEstimatePrint = (invoiceItems = []) => {
			const normalizedInvoiceItems = normalizeInvoiceItemsMetadata(invoiceItems);
			if (!isRetailPrint) {
				return projectCustomerPricingPayload(normalizedInvoiceItems);
			}
			return projectCustomerPricingPayload(applyPricingModeToInvoiceItems(
				Array.isArray(normalizedInvoiceItems) ? normalizedInvoiceItems : [],
				PRICING_MODE_RETAIL,
				retailPricingConfig
			));
		};

		for (let i = 0; i < instances.length; i++) {
			const instanceSearchData = instances[i];
			let cloudActivityData = instanceSearchData;
			retailCustomerName = getActivityItemValueById(instanceSearchData, "jobNumber") || retailCustomerName;
			let checklistEstimates = Array.isArray(instanceSearchData.estimates) ? instanceSearchData.estimates : [];
			let checklistInvoiceItems = Array.isArray(instanceSearchData.invoiceItems) ? instanceSearchData.invoiceItems : [];
			let selectedValue = typeof instanceSearchData.selectedValue === "string" ? instanceSearchData.selectedValue : "";
			let checklistJobDetails = getEstimateJobDetailsForPrint(instanceSearchData.jobDetails || {});

			try {
				if (instanceSearchData?.url) {
					let instanceData = await s3.getObject({ Bucket: env.s3.contentBucket, Key: instanceSearchData.url }).promise();
					instanceData = JSON.parse(instanceData.Body.toString());
					instanceData = normalizeActivity(instanceData);
					instanceData = normalizePricingMetadataForPrint(instanceData);
					cloudActivityData = instanceData;

					checklistEstimates = Array.isArray(instanceData.estimates) ? instanceData.estimates : checklistEstimates;
					checklistInvoiceItems = pickFirstNonEmptyInvoiceItems(
						getActivePricingContractInvoiceItems(instanceData.pricingContractProto),
						Array.isArray(instanceData.invoiceItems) ? instanceData.invoiceItems : null,
						checklistInvoiceItems
					);
					selectedValue = typeof instanceData.selectedValue === "string" ? instanceData.selectedValue : selectedValue;
					checklistJobDetails = getEstimateJobDetailsForPrint(instanceData);
					retailCustomerName = getActivityItemValueById(instanceData, "jobNumber") || retailCustomerName;
				}
			} catch (err) {
				console.error("Unable to hydrate estimate instance from S3, falling back to search hit data", instanceSearchData?.url, err);
			}

			if (currentDraft) {
				const activityWithCurrentDraft = applyEstimatePrintCurrentDraft(cloudActivityData, currentDraft);
				checklistEstimates = activityWithCurrentDraft.estimates;
				checklistInvoiceItems = activityWithCurrentDraft.invoiceItems;
				selectedValue = activityWithCurrentDraft.selectedValue;
				checklistJobDetails = getEstimateJobDetailsForPrint(activityWithCurrentDraft.jobDetails);
			}

			const existingCount = newInstances.length;
			const estimatesForPrint = getEstimatePrintOptions(checklistEstimates, requestedEstimateValue);
			estimatesForPrint.forEach((estimate, estimateIndex) => {
				const estimateInvoiceItems = Array.isArray(estimate?.invoiceItems) ? estimate.invoiceItems : [];
				const estimateJobDetails = getEstimateJobDetailsForPrint(estimate);

				if (estimateInvoiceItems.length > 0) {
					newInstances.push({
						instanceId: instanceSearchData.instanceId,
						estimateId: estimate?.id || estimate?.value || `${instanceSearchData.instanceId}-${estimateIndex}`,
						sessionNameResolved: instanceSearchData.sessionNameResolved,
						estimateName: resolveEstimateNameForPrint(estimate),
						instructions: estimateJobDetails.instructions,
						description: estimateJobDetails.description,
						jobDescription: estimateJobDetails.description,
						notes: estimateJobDetails.notes,
						jobNotes: estimateJobDetails.notes,
						invoiceItems: prepareInvoiceItemsForEstimatePrint(estimateInvoiceItems)
					});
				}
			});

			const isOriginalEstimateRequested = requestedEstimateValue.toLowerCase() === "original";
			const canUseRootInvoiceFallback = !requestedEstimateValue || isOriginalEstimateRequested;
			if (canUseRootInvoiceFallback && newInstances.length === existingCount && Array.isArray(checklistInvoiceItems) && checklistInvoiceItems.length > 0) {
				const selectedEstimate = Array.isArray(checklistEstimates) && selectedValue !== ""
					? checklistEstimates.find((estimate) => estimate?.value === selectedValue)
					: null;
				const estimateJobDetails = isOriginalEstimateRequested
					? checklistJobDetails
					: (selectedEstimate ? getEstimateJobDetailsForPrint(selectedEstimate) : checklistJobDetails);

				newInstances.push({
					instanceId: instanceSearchData.instanceId,
					estimateId: `${instanceSearchData.instanceId}-original`,
					sessionNameResolved: instanceSearchData.sessionNameResolved,
					estimateName: isOriginalEstimateRequested
						? "Original Estimate"
						: resolveFallbackEstimateNameForPrint({
							estimates: checklistEstimates,
							selectedValue
						}),
					instructions: estimateJobDetails.instructions,
					description: estimateJobDetails.description,
					jobDescription: estimateJobDetails.description,
					notes: estimateJobDetails.notes,
					jobNotes: estimateJobDetails.notes,
					invoiceItems: prepareInvoiceItemsForEstimatePrint(checklistInvoiceItems)
				});
			}

			if (requestedEstimateValue && newInstances.length === existingCount) {
				failEstimatePrint(
					"Print Estimate failed",
					"The selected estimate is no longer available or does not contain any line items."
				);
			}
		}

		if (newInstances.length === 0) {
			failEstimatePrint("Print Estimates failed", "No estimates were found.");
		}

		allEstimates.instances = newInstances;
		allEstimates.invoiceId = resolveEstimateReportJobId(instances, {
			allowSessionNameFallback: !isRetailPrint
		});

		const printFilename = template + "-" + new Date().toISOString();
		const printConfig = docTypeExt
			? { "docTypeExt": docTypeExt, "preview": true, "preferredPreviewHost": "searchHistory" }
			: { "preview": true, "preferredPreviewHost": "searchHistory" };

		if (isRetailPrint) {
			let retailReportData;
			try {
				retailReportData = buildRetailEstimateReportData({
					invoiceId: allEstimates.invoiceId,
					customerName: retailCustomerName,
					instances: newInstances
				});
			} catch (err) {
				failEstimatePrint(
					"Print Retail Estimate failed",
					err && err.message ? err.message : "The retail estimate could not be prepared."
				);
			}

			state.set(["appState", "status", "showSpinner"], false);
			await printInlineTemplate(
				printFilename,
				retailReportData,
				RETAIL_ESTIMATE_JSREPORT_TEMPLATE,
				printConfig
			);
			return {
				success: true,
				estimateCount: newInstances.length,
				estimateValue: requestedEstimateValue,
				pricingMode: requestedPricingMode,
				usedCurrentDraft: Boolean(currentDraft)
			};
		}

		let customerMap = state.get(["appState", "customerMap"]);
		if (env.stage === "dev" && !customerMap) customerMap = {};
		let customerIdentityMaps = null;
		const useCurrentJabCustomers = isJabOrganization(getOrgId());

		if (useCurrentJabCustomers) {
			const customers = await fetchFreshJabCustomers();
			customerIdentityMaps = buildCustomerIdentityMaps(customers);
			customerMap = customerIdentityMaps.customerMap;
			state.set(["appState", "customers"], customers);
			state.set(["appState", "customerMap"], customerMap);
			state.set(["appState", "customerIdentityMaps"], customerIdentityMaps);
		} else if (env.stage !== "dev" && customerMap === null) {
			state.set(["appState", "documents", "showSpinner"], true);
			state.set(["appState", "status", "showSpinner"], true);
			state.set(["appState", "editor", "showSpinner"], true);

			const urlCustomers = "https://api.ambifi.com/artifacts/googleScriptResult?sheetId=1939X5GjBmYFgnK14tHxI2LzfapbqIceN_VYvM0Bvmdo";

			const responseCustomers = await fetch(urlCustomers, {
				method: "GET",
				headers: {
					"Authorization": getJwtToken()
				}
			});
			if (!responseCustomers.ok) {
				const message = "An error has occured: " + responseCustomers.status;
				alert(message);
			}

			const responseCustomersJson = await responseCustomers.json();

			customerMap = arrayToMap(responseCustomersJson, "customerName");
		}

		allEstimates.customer = useCurrentJabCustomers
			? resolveInvoiceCustomerIdentityOrThrow(customerIdentityMaps, instances)
			: customerMap[instances[0].company];
		allEstimates.customerJobNumber = String(
			instances[0].sessionNameResolved || instances[0].sessionName || instances[0].jobIdString || instances[0].jobId || ""
		).trim();
		allEstimates.displayNamesMap = utils.getDisplayNamesMap();

		console.log("arrEstimates", { data: allEstimates }, JSON.stringify(allEstimates).length);

		state.set(["appState", "status", "showSpinner"], false);

		await printTemplate(
			printFilename,
			allEstimates,
			template,
			printConfig
		);
		return {
			success: true,
			estimateCount: newInstances.length,
			estimateValue: requestedEstimateValue,
			pricingMode: requestedPricingMode,
			usedCurrentDraft: Boolean(currentDraft)
		};
	}).catch((err) => {
		state.set(["appState", "documents", "showSpinner"], false);
		state.set(["appState", "status", "showSpinner"], false);
		state.set(["appState", "editor", "showSpinner"], false);

		console.error(err);
		if (!err || !err.estimatePrintUserNotified) {
			showError2("Print Estimates failed", err);
		}
		if (options && options.rejectOnError === true) {
			throw err;
		}
		return {
			success: false,
			error: err && err.message ? err.message : "The estimates report could not be prepared."
		};
	});
}

async function buildInvoiceReportDataFromInstances(instances = [], { docTypeExt, shippingTotal, totalValue, shippingDetails } = {}) {
	console.log(instances);

	const s3 = new AWS.S3({ useDualStack: true });
	const statusItems = Array.isArray(state.get(["appState", "statusItems"])) ? state.get(["appState", "statusItems"]) : [];
	const invoiceCreatedAt = new Date();
	const normalizedShippingDetails = normalizeInvoiceShippingDetails({ shippingTotal, shippingDetails });
	const ext = docTypeExt ? docTypeExt : "";
	const includeReferenceData = shouldIncludeInvoiceReferenceData(ext);

	const allInvoices = {};

	const newInstances = [];
	let invoiceSubtotal = 0;
	let insuredValueTotal = 0;
	let declaredValueTotal = 0;

	// Loop through instances and get full content for each instance
	for (let i = 0; i < instances.length; i++) {
		const instanceSearchData = instances[i];
		const currentStatusItem = statusItems.find((item) => item && item.instanceId === instanceSearchData.instanceId) || {};
		let hydratedInstanceData = null;
		let checklistInvoiceItems = Array.isArray(instanceSearchData.invoiceItems) ? instanceSearchData.invoiceItems : null;
		let resolvedJobId = [instanceSearchData.jobIdString, instanceSearchData.jobId, currentStatusItem.jobIdString, currentStatusItem.jobId]
			.find((value) => value !== undefined && value !== null && String(value).trim() !== "");
		let resolvedSessionName = [instanceSearchData.sessionNameResolved, instanceSearchData.sessionName, currentStatusItem.sessionNameResolved, currentStatusItem.sessionName]
			.find((value) => value !== undefined && value !== null && String(value).trim() !== "");

		try {
			if (instanceSearchData?.url) {
				let instanceData = await s3.getObject({ Bucket: env.s3.contentBucket, Key: instanceSearchData.url }).promise();
				instanceData = JSON.parse(instanceData.Body.toString());
				instanceData = normalizeActivity(instanceData);
				instanceData = normalizePricingMetadataForPrint(instanceData);
				hydratedInstanceData = instanceData;

				checklistInvoiceItems = pickFirstNonEmptyInvoiceItems(
					getActivePricingContractInvoiceItems(instanceData.pricingContractProto),
					Array.isArray(instanceData.invoiceItems) ? instanceData.invoiceItems : null,
					checklistInvoiceItems
				);

				resolvedJobId = resolvedJobId || [instanceData.jobIdString, instanceData.jobId]
					.find((value) => value !== undefined && value !== null && String(value).trim() !== "");
				resolvedSessionName = resolvedSessionName || [instanceData.sessionNameResolved, instanceData.sessionName, instanceData.name]
					.find((value) => value !== undefined && value !== null && String(value).trim() !== "");
			}
		} catch (err) {
			console.error("Unable to hydrate invoice instance from S3, falling back to search hit data", instanceSearchData?.url, err);
		}

		if (Array.isArray(checklistInvoiceItems) && checklistInvoiceItems.length > 0) {
			const activityForInvoiceFields = hydratedInstanceData || instanceSearchData || currentStatusItem || {};
			const invoiceItems = normalizeInvoiceItemsForReport(checklistInvoiceItems, { includeMetadata: includeReferenceData });
			const invoiceTotal = computeInvoiceReportItemsTotal(invoiceItems);
			const invoiceTotalString = formatPricingTotalCurrency(invoiceTotal);
			const insuredValueInfo = resolveInvoiceInsuredValue(activityForInvoiceFields);
			const declaredValueInfo = resolveInvoiceDeclaredValue(activityForInvoiceFields);
			const declaredValueNumber = roundInvoiceAmount(insuredValueInfo.insuredValueNumber + declaredValueInfo.declaredValueNumber);
			const declaredValueValues = []
				.concat(insuredValueInfo.insuredValueValues || [])
				.concat(declaredValueInfo.declaredValueValues || []);
			const declaredValueString = formatPricingTotalCurrency(declaredValueNumber);
			const declaredValue = declaredValueValues.join(", ");
			const additionalValueNumber = declaredValueNumber;
			const totalValueNumber = roundInvoiceAmount(invoiceTotal + additionalValueNumber);

			invoiceSubtotal = roundInvoiceAmount(invoiceSubtotal + invoiceTotal);
			insuredValueTotal = roundInvoiceAmount(insuredValueTotal + insuredValueInfo.insuredValueNumber);
			declaredValueTotal = roundInvoiceAmount(declaredValueTotal + declaredValueNumber);

			newInstances.push({
				"instanceId": instanceSearchData.instanceId,
				"jobId": resolvedJobId || "",
				"sessionNameResolved": resolvedSessionName || "",
				"customerJobNumber": resolvedSessionName || "",
				"invoiceItems": invoiceItems,
				"invoiceTotal": invoiceTotal,
				"invoiceTotalString": invoiceTotalString,
				"declaredValue": declaredValue,
				"declaredValueValues": declaredValueValues,
				"declaredValueNumber": declaredValueNumber,
				"declaredValueString": declaredValueString,
				"additionalValue": additionalValueNumber,
				"additionalValueString": formatPricingTotalCurrency(additionalValueNumber),
				"totalValue": totalValueNumber,
				"totalValueString": formatPricingTotalCurrency(totalValueNumber)
			});
		}
	}

	allInvoices.instances = newInstances;

	let priceListMap = includeReferenceData ? state.get(["appState", "priceListMap"]) : null;
	if (env.stage === "dev" && !priceListMap) priceListMap = {};
	let customerMap = state.get(["appState", "customerMap"]);
	if (env.stage === "dev" && !customerMap) customerMap = {};
	let customerIdentityMaps = null;
	const useCurrentJabCustomers = isJabOrganization(getOrgId());

	if (env.stage !== "dev" && priceListMap === null && includeReferenceData) {
		// Need to add price list as well
		// const url = "https://script.google.com/macros/s/AKfycbzxNBUz66mYRfb1GtCwXBLVCg4Fi3cLFwO-YpVP2CbueQuaZI3RmayvN1zi4bLAShYz/exec?sheetId=1ooKByEUqSD900Ph7xQP_lUIgISKrsgsPU7INipt27U8&sheetName=Price%20List";
		const url = "https://public-assets.ambifi.com/projects/jab/priceSheets/priceSheet.json";

		const response = await fetch(url);
		if (!response.ok) {
			const message = "An error has occured: " + response.status;
			alert(message);
		}

		const responseJson = await response.json();

		priceListMap = arrayToMap(responseJson.priceSheet, "id");

		state.set(["appState", "priceListMap"], priceListMap);
	}

	if (useCurrentJabCustomers) {
		const customers = await fetchFreshJabCustomers();
		customerIdentityMaps = buildCustomerIdentityMaps(customers);
		customerMap = customerIdentityMaps.customerMap;
		state.set(["appState", "customers"], customers);
		state.set(["appState", "customerMap"], customerMap);
		state.set(["appState", "customerIdentityMaps"], customerIdentityMaps);
	} else if (env.stage !== "dev" && customerMap === null) {
		// Need to add price list as well
		const urlCustomers = "https://api.ambifi.com/artifacts/googleScriptResult?sheetId=1939X5GjBmYFgnK14tHxI2LzfapbqIceN_VYvM0Bvmdo";

		const responseCustomers = await fetch(urlCustomers, {
			method: "GET",
			headers: {
				"Authorization": getJwtToken()
			}
		});
		if (!responseCustomers.ok) {
			const message = "An error has occured: " + responseCustomers.status;
			alert(message);
		}

		const responseCustomersJson = await responseCustomers.json();

		customerMap = arrayToMap(responseCustomersJson, "customerName");
		state.set(["appState", "customerMap"], customerMap);
	}

	if (includeReferenceData) {
		allInvoices.priceListMap = priceListMap;
	}

	// Pass customer object
	const firstInstance = instances[0] || {};
	const customer = useCurrentJabCustomers
		? resolveInvoiceCustomerIdentityOrThrow(customerIdentityMaps, instances)
		: (customerMap && firstInstance.company ? customerMap[firstInstance.company] : null);
	console.log("CUSTOMER", customer);
	allInvoices.customer = includeReferenceData ? (customer || {}) : normalizeInvoiceCustomerForReport(customer || {});

	if (hasInvoiceShippingDetailValue(normalizedShippingDetails)) {
		allInvoices.shipping = normalizedShippingDetails;
		allInvoices.shippingTotal = normalizedShippingDetails.totalNumber;
		allInvoices.shippingTotalString = normalizedShippingDetails.totalString;
	}

	const additionalValueTotal = declaredValueTotal;
	const computedTotalValue = roundInvoiceValueToNextHundred(invoiceSubtotal + additionalValueTotal);
	const resolvedTotalValue = hasInvoiceFieldValue(totalValue)
		? roundInvoiceValueToNextHundred(parseInvoiceCurrencyValue(totalValue))
		: computedTotalValue;
	allInvoices.invoiceSubtotal = invoiceSubtotal;
	allInvoices.invoiceSubtotalString = formatPricingTotalCurrency(invoiceSubtotal);
	allInvoices.insuredValueTotal = insuredValueTotal;
	allInvoices.insuredValueTotalString = formatPricingTotalCurrency(insuredValueTotal);
	allInvoices.declaredValueTotal = declaredValueTotal;
	allInvoices.declaredValueTotalString = formatPricingTotalCurrency(declaredValueTotal);
	allInvoices.additionalValueTotal = additionalValueTotal;
	allInvoices.additionalValueTotalString = formatPricingTotalCurrency(additionalValueTotal);
	allInvoices.totalValue = resolvedTotalValue;
	allInvoices.totalValueString = formatPricingTotalCurrency(resolvedTotalValue);
	allInvoices.createdAt = invoiceCreatedAt.toISOString();
	allInvoices.date = `${invoiceCreatedAt.getMonth() + 1}/${invoiceCreatedAt.getDate()}/${invoiceCreatedAt.getFullYear()}`;

	if (includeReferenceData) {
		allInvoices.displayNamesMap = utils.getDisplayNamesMap();
	}

	return allInvoices;
}

export function buildInvoiceReportData(instances = [], options = {}) {
	return refreshCredentials().then(() => buildInvoiceReportDataFromInstances(instances, options));
}

function buildInvoiceJobMetadata(allInvoices = {}) {
	const shipping = allInvoices.shipping || normalizeInvoiceShippingDetails({ shippingTotal: allInvoices.shippingTotal });
	const invoiceRecord = {
		invoiceId: allInvoices.invoiceId || "",
		createdAt: allInvoices.createdAt || "",
		date: allInvoices.date || "",
		invoiceSubtotal: allInvoices.invoiceSubtotal || 0,
		invoiceSubtotalString: allInvoices.invoiceSubtotalString || "",
		totalValue: allInvoices.totalValue || 0,
		totalValueString: allInvoices.totalValueString || "",
		shipping
	};

	return {
		invoiceRecord,
		latestFields: {
			invoiceId: allInvoices.invoiceId || "",
			lastInvoiceId: allInvoices.invoiceId || "",
			lastInvoiceDate: allInvoices.date || "",
			lastInvoiceCreatedAt: allInvoices.createdAt || "",
			lastInvoiceTotalValue: allInvoices.totalValue || 0,
			lastInvoiceTotalValueString: allInvoices.totalValueString || "",
			lastInvoiceShipping: shipping,
			shippingTotal: shipping.totalNumber || 0,
			shippingTotalString: shipping.totalString || formatPricingTotalCurrency(shipping.totalNumber || 0),
			shippingCarrier: shipping.carrier || "",
			shippingService: shipping.service || "",
			shippingTrackingNumbers: shipping.trackingNumbers || [],
			shippingTrackingNumbersString: shipping.trackingNumbersString || "",
			shippingDate: shipping.shipDate || "",
			shippingNotes: shipping.notes || ""
		}
	};
}

function mergeInvoiceJobMetadata(instanceData = {}, allInvoices = {}) {
	const { invoiceRecord, latestFields } = buildInvoiceJobMetadata(allInvoices);
	const existingInvoices = Array.isArray(instanceData.invoices) ? instanceData.invoices : [];
	const invoiceId = invoiceRecord.invoiceId;
	const invoices = existingInvoices
		.filter((invoice) => !invoiceId || invoice?.invoiceId !== invoiceId)
		.concat(invoiceRecord);
	const invoiceIds = _.uniq([]
		.concat(Array.isArray(instanceData.invoiceIds) ? instanceData.invoiceIds : [])
		.concat(invoices.map((invoice) => invoice?.invoiceId).filter(Boolean)));

	return {
		...instanceData,
		...latestFields,
		invoiceIds,
		invoices
	};
}

async function saveInvoiceMetadataForInstances(bucketName, instances = [], allInvoices = {}) {
	if (!allInvoices || !allInvoices.invoiceId || !Array.isArray(instances) || instances.length === 0) {
		return;
	}

	for (let i = 0; i < instances.length; i += 1) {
		const instanceSearchData = instances[i] || {};
		if (!instanceSearchData.url) {
			continue;
		}

		const instanceData = await getObject(bucketName, instanceSearchData.url);
		const nextInstanceData = mergeInvoiceJobMetadata(instanceData, allInvoices);
		await saveInstance(bucketName, instanceSearchData.url, nextInstanceData);
	}
}

export async function printInstancesForInvoice(tree, bucketName, template = "ambifi-activity-group-tasks", instances, docTypeExt, shippingTotal, totalValue, shippingDetails, invoiceRequestId) {
	try {
		await refreshCredentials();
		state.set(["appState", "status", "showSpinner"], true);

		let allInvoices = await buildInvoiceReportDataFromInstances(instances, { docTypeExt, shippingTotal, totalValue, shippingDetails });

		console.log("arrInstances", { data: allInvoices }, JSON.stringify(allInvoices).length);

		// if not printing a task report which we don't want to publish. Should probably pass type of report in instead of extension.
		const ext = docTypeExt ? docTypeExt : "";
		if (ext !== "xlsx") {
			const publication = await publishActivityForPrintInvoice(allInvoices, invoiceRequestId);
			allInvoices = publication.allInvoices;
			await saveInvoiceMetadataForInstances(bucketName, instances, allInvoices);
		}
		const printFilename = buildInvoicePrintFilename(template, allInvoices.invoiceId);

		state.set(["appState", "status", "showSpinner"], false);

		await printTemplate(
			printFilename,
			allInvoices,
			template,
			docTypeExt
				? { "docTypeExt": docTypeExt, "preview": true, "preferredPreviewHost": "searchHistory" }
				: { "preview": true, "preferredPreviewHost": "searchHistory" }
		);
		return allInvoices;
	} catch (err) {
		state.set(["appState", "documents", "showSpinner"], false);
		state.set(["appState", "status", "showSpinner"], false);
		state.set(["appState", "editor", "showSpinner"], false);

		console.error(err);
		showError2("Print Instances failed", err);
		if (_.isObject(err)) {
			err.ambifiPrintErrorDisplayed = true;
		}
		throw err;
	}
}

export function reprintInstances(allInstances, template = "ambifi-activity-group") {
	refreshCredentials().then(async () => {
		console.log(allInstances);

		console.log("arrInstances", { data: allInstances }, JSON.stringify(allInstances).length);

		let printFilename = template + "-" + new Date().toISOString();

		state.set(["appState", "status", "showSpinner"], false);

		printTemplate(printFilename, { data: { allInstances } }, template, { "docTypeExt": "xlsx" });
	}).catch((err) => {
		console.error(err);
		showError2("Print Instances failed", err);
	});
}

async function prepareInstancesReport(bucketName, instances = [], instanceSearchDataOnly = false) {
	await refreshCredentials();
	const sortedInstances = (Array.isArray(instances) ? instances : []).slice().sort((a, b) => Number(a.createdDateTime || 0) - Number(b.createdDateTime || 0));
	const s3 = new AWS.S3({ useDualStack: true });
	const resolvedBucketName = bucketName || env.s3.contentBucket;

	const arrInstances = [];
	// Loop through instances and get full content for each instance.
	for (let i = 0; i < sortedInstances.length; i++) {
		const instanceSearchData = sortedInstances[i];
		let instanceData = null;
		if (!instanceSearchDataOnly) {
			try {
				instanceData = await s3.getObject({ Bucket: resolvedBucketName, Key: instanceSearchData.url }).promise();
				instanceData = JSON.parse(instanceData.Body.toString());
				// Should convert to make sure has at least one list and one section and set proper type.
				instanceData = normalizeActivity(instanceData);
				instanceData = setFullSessionName(instanceData);
				recurseReplaceSpeeds(instanceData.children);
				instanceData = prepareSharedTaskIdentityReportFields(instanceData);
			} catch (error) {
				const sourceLabel = instanceSearchData.name || instanceSearchData.checklistName || instanceSearchData.instanceId || instanceSearchData.objectID || "activity record";
				const reason = error && error.message ? error.message : "Unknown source error";
				throw new Error(`Could not prepare ${sourceLabel} for the report: ${reason}`);
			}
		}

		arrInstances.push(instanceData ? {
			instanceSearchData,
			instanceData
		} : {
			instanceSearchData
		});
	}

	return arrInstances;
}

export async function renderInstancesReport(bucketName, template = "ambifi-activity-group", instances = [], instanceSearchDataOnly = false, options = {}) {
	const arrInstances = await prepareInstancesReport(bucketName, instances, instanceSearchDataOnly);
	const filenamePrefix = _.trim(options.filenamePrefix) || template;
	const response = await renderTemplateResponse({ data: arrInstances }, template, { "docTypeExt": "xlsx" });

	return {
		fileName: `${filenamePrefix}.xlsx`,
		instances: arrInstances,
		response
	};
}

export async function printInstancesReport(bucketName, template = "ambifi-activity-group", instances = [], instanceSearchDataOnly = false, options = {}) {
	state.set(["appState", "status", "showSpinner"], true);
	try {
		const arrInstances = await prepareInstancesReport(bucketName, instances, instanceSearchDataOnly);
		console.log("arrInstances", { data: arrInstances }, JSON.stringify(arrInstances).length);
		const filenamePrefix = _.trim(options.filenamePrefix) || template;
		const printFilename = `${filenamePrefix}-${new Date().toISOString()}`;

		state.set(["appState", "status", "showSpinner"], false);
		await printTemplate(printFilename, { data: arrInstances }, template, { "docTypeExt": "xlsx" });
		return arrInstances;
	} finally {
		state.set(["appState", "status", "showSpinner"], false);
	}
}

export function printInstances(tree, bucketName, template = "ambifi-activity-group", instances, instanceSearchDataOnly = false) {
	return printInstancesReport(bucketName, template, instances, instanceSearchDataOnly).catch((err) => {
		state.set(["appState", "status", "showSpinner"], false);

		console.error(err);
		showError2("Print Instances failed", err);
	});
}

export function printInstance(tree, bucketName, fileName, template = "ambifi-lists-form-remove-empty-values", hit, generateSignedUrls = true) {
	refreshCredentials().then(() => {
		state.set(["appState", "status", "showSpinner"], true);

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${fileName}` }, async (err, data) => {
			if (err) {
				state.set(["appState", "status", "showSpinner"], false);
				showError("Unable to get checklist", err);
			} else {
				// Set previewChecklist
				let jsonChecklist = JSON.parse(data.Body.toString());

				if (template === "cc-label") {
					console.log("HIT", hit);

					// 					const activitySummary = utils.summarizeActivityContent(jsonChecklist);

					// 					const prompt = `You are a professional custom jewelry production assistant. Your task is to take raw job submission data from a customer form and convert it into a clear, concise summary for internal production teams. This summary should be formatted cleanly for a job board, with consistent section headers and organized details.

					// 🧠 Be intelligent and context-aware:
					// - **Omit generic field prompts** and repeated or unnecessary text.
					// - **Parse** stones and setting data into structured bullet points.
					// - Use **plain language** for special instructions.
					// - **Identify metal types and karats cleanly**, even if multiple are listed.
					// - **Use bullet formatting** where appropriate, and group related information logically.

					// 💡 DO NOT include fields already visible elsewhere in the interface (e.g. due date, customer name, or order ID) unless explicitly asked.

					// 🔧 Format your output as follows (omit any irrelevant sections):

					// ---

					// ### Services
					// [List only what is selected, clarify casting metal if known]

					// ---

					// ### Item Details
					// [Example: Ring - Size 6.5, Finish: High Polish]

					// ---

					// ### Stones
					// Customer Supplied:
					// - Primary: [Shape] - [Dimensions], Setting: [Setting Type]
					// - Secondary: [Details or “None”]

					// Converge Supplied:
					// - [If any, same format]

					// ---

					// ### Instructions
					// [Condensed, readable instructions for execution - highlight any special design or fabrication info clearly]

					// ---

					// ### Stamp
					// [Brand name or “My trademark/logo on file”]

					// ---

					// ### Shipping
					// [Shipping method + Insured value or Pickup]

					// ---

					// Now apply this formatting to the following submission:
					// ===
					// ${activitySummary}
					// `;
					// 					const chatCompletionsTemplate = {
					// 						messages: [
					// 							{ role: "system", content: "You are a helpful assistant." },
					// 							{ role: "user", content: prompt }
					// 						],
					// 						model: "gpt-4-turbo"
					// 					};

					// 					const chatResponse = await getChatCompletions(JSON.stringify(chatCompletionsTemplate));


					// const chatCompletionsTemplate2 = {
					// 	messages: [
					// 		{ role: "system", content: "You are a helpful assistant." },
					// 		{ role: "user", content: `Can you create a super brief description of not more than 15 words from the following? ${chatResponse}` }
					// 	],
					// 	model: "gpt-4-turbo"
					// };


					// const chatResponse2 = await getChatCompletions(JSON.stringify(chatCompletionsTemplate2));

					// 					debugger;

					const labelDescriptionValues = utils.getValues(jsonChecklist, "labelDescription");
					const labelNotesValues = utils.getValues(jsonChecklist, "labelNotes");
					const labelInstructionsValues = utils.getValues(jsonChecklist, "labelInstructions");
					const checklistInvoiceItems = getActivePricingContractInvoiceItems(jsonChecklist.pricingContractProto)
						|| (Array.isArray(jsonChecklist.invoiceItems) ? jsonChecklist.invoiceItems : null)
						|| (Array.isArray(hit.invoiceItems) ? hit.invoiceItems : []);

					jsonChecklist = {
						sessionName: hit.sessionNameResolved,
						jobId: hit.jobId,
						jobIdString: hit.jobIdString,
						projectId: hit.projectId,
						instanceId: hit.instanceId,
						newInstanceId: hit.instanceId,
						company: hit.company,
						projectGroup: hit.projectGroup,
						displayName: hit.displayName,
						profilePicture: getSignedAssetUrl(hit.profilePicture),
						dueDate: hit.dueDate,
						createdDateTimeIsoString: hit.createdDateTimeIsoString,
						lastUpdatedDateTimeIsoString: hit.lastUpdatedDateTimeIsoString,
						dueDateIsoString: hit.dueDateIsoString,
						workflowStatus: hit.workflowStatus,
						thumbnailImage1: utils.getFirstMediaAttachment(hit.notes),
						thumbnailImage2: utils.getSecondMediaAttachment(hit.notes),
						tasks: normalizeInvoiceItemsMetadata(checklistInvoiceItems),
						briefDescription: jsonChecklist.jobDetails?.description || (labelDescriptionValues.length > 0 ? utils.summarizeValues(labelDescriptionValues) : ""),
						instructions: jsonChecklist.jobDetails?.instructions || (labelInstructionsValues.length > 0 ? labelInstructionsValues[0].value : ""),
						notes: jsonChecklist.jobDetails?.notes || (labelNotesValues.length > 0 ? labelNotesValues[0].value : "")
					};
				} else {
					if (generateSignedUrls) {
						jsonChecklist = await publishActivityToSignedUrls(jsonChecklist, fileName);
					}
					// Should convert to make sure has at least one list and one section and set proper type
					jsonChecklist = normalizeActivity(jsonChecklist);
					jsonChecklist = setFullSessionName(jsonChecklist);

					recurseReplaceSpeeds(jsonChecklist.children);
					recurseConvertChecklistToMarkdown(jsonChecklist.children, false, { checklist: jsonChecklist });
					jsonChecklist = prepareSharedTaskIdentityReportFields(jsonChecklist);
				}

				jsonChecklist = normalizePricingMetadataForPrint(jsonChecklist);

				let printFilename = "";
				let lastUpdated = "";

				if (template === "cc-label") {
					lastUpdated = hit.sessionNameResolved;
					printFilename = hit.name + " - " + lastUpdated;
				} else {
					if (jsonChecklist.hasOwnProperty("history") && jsonChecklist.history.length > 0) {
						lastUpdated = jsonChecklist.history[jsonChecklist.history.length - 1].timestamp;
					}

					if (lastUpdated !== "") {
						printFilename = jsonChecklist.name + " - " + lastUpdated;

					} else {
						printFilename = jsonChecklist.name;
					}
				}


				state.set(["appState", "status", "showSpinner"], false);

				const printConfig = { preview: true, preferredPreviewHost: "searchHistory" };
				printTemplate(printFilename, jsonChecklist, template, printConfig);
			}
		});
	}).catch((err) => {
		state.set(["appState", "status", "showSpinner"], false);

		console.error(err);
		showError2("Print Instance failed", err);
	});
}

// export function getAllChecklists(tree) {
// 	return refreshCredentials().then(({ cognitoUser }) => {
// 		const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get());

// 		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json" , ResponseCacheControl: "no-cache" } });

// 		return getChecklists(cognitoUser.getUsername(), keyPrefix, bucket, false).then(() => {
// 			hideLoader(tree);
// 		}).catch((err) => {
// 			actions.postMessage({ "method": "error", "message": `Error in call to getChecklists: ${err}` });
// 			hideLoader(tree);
// 			throw err;
// 		});

// 	}).catch((err) => {
// 		console.error(err);
// 		hideLoader(tree);
// 		showError2("Get checklists failed", err);

// 		actions.postMessage({ "method": "error", "message": `Error in getAllChecklists; ${err}` });
// 		throw err;
// 	});
// }


// Beginning of reassign activity.
export async function reassignActivity(activityUrl, dstKeyPrefix, displayName) {
	return new Promise((resolve, reject) => {
		try {
			showPlayerSpinner();

			const srcPrefix = activityUrl.replace(".json", "");
			const activityId = srcPrefix.split("/")[1];

			// Let's add some content to the activity for log of assignees
			refreshCredentials().then(() => {
				request.get(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.artifacts.transferActivity(activityId, dstKeyPrefix)}`)
					.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
					.then(res => {
						// Make sure get back success

						hidePlayerSpinner();
						state.set(["appState", "reassignModal", "show"], false);

						showSuccessToast("Successfully reassigned the activity to " + displayName + ".");

						// showSuccess("Reassign", "Successfully reassigned the activity to " + displayName + ".");
						resolve();
					}).catch(err => {
						hidePlayerSpinner();
						state.set(["appState", "reassignModal", "show"], false);
						console.error(err);
						reject(err);
					});
			}).catch((err) => {
				hidePlayerSpinner();
				state.set(["appState", "reassignModal", "show"], false);
				console.error(err);
				showError("Failed to reassign the activity.", err);

				reject(err);
			});
		} catch (err) {
			hidePlayerSpinner();
			state.set(["appState", "reassignModal", "show"], false);
			console.error(err);
			showError("Failed to reassign the activity.", err);

			reject(err);
		}
	});
}

// export function reassignActivity(activityUrl, dstKeyPrefix, displayName) {
// 	return new Promise((resolve, reject) => {
// 		try {
// 			state.set(["appState", "status", "showSpinner"], true);

// 			const userIdentityId = state.get(["user", "identityId"]);

// 			// Let's add some content to the activity for log of assignees
// 			refreshCredentials().then(() => {
// 				state.set(["appState", "status", "showSpinner"], true);

// 				// Get source activity
// 				const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
// 				bucket.getObject({ Key: `${activityUrl}` }, async (err, data) => {
// 					if (err) {
// 						state.set(["appState", "status", "showSpinner"], false);
// 						showError("Unable to get activity", err);

// 						reject(err);
// 					} else {
// 						let jsonActivity = JSON.parse(data.Body.toString());

// 						let newActivityUrl = activityUrl.substring(activityUrl.indexOf("/") + 1);
// 						newActivityUrl = dstKeyPrefix + "/" + newActivityUrl;

// 						// Upload to new destination
// 						const params = { Key: `${newActivityUrl}`, ContentType: "application/json", Body: JSON.stringify(jsonActivity) };

// 						console.log("COPY ACTIVITY", `${activityUrl}`, jsonActivity);

// 						bucket.upload(params, async (err) => {
// 							// Replace with notification
// 							if (!err) {
// 								state.set(["appState", "status", "showSpinner"], false);
// 								state.set(["appState", "reassignModal", "show"], false);

// 								showSuccess("Reassign", "Successfully reassigned the activity to " + displayName + ".<br/><br/>NOTE: Sometimes it can take a few seconds so you may need to press the Refresh button to see the result.");
// 								resolve();
// 							} else {
// 								state.set(["appState", "status", "showSpinner"], false);

// 								showError("Failed to reassign the activity.", err.message);

// 								reject(err);
// 							}
// 						});
// 					}
// 				});
// 			}).catch((err) => {
// 				state.set(["appState", "status", "showSpinner"], false);
// 				console.error(err);
// 				showError("Failed to reassign the activity.", err);

// 				reject(err);
// 			});
// 		} catch (err) {
// 			state.set(["appState", "status", "showSpinner"], false);
// 			console.error(err);
// 			showError("Failed to reassign the activity.", err);

// 			reject(err);
// 		}
// 	});
// }

export function reassignInstance(instanceUrl, dstKeyPrefix, displayName, options = {}) {
	const orgId = getOrgId();
	return new Promise((resolve, reject) => {
		try {
			const normalizedDestinationIdentityId = typeof dstKeyPrefix === "string" ? dstKeyPrefix.trim() : "";
			const currentOwnerIdentityId = getCurrentInstanceOwnerIdentityId(instanceUrl);
			if (!currentOwnerIdentityId || !normalizedDestinationIdentityId) {
				const validationError = new Error("The current owner and destination member are required to reassign this job.");
				showError("Reassign", validationError.message);
				reject(validationError);
				return;
			}

			if (currentOwnerIdentityId === normalizedDestinationIdentityId) {
				showError("Reassign", "Sorry, it is already assigned to " + displayName + ".");
				resolve({ reassigned: false, reason: "already-assigned" });
				return;
			}

			let customerIdentitySnapshot = null;
			if (options && options.customerIdentitySnapshot) {
				customerIdentitySnapshot = normalizeCustomerIdentitySnapshot(options.customerIdentitySnapshot);
				if (!isCompleteCustomerIdentitySnapshot(customerIdentitySnapshot)) {
					const identityError = new Error("The selected member does not have a complete customer code, customer GUID, and company name.");
					showError("Reassign", identityError.message);
					reject(identityError);
					return;
				}
			}

			state.set(["appState", "status", "showSpinner"], true);

			// Let's add some content to the activity for log of assignees
			refreshCredentials().then(async () => {
				await assertCurrentJobTarget(instanceUrl, {});
				state.set(["appState", "status", "showSpinner"], true);

				// Get source activity
				const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
				bucket.getObject({ Key: `${instanceUrl}` }, async (err, data) => {
					if (err) {
						state.set(["appState", "status", "showSpinner"], false);
						showError("Unable to get activity", err);

						reject(err);
					} else {
						let jsonInstance = JSON.parse(data.Body.toString());
						jsonInstance.displayName = displayName;

						let newInstanceUrl = instanceUrl.substring(instanceUrl.indexOf("/") + 1);
						newInstanceUrl = normalizedDestinationIdentityId + "/" + newInstanceUrl;

						// Create assigness array if doesn't exist, otherwise push
						if (!jsonInstance.hasOwnProperty("assignees")) {
							jsonInstance.assignees = [];
						}

						const reassignment = buildJobReassignmentEdge({
							timestamp: getUtcTimestamp(),
							identityId: normalizedDestinationIdentityId,
							srcInstanceUrl: instanceUrl,
							dstInstanceUrl: newInstanceUrl,
							customerIdentitySnapshot
						});
						jsonInstance.assignees.push(reassignment);


						// Also need to move userAssets and fix references!!!
						let notes = [];
						utils.recurseExtractNotes(jsonInstance.children, notes, 0, 0);

						for (let i = 0; i < notes.length; i++) {
							let note = notes[i];
							if (note.hasOwnProperty("mediaAttachmentsUrls") && note.mediaAttachmentsUrls.length > 0) {
								for (let j = 0; j < note.mediaAttachmentsUrls.length; j++) {
									try {
										if (note.hasOwnProperty("mediaAttachmentsUrls")) {
											let media = note.mediaAttachmentsUrls[j];

											// copy object
											// Make sure string which woud be url. Storing note objects as well.
											if (typeof media === "string") {
												const srcUrl = media;
												const srcKey = srcUrl.replace("https://s3.amazonaws.com/content.ambifi.com/", "");

												const dstKey = normalizedDestinationIdentityId + "/" + srcKey.substring(srcKey.indexOf("/") + 1);

												console.log(srcKey, dstKey);
												await copyObject(env.s3.contentBucket, srcKey, env.s3.contentBucket, dstKey);

												// update
												jsonInstance.children[note.listIndex].children[note.sectionIndex].children[note.itemIndex].mediaAttachments[j].remoteUri = "https://s3.amazonaws.com/content.ambifi.com/" + dstKey;
												jsonInstance.children[note.listIndex].children[note.sectionIndex].children[note.itemIndex].mediaAttachmentsUrls[j] = "https://s3.amazonaws.com/content.ambifi.com/" + dstKey;
											}
										}
									} catch (err) {
										// No op
									}
								}
							}

						}

						// Upload to new destination
						const params = { Key: `${newInstanceUrl}`, ContentType: "application/json", Body: JSON.stringify(jsonInstance) };

						console.log("COPY ACTIVITY", `${instanceUrl}`, jsonInstance);

						bucket.upload(params, async (err) => {
							// Replace with notification
							if (!err) {
								rememberJobReassignment(state, orgId, {
									srcInstanceUrl: instanceUrl,
									dstInstanceUrl: newInstanceUrl,
									displayName,
									profilePicture: options.profilePicture,
									assigneeCount: jsonInstance.assignees.length,
									customerIdentitySnapshot
								});
								state.set(["appState", "status", "showSpinner"], false);
								state.set(["appState", "reassignModal", "show"], false);

								const customerTransferMessage = customerIdentitySnapshot
									? " The job customer was also changed to " + customerIdentitySnapshot.company + "."
									: "";
								showSuccess("Reassign", "Successfully reassigned the activity to " + displayName + "." + customerTransferMessage + "<br/><br/>NOTE: Sometimes it can take a few seconds so you may need to press the Refresh button to see the result.");
								resolve({
									reassigned: true,
									destinationUrl: newInstanceUrl,
									customerTransferred: Boolean(customerIdentitySnapshot),
									destinationIdentityId: normalizedDestinationIdentityId
								});
							} else {
								state.set(["appState", "status", "showSpinner"], false);

								showError("Failed to reassign the activity.", err.message);

								reject(err);
							}
						});
					}
				});
			}).catch((err) => {
				state.set(["appState", "status", "showSpinner"], false);
				console.error(err);
				showError("Failed to reassign the activity.", err);

				reject(err);
			});
		} catch (err) {
			state.set(["appState", "status", "showSpinner"], false);
			console.error(err);
			showError("Failed to reassign the activity.", err);

			reject(err);
		}
	});
}

export function saveJsonToS3WithKeyPrefix(object, bucketName, keyPrefix, fileName, message = "") {
	return refreshCredentials().then(() => {
		// Instantiate aws sdk service objects now that the credentials have been updated.
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
		const params = { Key: `${keyPrefix}/${fileName}`, ContentType: "application/json", Body: JSON.stringify(object) };
		return bucket.upload(params).promise().then(() => {
			console.log("SAVED.");
			if (message !== "") {
				showSuccess("Successfully saved", message);
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("Save failed", err);
		throw err;
	});
}

export function saveHistory(bucketName, files, keyPrefixOverride = "", refreshChecklists = false) {
	let keyPrefix = keyPrefixOverride;
	if (keyPrefix === "") {
		keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get());
	}

	return putBatch(bucketName, keyPrefix, files)
		.then(() => {
			// Send message to client that history has been saved so can set sync to true on all instances
			postMessage({ method: "saveHistory", result: "success", refreshChecklists: refreshChecklists });
		});
	// .catch((err) => {
	// 	//alert(err);
	// 	//actions.postMessage({ method: "saveHistory", result: err });
	// 	throw err;
	// });
}


// Need to send in batch instead of loop
export function saveJsonToS3ForHistory(object, bucketName, fileName) {
	refreshCredentials().then(() => {
		const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get());

		// Instantiate aws sdk service objects now that the credentials have been updated.
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
		const params = { Key: `${keyPrefix}/${fileName}`, ContentType: "application/json", Body: JSON.stringify(object) };
		console.log(`SAVE HISTORY: ${keyPrefix}/${fileName}`);
		bucket.upload(params, (err) => {
			const result = err ? "ERROR!" : "SAVED.";
			console.log(result);
			// Replace with notification
			if (err) {
				showError("History save failed", err.message);
			}
		});
	}).catch((err) => {
		console.error(err);
		showErrorNoDetail("Save history failed", err);
	});
}

export function saveJsonToS3(object, bucketName, fileName, message = "", getChecklists = true) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get());

			// Instantiate aws sdk service objects now that the credentials have been updated.
			uploadObject(object, bucketName, keyPrefix).then(() => {
				// If getChecklists then refresh content on mobile device
				if (getChecklists) {
					sendInventoryAndUserInfoMessage().then(() => {
						if (message !== "") {
							showSuccess("Save successful", message);
							state.set(["appState", "editor", "showSpinner"], false);
						}
					}).catch(err => {
						showError("Failed to save", err.message);
						reject(err);
					});

					// receiveDocuments sets the state in the app
				} else {
					console.debug("In saveJsonToS3", object);
					initializeInventory(false).catch(err => {
						showError("Failed to save", err.message);
						reject(err);
					});
				}
			}).catch(err => {
				showError("Failed to save", err.message);
				reject(err);
			});
		}).catch((err) => {
			console.error(err);
			showError2("Save failed", err);
			reject(err);
		});
	});
}

export function getJsonFileFromS3(bucketName, fileName) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(async () => {
			const keyPrefix = getKeyPrefix(state.get(["user", "identityId"]));

			const s3 = new AWS.S3({ useDualStack: true });

			try {
				const data = await s3.getObject({ Bucket: bucketName, Key: keyPrefix + "/" + fileName }).promise();

				console.log("GET!: " + data.Body.toString());

				resolve(JSON.parse(data.Body.toString()));

			} catch (err) {
				reject("Error: " + err.message);
			}
		}).catch((err) => {
			console.error(err);
			showError2("Save failed", err);
			reject(err);
		});
	});
}

export function putJsonFileToS3(bucketName, fileName, data) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(async () => {
			const body = JSON.stringify(withComputedPricingTotals(data));
			const keyPrefix = getKeyPrefix(state.get(["user", "identityId"]));
			const s3 = new AWS.S3({ useDualStack: true });

			try {
				await s3.putObject({ Bucket: bucketName, Key: keyPrefix + "/" + fileName, Body: body, ContentType: "application/json" }).promise();

				console.log("PUT!: " + data);
				resolve(data);
			} catch (err) {
				reject("Error: " + err.message);
			}
		}).catch((err) => {
			console.error(err);
			showError2("Save failed", err);
			reject(err);
		});
	});
}

export function deleteJsonFileFromS3WithKeyPrefix(bucketName, keyPrefix, fileName) {
	return deleteObject(bucketName, `${keyPrefix}/${fileName}`).catch((err) => {
		console.error(err);
		showError2("Delete failed", err);
	});
}

export function deleteJsonFileFromS3(bucketName, fileName) {
	const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get());
	const key = `${keyPrefix}/${fileName}`;

	return deleteObject(bucketName, key).catch((err) => {
		console.error(err);
		showError2("Delete failed", err);
	});
}

export function saveJsonFilesToS3WithKeyPrefix(bucketName, files, message = "") {
	return refreshCredentials().then(() => {
		return putBatchWithKeyPrefix(bucketName, files).then(() => {
			if (message !== "") {
				showSuccess("Save successful", message);
				state.set(["appState", "editor", "showSpinner"], false);
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("Save failed", err);
		throw err;
	});
}

// This also getAllChecklists
export function saveJsonFilesToS3(bucketName, files, message = "", getChecklists = true, options = {}) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get());
			const diagnosticSave = options.diagnosticSave === true || options.simulateS3BadDigestFailure === true;
			const onStatus = diagnosticSave && _.isFunction(options.onStatus) ? options.onStatus : null;
			const captureAuthoringSaveDiagnostics = diagnosticSave && shouldCaptureS3SaveBatch(files);
			const saveAttemptId = diagnosticSave ? generateUUID() : "";
			const saveBatchDiagnosticContext = buildS3SaveBatchDiagnosticContext(bucketName, keyPrefix, files, saveAttemptId);
			const saveBatchStartedAt = diagnosticSave ? Date.now() : 0;
			const temporaryCaptureReason = "authoringS3JsonBatchSave";
			let temporaryCaptureEnabled = false;
			const stopTemporarySaveCapture = (outcome, detail = {}) => {
				if (!temporaryCaptureEnabled) {
					return;
				}
				temporaryCaptureEnabled = false;
				disableTemporaryWebDiagnosticCapture(temporaryCaptureReason, _.assign({}, saveBatchDiagnosticContext, detail, {
					outcome
				}));
			};
			if (!diagnosticSave) {
				disableTemporaryWebDiagnosticCapture(temporaryCaptureReason, {
					outcome: "normalSaveStarted"
				});
			}
			notifySaveStatus(onStatus, "Preparing cloud upload...", {
				phase: "prepareS3Batch",
				fileCount: files.length
			});
			if (captureAuthoringSaveDiagnostics) {
				temporaryCaptureEnabled = !!enableTemporaryWebDiagnosticCapture(temporaryCaptureReason, 300000, saveBatchDiagnosticContext);
				recordWebDiagnosticEvent("authoringS3JsonBatchSaveStarted", saveBatchDiagnosticContext);
			}
			putBatch(bucketName, keyPrefix, files, {
				onStatus,
				sequential: false,
				maxBadDigestRetries: 3,
				diagnosticSave,
				saveAttemptId,
				simulateS3BadDigestFailure: options.simulateS3BadDigestFailure === true
			})
				.then(() => {
					if (diagnosticSave) {
						const batchElapsedMs = recordSaveTimingEvent("authoringS3JsonBatchSaveCompleted", "s3BatchUpload", saveBatchStartedAt, saveBatchDiagnosticContext);
						recordWebDiagnosticEvent("authoringS3JsonBatchSaveTiming", _.assign({}, saveBatchDiagnosticContext, {
							elapsedMs: batchElapsedMs,
							elapsed: formatSaveDuration(batchElapsedMs)
						}));
					}
					if (getChecklists) {
						notifySaveStatus(onStatus, "Syncing saved activity to device...", {
							phase: "syncSavedActivity"
						});
						sendInventoryAndUserInfoMessage().then(() => {
							if (message !== "") {
								notifySaveStatus(onStatus, "Save completed.", {
									phase: "complete"
								});
								showSuccessToast(message);
								state.set(["appState", "editor", "showSpinner"], false);
								state.set(["appState", "editor", "spinnerMessage"], "");
							}
							stopTemporarySaveCapture("success");
							resolve();
						}).catch(err => {
							notifySaveStatus(onStatus, "Save completed, but device sync failed.", {
								phase: "syncFailed"
							});
							stopTemporarySaveCapture("syncFailed", {
								error: buildS3ErrorDiagnosticContext(err)
							});
							console.error(err);
							reject(err);
							showError("Failed to save", err.message);
						});
					} else {

						if (message !== "") {
							notifySaveStatus(onStatus, "Save completed.", {
								phase: "complete"
							});
							showSuccessToast(message);
							state.set(["appState", "editor", "showSpinner"], false);
							state.set(["appState", "editor", "spinnerMessage"], "");
						}
						stopTemporarySaveCapture("success");
						resolve();
					}
				})
				.catch((err) => {
					if (diagnosticSave) {
						const batchElapsedMs = Math.max(0, Date.now() - saveBatchStartedAt);
						if (_.isObject(err)) {
							err.s3BatchElapsedMs = batchElapsedMs;
						}
						if (captureAuthoringSaveDiagnostics) {
							recordWebDiagnosticEvent("authoringS3JsonBatchSaveFailed", {
								batch: saveBatchDiagnosticContext,
								elapsedMs: batchElapsedMs,
								elapsed: formatSaveDuration(batchElapsedMs),
								error: buildS3ErrorDiagnosticContext(err)
							});
						}
					}
					stopTemporarySaveCapture("failed", {
						error: buildS3ErrorDiagnosticContext(err)
					});
					reject(err);
					showError2("Save failed", err);
					console.log(err.message);
				});

		}).catch((err) => {
			reject(err);
			console.error(err);
			showError2("Save failed", err);
		});
	});

}

const putBatch = function putBatch(bucketName, keyPrefix, files, options = {}) {
	const {
		onStatus = null,
		sequential = false,
		maxBadDigestRetries = 3,
		diagnosticSave = false,
		saveAttemptId = "",
		simulateS3BadDigestFailure = false
	} = options || {};
	const putOne = (file, index) => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
		const body = JSON.stringify(file.fileContent);
		const key = `${file.prefix ? file.prefix : keyPrefix}/${file.fileName}`;
		const diagnosticContext = buildS3SaveFileDiagnosticContext(bucketName, key, file, body, files.length, bucket.endpoint || {}, saveAttemptId);
		const uploadStartedAt = Date.now();
		const stopLongRunningUploadStatus = diagnosticSave ? startLongRunningSaveStatus(
			onStatus,
			(elapsedMs) => `Still uploading ${diagnosticContext.saveArtifactLabel} (${index + 1} of ${files.length})... ${formatSaveDuration(elapsedMs)} elapsed.`,
			{
				phase: "s3UploadStillRunning",
				index: index + 1,
				total: files.length,
				artifact: diagnosticContext.saveArtifactLabel,
				key
			}
		) : () => Math.max(0, Date.now() - uploadStartedAt);
		notifySaveStatus(onStatus, `Uploading ${diagnosticContext.saveArtifactLabel} (${index + 1} of ${files.length})...`, {
			phase: "s3Upload",
			index: index + 1,
			total: files.length,
			artifact: diagnosticContext.saveArtifactLabel,
			key
		});
		if (diagnosticSave) {
			recordWebDiagnosticEvent("authoringS3JsonPutObjectStarted", {
				save: diagnosticContext,
				startedAt: new Date(uploadStartedAt).toISOString()
			});
		}
		const putPromise = diagnosticSave
			? putObjectWithBadDigestRetry(bucket, { Key: key, ContentType: "application/json", Body: body }, diagnosticContext, maxBadDigestRetries, onStatus, {
				simulateS3BadDigestFailure: simulateS3BadDigestFailure === true && index === 0
			})
			: bucket.putObject({ Key: key, ContentType: "application/json", Body: body }).promise();

		return putPromise
			.then((result) => {
				const uploadElapsedMs = stopLongRunningUploadStatus();
				notifySaveStatus(onStatus, `Uploaded ${diagnosticContext.saveArtifactLabel} (${index + 1} of ${files.length}) in ${formatSaveDuration(uploadElapsedMs)}.`, {
					phase: "s3Uploaded",
					index: index + 1,
					total: files.length,
					artifact: diagnosticContext.saveArtifactLabel,
					key,
					elapsedMs: uploadElapsedMs
				});
				if (diagnosticSave) {
					recordWebDiagnosticEvent("authoringS3JsonPutObjectCompleted", {
						save: diagnosticContext,
						elapsedMs: uploadElapsedMs,
						elapsed: formatSaveDuration(uploadElapsedMs)
					});
				}
				return result;
			})
			.catch((err) => {
				const uploadElapsedMs = stopLongRunningUploadStatus();
				if (!diagnosticSave) {
					throw err;
				}
				const annotatedError = annotateS3SaveError(err, _.assign({}, diagnosticContext, {
					uploadElapsedMs,
					attemptNumber: _.get(err, "attemptNumber", 1),
					maxAttempts: _.get(err, "maxAttempts", maxBadDigestRetries + 1)
				}));
				const errorContext = buildS3ErrorDiagnosticContext(annotatedError);
				recordWebDiagnosticEvent("authoringS3JsonPutObjectCompletedWithError", {
					save: diagnosticContext,
					elapsedMs: uploadElapsedMs,
					elapsed: formatSaveDuration(uploadElapsedMs),
					error: errorContext
				});
				throw annotatedError;
			});
	};

	if (sequential) {
		const results = [];
		return files.reduce((promise, file, index) => {
			return promise.then(() => putOne(file, index).then((result) => {
				results.push(result);
				return results;
			}));
		}, Promise.resolve()).then(() => results);
	}

	return Promise.all(files.map((file, index) => putOne(file, index)));
};

const putBatchWithKeyPrefix = function putBatchWithKeyPrefix(bucketName, files) {
	return Promise.all(files.map((file) => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
		const body = JSON.stringify(file.fileContent);
		console.log("PUT INVENTORY3", files);
		return bucket.putObject({ Key: `${file.keyPrefix}/${file.fileName}`, ContentType: "application/json", Body: body }).promise();
	}));
};

function buildActivityMetadataDocument(document = {}, inventoryEntry = {}) {
	const ownerIdentityId = _.trim(_.toString(
		_.get(inventoryEntry, "ownerIdentityId", "") ||
		_.get(inventoryEntry, "identityId", "") ||
		_.get(document, "ownerIdentityId", "") ||
		_.get(document, "identityId", "") ||
		getIdentityId()
	));

	return _.assign({}, inventoryEntry, preserveInventorySharingMetadata(document, inventoryEntry), {
		orgId: getOrgId(),
		ownerIdentityId: ownerIdentityId || getIdentityId()
	});
}


export async function updateChecklistsAndPushToS3(checklist, newDocument = null, options = {}) {
	const {
		message = "",
		ignoreContributors = false,
		lock = true,
		runtimeChecklist = null,
		onSaveStatus = null,
		simulateS3BadDigestFailure = false,
		diagnosticSave = false
	} = options || {};
	const useDiagnosticSave = diagnosticSave === true || simulateS3BadDigestFailure === true;
	const saveStatusHandler = useDiagnosticSave && _.isFunction(onSaveStatus) ? onSaveStatus : null;

	if (isCurrentTabAuthoringReadOnly()) {
		const readOnlyMessage = `${getReadOnlyAuthoringMessage()} This authoring save was blocked to avoid overwriting work from another tab.`;
		showError("Read-Only Tab", readOnlyMessage);
		throw new Error(readOnlyMessage);
	}

	// Reconcile before any source, runtime, inventory, or shared-metadata projection.
	const heroMedia = getActivityHeroMediaFields(checklist, {
		runtimeActivity: runtimeChecklist,
		getDriveResource: getDriveObject,
		assetUrls: env.cloudFront.assetUrls
	});
	Object.assign(checklist, heroMedia);
	if (runtimeChecklist) Object.assign(runtimeChecklist, heroMedia);
	if (newDocument) Object.assign(newDocument, heroMedia);

	applyAdvanceOnAcknowledgeStrategyMigration(checklist);
	applyAdvanceOnAcknowledgeStrategyMigration(runtimeChecklist);
	applyMoveForwardMigration(checklist);
	applyMoveForwardMigration(runtimeChecklist);

	// Guarantee we have an identityId
	// Check metadata - if identityId is the same as logged in user then don't inject
	const activityInfo = getActivityById(checklist.id);

	if (activityInfo && activityInfo.hasOwnProperty("identityId")) {
		checklist.identityId = activityInfo.identityId;
	}

	if (activityInfo && activityInfo.hasOwnProperty("sharedWithType") && (activityInfo.sharedWithType === "member" || activityInfo.sharedWithType === "group") && checklist.identityId === getIdentityId()) {
		showError2("Save Activity", "Unable to save the activity because this activity was shared with you but is missing the proper identity id.");
		return;
	}

	const isThirdPartyAuthor = (checklist.hasOwnProperty("identityId") && checklist.identityId !== "" && checklist.identityId !== getIdentityId() && (isOrganizationAdministrator() || isOrganizationAuthor()));
	if (!checklist.hasOwnProperty("identityId") || checklist.identityId === "" || !checklist.identityId || checklist.identityId === getIdentityId() || isThirdPartyAuthor) {
		const documents = state.get(["activities"]);
		let inventoryEntry = {};

		const name = state.get(["user", "name"]);
		const username = state.get(["user", "username"]);
		const nickname = state.get(["user", "nickname"]);

		if (!ignoreContributors) {
			if (newDocument === null) {
				if (!checklist.hasOwnProperty("contributors")) {
					const contributors = [];
					contributors.push({ name, username, nickname });
					checklist.contributors = contributors;
				} else if (checklist.contributors.length === 0) {
					checklist.contributors.push({ name, username, nickname });
				} else if (checklist.contributors[checklist.contributors.length - 1].username !== username) {
					checklist.contributors.push({ name, username, nickname });
				}
			}
		}

		const newDocuments = [];

		for (const document of documents) { // eslint-disable-line no-unused-vars
			if (!document.hasOwnProperty("category") || document.category !== "learning") {
				if (!document.hasOwnProperty("newDoc") || !document.newDoc) {
					if (checklist.id === document.id) {
						document.orgId = document.orgId || getOrgId();
						document.ownerIdentityId = document.ownerIdentityId || getIdentityId();
						document.name = checklist.name;
						document.description = checklist.description;
						document.cloned = checklist.cloned;
						document.publisher = checklist.publisher;
						document.genre = checklist.genre;
						document.tags = checklist.tags ? checklist.tags : [];
						document.contributors = checklist.contributors;
						_.assign(document, getActivityInventoryMediaFields(checklist, { onlyPresent: true }));
						document.checklistId = checklist.checklistId;
						document.driveRootPath = checklist.driveRootPath;
						document.category = checklist.category ? checklist.category : "";
						if (checklist.owner) {
							document.owner = checklist.owner;
						}
						// If trackData was set on inventory entry but not in the document yet, then adjust the document content to what was set in the inventory entry
						if (!checklist.hasOwnProperty("trackData") && document.hasOwnProperty("trackData")) {
							checklist.trackData = document.trackData;
						} else {
							document.trackData = checklist.trackData;
						}

						document.revision = checklist.hasOwnProperty("revision") ? checklist.revision : 1;
						document.revisionTs = checklist.hasOwnProperty("revisionTs") ? checklist.revisionTs : new Date().getTime();
						document.externalResources = checklist.hasOwnProperty("externalResources") ? checklist.externalResources : [];
						inventoryEntry = document;
					}

					// experiences.json		
					newDocuments.push(document);
				} else if (document.hasOwnProperty("newDoc") && document.newDoc && checklist.id === document.id) {
					document.newDoc = false;
					document.orgId = getOrgId();
					document.ownerIdentityId = getIdentityId();
					document.name = checklist.name;
					document.description = checklist.description;
					document.cloned = checklist.cloned;
					document.publisher = checklist.publisher;
					document.genre = checklist.genre;
					document.tags = checklist.tags ? checklist.tags : [];
					document.contributors = checklist.contributors;
					_.assign(document, getActivityInventoryMediaFields(checklist, { onlyPresent: true }));
					document.checklistId = checklist.checklistId;
					document.driveRootPath = checklist.driveRootPath;
					document.trackData = checklist.trackData;
					document.category = checklist.category ? checklist.category : "";
					document.revision = checklist.hasOwnProperty("revision") ? checklist.revision : 1;
					document.revisionTs = checklist.hasOwnProperty("revisionTs") ? checklist.revisionTs : new Date().getTime();
					document.externalResources = checklist.hasOwnProperty("externalResources") ? checklist.externalResources : [];
					document.owner = true;

					checklist.identityId = getIdentityId();

					// experiences.json
					newDocuments.unshift(document);
				}
			}

		}
		if (newDocument !== null && !_.find(newDocuments, (document) => document.id === newDocument.id)) {
			newDocuments.unshift(newDocument);
			if (_.isEmpty(inventoryEntry)) {
				inventoryEntry = newDocument;
			}
		}

		if (!isThirdPartyAuthor && !_.find(newDocuments, (document) => document.id === checklist.id)) {
			const repairedInventoryEntry = _.assign(
				{},
				createImportedActivityInventoryEntry(checklist),
				_.isEmpty(inventoryEntry) ? {} : inventoryEntry,
				{
					id: checklist.id,
					orgId: getOrgId(),
					ownerIdentityId: getIdentityId(),
					name: checklist.name,
					description: checklist.description,
					cloned: checklist.cloned === true,
					genre: checklist.genre,
					tags: checklist.tags ? checklist.tags : [],
					contributors: checklist.contributors,
					publisher: checklist.publisher,
					revision: checklist.hasOwnProperty("revision") ? checklist.revision : 1,
					revisionTs: checklist.hasOwnProperty("revisionTs") ? checklist.revisionTs : new Date().getTime(),
					visible: true,
					speedType: checklist.speedType ? checklist.speedType : "KIAS",
					checklistId: checklist.checklistId,
					driveRootPath: checklist.driveRootPath,
					category: checklist.category ? checklist.category : "",
					trackData: checklist.trackData,
					externalResources: checklist.hasOwnProperty("externalResources") ? checklist.externalResources : [],
					owner: checklist.owner === false ? false : true,
					newDoc: false
				},
				getActivityInventoryMediaFields(checklist)
			);

			console.warn("Repairing missing inventory entry during activity save", {
				activityId: checklist.id,
				hadInventoryEntry: !_.isEmpty(inventoryEntry),
				hadNewDocument: newDocument !== null
			});

			newDocuments.unshift(repairedInventoryEntry);
			if (_.isEmpty(inventoryEntry)) {
				inventoryEntry = repairedInventoryEntry;
			}
		}

			const keyPrefix = getKeyPrefix(checklist.identityId ? checklist.identityId : getIdentityId());
			// const keyPrefix = isThirdPartyAuthor ? checklist.identityId : getIdentityId();
			const sourcePrefix = `${keyPrefix}/source`;
			const checklistForRuntime = _.isObject(runtimeChecklist) ? runtimeChecklist : checklist;
			const publishedChecklist = buildPublishedChecklistPayload(checklistForRuntime);

			if (!isValidActivitySavePathPrefix(keyPrefix)) {
				throw new Error(`Save activity JSON failed, invalid save path prefix: ${keyPrefix}`);
			}

		let experiencesInventory = createExperiencesInventoryFromActivities(newDocuments);
		const saveFileContext = {
			activityId: checklist.id,
			activityName: checklist.name
		};

			const files = isThirdPartyAuthor ? [
				{
					fileName: `${checklist.id}.json`,
					fileContent: publishedChecklist,
					prefix: keyPrefix,
					saveArtifactLabel: "published activity JSON",
					...saveFileContext
				},
				{
					fileName: `${checklist.id}.json`,
					fileContent: checklist,
					prefix: sourcePrefix,
					saveArtifactLabel: "authoring source JSON",
					...saveFileContext
				}
			] : [
				{
					fileName: env.artifacts.inventoryFileName,
					fileContent: experiencesInventory,
					saveArtifactLabel: "activity inventory JSON",
					...saveFileContext
				},
				{
					fileName: `${checklist.id}.json`,
					fileContent: publishedChecklist,
					prefix: keyPrefix,
					saveArtifactLabel: "published activity JSON",
					...saveFileContext
				},
				{
					fileName: `${checklist.id}.json`,
					fileContent: checklist,
					prefix: sourcePrefix,
					saveArtifactLabel: "authoring source JSON",
					...saveFileContext
				}
			];

		console.log("S");

		return new Promise((resolve, reject) => {
			const stopLongRunningLocalInventoryStatus = useDiagnosticSave ? startLongRunningSaveStatus(
				saveStatusHandler,
				(elapsedMs) => `Still updating local activity inventory... ${formatSaveDuration(elapsedMs)} elapsed.`,
				{
					phase: "updateLocalInventoryStillRunning",
					activityId: checklist.id,
					activityName: checklist.name
				}
			) : () => 0;
			notifySaveStatus(saveStatusHandler, "Updating local activity inventory...", {
				phase: "updateLocalInventory"
			});
			setActivities(newDocuments).then(() => {
				const localInventoryElapsedMs = stopLongRunningLocalInventoryStatus();
				if (useDiagnosticSave) {
					recordWebDiagnosticEvent("authoringSavePhaseCompleted", {
						phase: "updateLocalInventory",
						activityId: checklist.id,
						activityName: checklist.name,
						elapsedMs: localInventoryElapsedMs,
						elapsed: formatSaveDuration(localInventoryElapsedMs)
					});
				}
				const stopLongRunningSharedMetadataStatus = useDiagnosticSave ? startLongRunningSaveStatus(
					saveStatusHandler,
					(elapsedMs) => `Still updating shared activity metadata... ${formatSaveDuration(elapsedMs)} elapsed.`,
					{
						phase: "updateSharedMetadataStillRunning",
						activityId: checklist.id,
						activityName: checklist.name
					}
				) : () => 0;
				notifySaveStatus(saveStatusHandler, "Updating shared activity metadata...", {
					phase: "updateSharedMetadata"
				});
				updateSharedDocument(buildActivityMetadataDocument(checklist, inventoryEntry), isThirdPartyAuthor, { heroMediaReconciled: true }).then(() => {
					const sharedMetadataElapsedMs = stopLongRunningSharedMetadataStatus();
					if (useDiagnosticSave) {
						recordWebDiagnosticEvent("authoringSavePhaseCompleted", {
							phase: "updateSharedMetadata",
							activityId: checklist.id,
							activityName: checklist.name,
							elapsedMs: sharedMetadataElapsedMs,
							elapsed: formatSaveDuration(sharedMetadataElapsedMs)
						});
					}
					notifySaveStatus(saveStatusHandler, "Uploading activity files to AmbiFi Cloud...", {
						phase: "uploadActivityFiles",
						fileCount: files.length
					});
					saveJsonFilesToS3(env.s3.contentBucket, files, message, isMobile(), { onStatus: saveStatusHandler, simulateS3BadDigestFailure, diagnosticSave: useDiagnosticSave }).then(async () => {
						// Relock it ...
						if (state.exists(["newActivityWorkflowGuid"])) {
							const newActivityWorkflowGuid = state.get(["newActivityWorkflowGuid"]);
							if (newActivityWorkflowGuid) {
								try {
									await associateActivityWithWorkflow(checklist.id, newActivityWorkflowGuid);
									await reloadActivities();
								} catch (err) {
									showError("Associate with Workflow", "Unable to associate activity with selected workflow, please try adding it manually.", () => {
										state.set(["appState", "editor", "showSpinner"], false);
									});
									reject(err);
								}
								state.set(["newActivityWorkflowGuid"], null);
							}
						}
						if (lock) {
							notifySaveStatus(saveStatusHandler, "Finalizing editor lock...", {
								phase: "finalizeLock"
							});
							putLock(checklist.id, keyPrefix);
						}
						resolve();
					}).catch(err => {
						state.set(["appState", "editor", "showSpinner"], false);
						reject(err);
					});
				}).catch(err => {
					const sharedMetadataElapsedMs = stopLongRunningSharedMetadataStatus();
					if (useDiagnosticSave) {
						recordWebDiagnosticEvent("authoringSavePhaseFailed", {
							phase: "updateSharedMetadata",
							activityId: checklist.id,
							activityName: checklist.name,
							elapsedMs: sharedMetadataElapsedMs,
							elapsed: formatSaveDuration(sharedMetadataElapsedMs),
							error: buildS3ErrorDiagnosticContext(err)
						});
					}
					showError("Save Failed", "Unable to update shared activity meta data. Reason:" + err);
					state.set(["appState", "editor", "showSpinner"], false);
					reject(err);
				});
			}).catch(err => {
				const localInventoryElapsedMs = stopLongRunningLocalInventoryStatus();
				if (useDiagnosticSave) {
					recordWebDiagnosticEvent("authoringSavePhaseFailed", {
						phase: "updateLocalInventory",
						activityId: checklist.id,
						activityName: checklist.name,
						elapsedMs: localInventoryElapsedMs,
						elapsed: formatSaveDuration(localInventoryElapsedMs),
						error: buildS3ErrorDiagnosticContext(err)
					});
				}
				showError("Save Failed", "Failed to update inventory of activities, reason:" + err);
				state.set(["appState", "editor", "showSpinner"], false);
				reject(err);
			});
		});

	} else {
		throw new Error("Unable to save activity, the current user doesn't have the appropriate permissions to perform a save.");
	}
}



export function importChecklistFromCsv(checklist) {
	const normalizedChecklist = normalizeImportedActivityForLocalOwnership(checklist);
	return updateChecklistsAndPushToS3(normalizedChecklist, createImportedActivityInventoryEntry(normalizedChecklist), { message: `The activity ${normalizedChecklist.name} was successfully imported.` });
}

export function importChecklist(checklist) {
	const normalizedChecklist = normalizeImportedActivityForLocalOwnership(checklist);
	return updateChecklistsAndPushToS3(normalizedChecklist, createImportedActivityInventoryEntry(normalizedChecklist), { message: `The activity ${normalizedChecklist.name} was successfully imported.` });
}

export function setDocumentPrivacy(activity, privacy) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get(), activity);

			const activityInfo = getActivityById(activity.id);
			const activityPrefix = activityInfo && activityInfo.identityId ? activityInfo.identityId : undefined;

			Promise.all([
				getActivity(activity.id, activityPrefix),
				getActivityForAuthoring(activity.id, activityPrefix)
			]).then(([runtimeContent, authoringResult]) => {
				let checklist = _.cloneDeep(runtimeContent);
				let sourceChecklist = _.isObject(authoringResult) && _.isObject(authoringResult.activity)
					? _.cloneDeep(authoringResult.activity)
					: null;
				applyAdvanceOnAcknowledgeStrategyMigration(checklist);
				applyAdvanceOnAcknowledgeStrategyMigration(sourceChecklist);
				applyMoveForwardMigration(checklist);
				applyMoveForwardMigration(sourceChecklist);

				if (checklist.hasOwnProperty("identityId")) {
					delete checklist.identityId;
				}
				if (checklist.hasOwnProperty("share")) {
					delete checklist.share;
				}
				if (sourceChecklist) {
					if (sourceChecklist.hasOwnProperty("identityId")) {
						delete sourceChecklist.identityId;
					}
					if (sourceChecklist.hasOwnProperty("share")) {
						delete sourceChecklist.share;
					}
				}

				// If privacy = public then copy
				// If privacy = private then delete
				checklist.privacy = privacy;
				if (sourceChecklist) {
					sourceChecklist.privacy = privacy;
				}

				// Need to update documents collection
				activity.privacy = privacy;
				const isThirdPartyAuthor = (checklist.hasOwnProperty("identityId") && checklist.identityId !== "" && checklist.identityId !== getIdentityId() && (isOrganizationAdministrator() || isOrganizationAuthor()));
				updateSharedDocument(buildActivityMetadataDocument(checklist, activityInfo || activity), isThirdPartyAuthor).then(async () => {
					updateActivity(activity);

					let documentsToSend = _.cloneDeep(state.get(["activities"]));
					documentsToSend.shift();
					documentsToSend = createExperiencesInventoryItemFromActivity(filterLearningActivities(documentsToSend));

					if (privacy === "public") {
						const files = [
							{
								keyPrefix,
								fileName: env.artifacts.inventoryFileName,
								fileContent: documentsToSend,
							},
							{
								keyPrefix: PUBLIC_KEY_PREFIX,
								fileName: `${checklist.id}.json`,
								fileContent: checklist,
							},
						];
						if (sourceChecklist) {
							files.push({
								keyPrefix: `${PUBLIC_KEY_PREFIX}/source`,
								fileName: `${checklist.id}.json`,
								fileContent: sourceChecklist,
							});
						}

						await saveJsonFilesToS3WithKeyPrefix(env.s3.contentBucket, files, "");
					} else if (privacy === "private") {
						// Not consistent...above we do this in a batch
						await Promise.all([
							deleteJsonFileFromS3WithKeyPrefix(env.s3.contentBucket, PUBLIC_KEY_PREFIX, `${activity.id}.json`),
							deleteJsonFileFromS3WithKeyPrefix(env.s3.contentBucket, `${PUBLIC_KEY_PREFIX}/source`, `${activity.id}.json`)
						]);
						await saveJsonToS3WithKeyPrefix(documentsToSend, env.s3.contentBucket, keyPrefix, env.artifacts.inventoryFileName, "");
					}
					resolve();
				}).catch(err => {
					console.error(err);
					reject(err);
				});
			});

		}).catch((err) => {
			console.error(err);
			showError2("Set privacy failed", err);
		});
	});

}

export function setDocumentOrgPrivacy(activity, privacy) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(async () => {
			try {
				const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get(), activity);
				const activityInfo = getActivityById(activity.id);
				const inventoryOwnerIdentityId = _.trim(_.toString(
					_.get(activityInfo, "identityId", "") ||
					_.get(activity, "identityId", "")
				));
				const activityPrefix = inventoryOwnerIdentityId !== "" ? inventoryOwnerIdentityId : undefined;

				const [runtimeContent, authoringResult] = await Promise.all([
					getActivity(activity.id, activityPrefix),
					getActivityForAuthoring(activity.id, activityPrefix)
				]);

				let checklist = _.cloneDeep(runtimeContent);
				let sourceChecklist = _.isObject(authoringResult) && _.isObject(authoringResult.activity)
					? _.cloneDeep(authoringResult.activity)
					: null;
				applyAdvanceOnAcknowledgeStrategyMigration(checklist);
				applyAdvanceOnAcknowledgeStrategyMigration(sourceChecklist);
				applyMoveForwardMigration(checklist);
				applyMoveForwardMigration(sourceChecklist);
				const ownerIdentityId = _.trim(_.toString(
					inventoryOwnerIdentityId ||
					_.get(runtimeContent, "identityId", "") ||
					_.get(sourceChecklist, "identityId", "")
				));
				const isThirdPartyAuthor = ownerIdentityId !== "" && ownerIdentityId !== getIdentityId() && (isOrganizationAdministrator() || isOrganizationAuthor());

				if (checklist.hasOwnProperty("identityId")) {
					delete checklist.identityId;
				}
				if (checklist.hasOwnProperty("share")) {
					delete checklist.share;
				}
				if (sourceChecklist) {
					if (sourceChecklist.hasOwnProperty("identityId")) {
						delete sourceChecklist.identityId;
					}
					if (sourceChecklist.hasOwnProperty("share")) {
						delete sourceChecklist.share;
					}
				}

				// If privacy = public then copy
				// If privacy = private then delete
				checklist.orgPrivacy = privacy;
				if (sourceChecklist) {
					sourceChecklist.orgPrivacy = privacy;
				}

				// Need to update documents collection
				activity.orgPrivacy = privacy;
				const metadataChecklist = isThirdPartyAuthor ? _.assign({}, checklist, { identityId: ownerIdentityId }) : checklist;
				await updateSharedDocument(buildActivityMetadataDocument(metadataChecklist, activityInfo || activity), isThirdPartyAuthor);
				updateActivity(activity);

				if (privacy === "public") {
					const files = [
						{
							keyPrefix: `${state.get(["selectedOrg", "id"])}/${PUBLIC_KEY_PREFIX}`,
							fileName: `${checklist.id}.json`,
							fileContent: checklist,
						},
					];

					if (!isThirdPartyAuthor) {
						let documentsToSend = _.cloneDeep(state.get(["activities"]));
						documentsToSend.shift();
						documentsToSend = createExperiencesInventoryFromActivities(documentsToSend);
						files.unshift({
							keyPrefix,
							fileName: env.artifacts.inventoryFileName,
							fileContent: documentsToSend,
						});
					}

					if (sourceChecklist) {
						files.push({
							keyPrefix: `${state.get(["selectedOrg", "id"])}/${PUBLIC_KEY_PREFIX}/source`,
							fileName: `${checklist.id}.json`,
							fileContent: sourceChecklist,
						});
					}

					await saveJsonFilesToS3WithKeyPrefix(env.s3.contentBucket, files, "");
				} else if (privacy === "private") {
					// Not consistent...above we do this in a batch
					await Promise.all([
						deleteJsonFileFromS3WithKeyPrefix(env.s3.contentBucket, `${state.get(["selectedOrg", "id"])}/${PUBLIC_KEY_PREFIX}`, `${activity.id}.json`),
						deleteJsonFileFromS3WithKeyPrefix(env.s3.contentBucket, `${state.get(["selectedOrg", "id"])}/${PUBLIC_KEY_PREFIX}/source`, `${activity.id}.json`)
					]);
					if (!isThirdPartyAuthor) {
						let documentsToSend = _.cloneDeep(state.get(["activities"]));
						documentsToSend.shift();
						documentsToSend = createExperiencesInventoryFromActivities(documentsToSend);
						await saveJsonToS3WithKeyPrefix(documentsToSend, env.s3.contentBucket, keyPrefix, env.artifacts.inventoryFileName, "");
					}
				}
				resolve();
			} catch (err) {
				console.error(err);
				reject(err);
			}
		}).catch((err) => {
			console.error(err);
			reject(err);
		});
	});

}

export function toggleSpeedType(document) {
	const documents = state.get(["activities"]);

	const newDocuments = [];

	for (const doc of documents) { // eslint-disable-line no-unused-vars
		if (!doc.hasOwnProperty("newDoc") || !doc.newDoc) {
			if (doc.id === document.id) {
				if (doc.speedType.toLowerCase() === "mph") {
					doc.speedType = "KIAS";
				} else {
					doc.speedType = "MPH";
				}
			}
			newDocuments.push(doc);
		}
	}



	// TODO: Can get out of sync without promise
	saveJsonToS3(createExperiencesInventoryFromActivities(newDocuments), env.s3.contentBucket, env.artifacts.inventoryFileName).then(() => {
		setActivities(newDocuments);
	}).catch(err => {
		throw err;
	});
}

export async function getPrintTemplates() {
	let headers = new Headers();

	headers.append("Authorization", "Basic amVmZi5ib25hc3NvQG1pcmFsb3VhZXJvLmNvbTpTaXhGb3VyNzJHb2xm");

	const responseTemplates = await fetch("https://miralouaero.jsreportonline.net/odata/templates?$select=name", {
		method: "GET",
		headers: headers
	});
	const jsonTemplates = await responseTemplates.json();
	const templates = jsonTemplates.value;

	return templates;
}

export async function getResolvedTemplate(templateId) {
	let headers = new Headers();

	headers.append("Authorization", "Basic amVmZi5ib25hc3NvQG1pcmFsb3VhZXJvLmNvbTpTaXhGb3VyNzJHb2xm");

	const responseTemplate = await fetch("https://miralouaero.jsreportonline.net/odata/templates(" + templateId + ")", {
		method: "GET",
		headers: headers
	});
	const jsonTemplate = await responseTemplate.json();
	const template = jsonTemplate.value[0].content;

	const templateObject = {
		"content": template,
		"engine": "none",
		"recipe": "html"
	};

	const myData = { "template": templateObject, "data": JSON.stringify({}) };

	jsreport.serverUrl = "https://miralouaero.jsreportonline.net";

	//add custom headers to ajax calls
	jsreport.headers["Authorization"] = "Basic amVmZi5ib25hc3NvQG1pcmFsb3VhZXJvLmNvbTpTaXhGb3VyNzJHb2xm";

	//render through AJAX request and return promise with array buffer response
	try {
		const resBuffer = await jsreport.renderAsync(myData);

		utils.hideLoader(state, "loadingSpinner");

		return resBuffer.toString();
	} catch (err) {
		utils.hideLoader(state, "loadingSpinner");

		alert("Error: " + err.toString());
	}
}

export function printTemplateWithContentLegacy(name, data, content, orientation) { //eslint-disable-line
	return new Promise((resolve, reject) => {
		state.set(["appState", "documents", "showSpinner"], true);

		// recurseDriveRefsToUrls(data.children, data.id, "", "");

		if (isMobile()) {
			postMessage({
				method: "showSpinner"
			});
		}

		const template = {
			"content": content,
			"engine": "handlebars",
			"recipe": "chrome-pdf",
			"electron": {
				"landscape": orientation === "landscape" ? true : false
			}
		};

		let newTemplate = template;

		if (data.hasOwnProperty("authorProperties") && data.authorProperties.hasOwnProperty("jsreportTemplate")) {
			newTemplate = Object.assign({}, template, data.authorProperties.jsreportTemplate);

			if (newTemplate.recipe !== "electron-pdf") {
				delete newTemplate.electron;
			}
		}

		const myData = { "template": newTemplate, "data": JSON.stringify(preparePdfDataEmojiImages(data)) };

		jsreport.serverUrl = env.jsreports.url;

		// add custom headers to ajax calls
		jsreport.headers.Authorization = env.jsreports.auth;
		// jsreport.headers['Content-Type'] = "application/json";

		// render through AJAX request and return promise with array buffer response
		jsreport.renderAsync(myData).then((res) => {
			console.log("Results from jsreports: ", res);

			state.set(["appState", "documents", "showSpinner"], false);

			if (isMobile()) {
				postMessage({ method: "base64Blob", base64: res.toDataURI() });
				postMessage({
					method: "hideSpinner"
				});
			} else {
				postMessage({ method: "showGoBack" });
				res.download(name + ".pdf");
			}
			resolve();
		}, (reason) => {
			state.set(["appState", "documents", "showSpinner"], false);

			alert(`Error: ${reason.status}\n${reason.statusText}`);
			if (isMobile()) {
				postMessage({
					method: "hideSpinner"
				});
				postMessage({
					method: "showError",
					errorTitle: "Print Failed",
					errorText: `An error occurred while attempting to print the report: ${reason.statusText}`
				});
			}
			reject(reason);
			// rejection
		});
	});
}

export function printTemplateWithContent(name, data, content, orientation, config = {}) { //eslint-disable-line
	return new Promise((resolve, reject) => {
		const manageSpinner = _.get(config, "manageSpinner", true);

		if (manageSpinner) {
			setGenericPrintSpinnerVisible(true);
		}

		// recurseDriveRefsToUrls(data.children, data.id, "", "");

		if (isMobile() && manageSpinner) {
			postMessage({
				method: "showSpinner"
			});
		}

		const landscape = orientation === "landscape" ? true : false;

		const template = {
			"content": content,
			"engine": "jsrender",
			"recipe": "chrome-pdf",
			"chrome": {
				"landscape": landscape,
				"printBackground": true,
				"marginTop": "0cm",
				"marginRight": "0cm",
				"marginBottom": "0cm",
				"marginLeft": "0cm",
				"preferCSSPageSize": true
			}
		};

		let authorProperties = _.get(data, "authorProperties", {});
		let templateOverride = {};
		let newTemplate = template;

		if (_.isString(authorProperties)) {
			try {
				authorProperties = JSON.parse(authorProperties);
			} catch (_err) {
				authorProperties = {};
			}
		}

		templateOverride = _.get(authorProperties, "jsreportTemplate", {});

		if (_.isString(templateOverride)) {
			try {
				templateOverride = JSON.parse(templateOverride);
			} catch (_err) {
				templateOverride = {};
			}
		}

		if (_.isPlainObject(templateOverride) && !_.isEmpty(templateOverride)) {
			newTemplate = _.merge({}, template, templateOverride);
			newTemplate.content = content;
		}

		if (newTemplate.recipe === "electron-pdf") {
			delete newTemplate.chrome;
			newTemplate.electron = _.merge({}, newTemplate.electron, {
				"landscape": landscape
			});
		} else {
			delete newTemplate.electron;
			newTemplate.chrome = _.merge({}, newTemplate.chrome, {
				"landscape": landscape
			});
		}

		const myData = { "template": newTemplate, "data": preparePdfDataEmojiImages(data, config) };

		jsreport.serverUrl = env.jsreports.url;

		// add custom headers to ajax calls
		jsreport.headers.Authorization = env.jsreports.auth;
		// jsreport.headers['Content-Type'] = "application/json";

		// render through AJAX request and return promise with array buffer response
		jsreport.renderAsync(myData).then((res) => {
			console.log("Results from jsreports: ", res);

			if (manageSpinner) {
				setGenericPrintSpinnerVisible(false);
			}

			if (isMobile()) {
				postMessage({ method: "base64Blob", base64: res.toDataURI() });
				if (manageSpinner) {
					postMessage({
						method: "hideSpinner"
					});
				}
			} else {
				postMessage({ method: "showGoBack" });
				const previewHost = getPdfPreviewHost(config);
				if (config.preview === true && previewHost) {
					const blob = res.toBlob();
					const blobUrl = window.URL.createObjectURL(blob);
					previewHost.showPdfPreview(blobUrl);
				} else {
					res.download(name + ".pdf");
				}
			}
			resolve();
		}, (reason) => {
			if (manageSpinner) {
				setGenericPrintSpinnerVisible(false);
			}

			alert(`Error: ${reason.status}\n${reason.statusText}`);
			if (isMobile()) {
				if (manageSpinner) {
					postMessage({
						method: "hideSpinner"
					});
				}
				postMessage({
					method: "showError",
					errorTitle: "Print Failed",
					errorText: `An error occurred while attempting to print the report: ${reason.statusText}`
				});
			}
			reject(reason);
			// rejection
		});
	});
}


export function printTemplate2(name, data, templateId, config = {}) { //eslint-disable-line
	return new Promise((resolve, reject) => {
		state.set(["appState", "documents", "showSpinner"], true);

		if (data.hasOwnProperty("children")) {
			recurseDriveRefsToUrls(data.children, data.id, "", "");
		}

		if (isMobile()) {
			postMessage({
				method: "showSpinner"
			});
		}

		const myData = { template: { name: templateId }, data: preparePdfDataEmojiImages(data, config) };

		// This could be API Gateway - this seems more secure as we would not even have public endpoint for reporting
		// Call lambda
		const lambda = new AWS.Lambda({ region: env.aws.defaultRegion, apiVersion: "2015-03-31" });

		const params = {
			// Put in env var
			FunctionName: "service-jsreport-lambda-proxy-v2-prod",
			InvocationType: "RequestResponse",
			LogType: "None",
			Payload: JSON.stringify({
				renderRequest: myData
			})
		};

		lambda.invoke(params, (error, data) => {
			if (error) {
				state.set(["appState", "documents", "showSpinner"], false);
				alert(`Error: ${error.statusCode} (${error.code}) ${error.message}`);
				if (isMobile()) {
					postMessage({
						method: "hideSpinner"
					});
					postMessage({
						method: "showError",
						errorTitle: "Print Failed",
						errorText: `An error occurred while attempting to print the report: ${error.statusCode} (${error.code}) ${error.message}`
					});
				}
				reject(error);
			} else {
				const result = JSON.parse(data.Payload);

				if (result.hasOwnProperty("errorType")) {
					state.set(["appState", "documents", "showSpinner"], false);

					alert(`Error: ${result.errorMessage}`);
					if (isMobile()) {
						postMessage({
							method: "hideSpinner"
						});
						postMessage({
							method: "showError",
							errorTitle: "Print Failed",
							errorText: `An error occurred while attempting to print the report: ${result.errorMessage}`
						});
					}
					reject(error);
				} else {
					console.log("Results from jsreports: ", result.body);

					state.set(["appState", "documents", "showSpinner"], false);

					// Saw article recommending to use contentDisposition - no javascript and no data limits

					if (isMobile()) {
						postMessage({ method: "base64Blob", base64: "data:application/pdf;base64," + result.body });
						postMessage({
							method: "hideSpinner"
						});
					} else {
						postMessage({ method: "showGoBack" });

						// const blob = new Blob([result.body], { type: "application/pdf;charset=utf-8" });

						if (config.hasOwnProperty("docTypeExt")) {
							FileSaver.saveAs("data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + result.body, `${name}.${config.docTypeExt}`);
						} else {
							FileSaver.saveAs("data:application/pdf;base64," + result.body, `${name}.pdf`);
						}
					}
					resolve();
				}
			}
		});
	});
}

export function renderTemplateResponse(data, templateId, config = {}) {
	assertCalculatedPrintLayout(data);
	data = projectCustomerPricingPayload(data);
	if (data.hasOwnProperty("children")) {
		recurseDriveRefsToUrls(data.children, data.id, "", "");
	}

	const printData = preparePdfDataEmojiImages(data, config);
	const myData = { template: { name: templateId }, data: JSON.stringify(printData) };

	jsreport.serverUrl = env.jsreports.url;
	jsreport.headers.Authorization = env.jsreports.auth;

	return jsreport.renderAsync(myData);
}

export function printTemplate(name, data, templateId, config = {}) { //eslint-disable-line
	data = projectCustomerPricingPayload(data);
	return new Promise((resolve, reject) => {
		try {
			const manageSpinner = _.get(config, "manageSpinner", true);

			if (manageSpinner) {
				state.set(["appState", "documents", "showSpinner"], true);
				state.set(["appState", "status", "showSpinner"], true);
			}

			//this is a hack, need to handle spinner outside this method since it is used in multiple places
			if (manageSpinner) {
				state.set(["appState", "editor", "showSpinner"], true);
			}
			if (isMobile() && manageSpinner) {
				postMessage({
					method: "showSpinner"
				});
			}

			// render through AJAX request and return promise with array buffer response
			renderTemplateResponse(data, templateId, config).then((res) => {
				console.log("Results from jsreports: ", res);

				// open in new window
				//window.open(res.toDataURI());

				//window.location.href = "data:image/gif;base64,R0lGODlhAQABAAAAACw=";
				//window.open("https://www.ambifi.com", "_blank");
				// open download dialog

				//actions.postMessage({ method: "showGoBack" });

				//console.log(res.toDataURI());

				if (manageSpinner) {
					state.set(["appState", "documents", "showSpinner"], false);
					state.set(["appState", "status", "showSpinner"], false);
					state.set(["appState", "editor", "showSpinner"], false);
				}

				if (isMobile()) {
					postMessage({ method: "base64Blob", base64: res.toDataURI() });
					if (manageSpinner) {
						postMessage({
							method: "hideSpinner"
						});
					}
				} else {
					postMessage({ method: "showGoBack" });

					const extension = config && config.hasOwnProperty("docTypeExt") ? config.docTypeExt : "pdf";
					const previewHost = getPdfPreviewHost(config);

					const shouldPreviewPdf = config.preview === true
						&& extension === "pdf"
						&& previewHost;

					if (shouldPreviewPdf) {
						const blob = res.toBlob();
						const blobUrl = window.URL.createObjectURL(blob);
						previewHost.showPdfPreview(blobUrl);
					} else {
						res.download(`${name}.${extension}`);
					}
				}
				resolve();
			}, (reason) => {
				if (manageSpinner) {
					state.set(["appState", "documents", "showSpinner"], false);
					state.set(["appState", "status", "showSpinner"], false);
					state.set(["appState", "editor", "showSpinner"], false);
				}

				alert(`Error: ${reason.status}\n${reason.statusText}`);
				if (isMobile()) {
					if (manageSpinner) {
						postMessage({
							method: "hideSpinner"
						});
					}
					postMessage({
						method: "showError",
						errorTitle: "Print Failed",
						errorText: `An error occurred while attempting to print the report: ${reason.statusText}`
					});
				}
				reject(reason);
				// rejection
			});

		} catch (err) {
			if (_.get(config, "manageSpinner", true)) {
				state.set(["appState", "documents", "showSpinner"], false);
				state.set(["appState", "status", "showSpinner"], false);
				state.set(["appState", "editor", "showSpinner"], false);
			}

			alert(`Error: ${err.message}`);
			reject(err);
		}
	});
}

function getPdfPreviewHost(config = {}) {
	const explicitPreviewHost = _.get(config, "previewHost");
	if (explicitPreviewHost && typeof explicitPreviewHost.showPdfPreview === "function") {
		return explicitPreviewHost;
	}

	if (typeof window === "undefined") {
		return null;
	}

	const hostMap = {
		documents: window.globalDocumentsView,
		editor: window.globalEditorView,
		searchHistory: window.globalSearchHistoryView,
		publications: window.globalPublicationsView
	};
	const activeNav = String(state.get(["appState", "navPanel", "selected"]) || "").trim();
	const preferredPreviewHost = String(_.get(config, "preferredPreviewHost", "") || "").trim();
	const activePreviewHost = activeNav === "myChecklists" ? "documents" : activeNav;
	const previewHostKeys = _.uniq([
		preferredPreviewHost,
		hostMap[activePreviewHost] ? activePreviewHost : "",
		"documents",
		"editor",
		"publications",
		"searchHistory"
	].filter(Boolean));

	for (let i = 0; i < previewHostKeys.length; i++) {
		const previewHost = hostMap[previewHostKeys[i]];
		if (previewHost && typeof previewHost.showPdfPreview === "function") {
			return previewHost;
		}
	}

	return null;
}

export function printInlineTemplate(name, data, template, config = {}) { //eslint-disable-line
	data = projectCustomerPricingPayload(data);
	return new Promise((resolve, reject) => {
		try {
			assertCalculatedPrintLayout(data);
			const manageSpinner = _.get(config, "manageSpinner", true);

			if (manageSpinner) {
				state.set(["appState", "documents", "showSpinner"], true);
				state.set(["appState", "status", "showSpinner"], true);
				state.set(["appState", "editor", "showSpinner"], true);
			}

			if (isMobile() && manageSpinner) {
				postMessage({
					method: "showSpinner"
				});
			}

			const myData = {
				template,
				data: preparePdfDataEmojiImages(data, config)
			};

			jsreport.serverUrl = env.jsreports.url;
			jsreport.headers.Authorization = env.jsreports.auth;

			jsreport.renderAsync(myData).then((res) => {
				if (manageSpinner) {
					state.set(["appState", "documents", "showSpinner"], false);
					state.set(["appState", "status", "showSpinner"], false);
					state.set(["appState", "editor", "showSpinner"], false);
				}

				if (isMobile()) {
					postMessage({ method: "base64Blob", base64: res.toDataURI() });
					if (manageSpinner) {
						postMessage({
							method: "hideSpinner"
						});
					}
				} else {
					postMessage({ method: "showGoBack" });

					const extension = config && config.hasOwnProperty("docTypeExt") ? config.docTypeExt : "pdf";
					const previewHost = getPdfPreviewHost(config);

					const shouldPreviewPdf = config.preview === true
						&& extension === "pdf"
						&& previewHost;

					if (shouldPreviewPdf) {
						const blob = res.toBlob();
						const blobUrl = window.URL.createObjectURL(blob);
						previewHost.showPdfPreview(blobUrl);
					} else {
						res.download(`${name}.${extension}`);
					}
				}
				resolve();
			}, (reason) => {
				if (manageSpinner) {
					state.set(["appState", "documents", "showSpinner"], false);
					state.set(["appState", "status", "showSpinner"], false);
					state.set(["appState", "editor", "showSpinner"], false);
				}

				alert(`Error: ${reason.status}\n${reason.statusText}`);
				if (isMobile()) {
					if (manageSpinner) {
						postMessage({
							method: "hideSpinner"
						});
					}
					postMessage({
						method: "showError",
						errorTitle: "Print Failed",
						errorText: `An error occurred while attempting to print the report: ${reason.statusText}`
					});
				}
				reject(reason);
			});
		} catch (err) {
			if (_.get(config, "manageSpinner", true)) {
				state.set(["appState", "documents", "showSpinner"], false);
				state.set(["appState", "status", "showSpinner"], false);
				state.set(["appState", "editor", "showSpinner"], false);
			}

			alert(`Error: ${err.message}`);
			reject(err);
		}
	});
}

export async function printFromMemory(document, columns = false, numColumns = 5, orientation = "portrait", custom = false, config = {}) { //eslint-disable-line
	showGenericPrintSpinner("Preparing activity...");
	try {
		let checklist = document;

		setGenericPrintSpinnerMessage("Resolving drive references...");
		checklist = await prepareActivityForDirectSignedPrintUrls(checklist);

		setGenericPrintSpinnerMessage("Preparing content...");
		utils.recurseReplaceSpeeds(checklist.children);
		utils.recurseConvertChecklistToMarkdown(checklist.children, true, { checklist });

		let templateId;

		if (columns) {
			if (isChecklistItems(checklist)) {
				templateId = "ambifi-items-columns";
			} else if (isChecklistSections(checklist)) {
				templateId = "ambifi-sections-columns";
			} else if (isChecklistLists(checklist)) {
				templateId = "ambifi-lists-columns";
			}
		} else {
			if (isChecklistItems(checklist)) {
				if (checklist.publisher.toLowerCase() === "checkmate") {
					templateId = "miracheck-items-checkmate";
				} else {
					templateId = "ambifi-items";
				}
			} else if (isChecklistSections(checklist)) {
				if (checklist.publisher.toLowerCase() === "checkmate") {
					templateId = "miracheck-sections-checkmate";
				} else {
					templateId = "ambifi-sections";
				}
			} else if (isChecklistLists(checklist)) {
				if (checklist.publisher.toLowerCase() === "checkmate") {
					templateId = "miracheck-lists-checkmate";
				} else {
					templateId = "ambifi-lists";
				}
			}
		}

		const template = checklist.printTemplate;

		if (custom && template && template.trim().length > 0) {
			removeAlternatives(checklist);
			setGenericPrintSpinnerMessage("Generating PDF...");
			await printTemplateWithContent(document.name, checklist, template, orientation, config);
		} else if (custom && (_.isUndefined(template) || (template && template.trim.length === 0))) {
			hideGenericPrintSpinner();
			alert("You do not have a Print Template. You need to add a Print Template in the Checklist properties.");
		} else {
			setGenericPrintSpinnerMessage("Generating PDF...");
			await printTemplate(document.name, checklist, templateId, config);
		}
	} catch (err) {
		hideGenericPrintSpinner();
		throw err;
	} finally {
		setGenericPrintSpinnerMessage("");
	}
}

function setAiReportPreparationSpinnerMessage(message) {
	state.set(["appState", "documents", "spinnerMessage"], message);
	state.set(["appState", "editor", "spinnerMessage"], message);
}

function showAiReportPreparationSpinner(message = "Preparing AI report...") {
	setAiReportPreparationSpinnerMessage(message);
	state.set(["appState", "documents", "showSpinner"], true);
	state.set(["appState", "status", "showSpinner"], true);
	state.set(["appState", "editor", "showSpinner"], true);
}

function hideAiReportPreparationSpinner() {
	setAiReportPreparationSpinnerMessage("");
	state.set(["appState", "documents", "showSpinner"], false);
	state.set(["appState", "status", "showSpinner"], false);
	state.set(["appState", "editor", "showSpinner"], false);
}

export async function printAiReportFromMemory(document, config = {}) {
	showAiReportPreparationSpinner("Preparing activity...");
	try {
		let checklist = document;

		setAiReportPreparationSpinnerMessage("Resolving drive references...");
		checklist = await prepareActivityForDirectSignedPrintUrls(checklist);

		setAiReportPreparationSpinnerMessage("Preparing content...");
		utils.recurseReplaceSpeeds(checklist.children);
		utils.recurseConvertChecklistToMarkdown(checklist.children, true, { checklist });

		setAiReportPreparationSpinnerMessage("Generating AI report PDF...");
		await printTemplate(document.name, checklist, "ambifi-ai-report", config);
	} catch (err) {
		hideAiReportPreparationSpinner();
		throw err;
	} finally {
		setAiReportPreparationSpinnerMessage("");
	}
}

export function print(document, columns = false, numColumns = 5, orientation = "portrait", custom = false, config = {}) { // eslint-disable-line
	showGenericPrintSpinner("Loading activity...");
	refreshCredentials().then(() => {
		const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get(), document);

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${document.id}.json` }, async (err, data) => {
			if (err) {
				hideGenericPrintSpinner();
				console.log(err, err.stack);
				alert(`${err}; ${err.stack}`);
			} else {
				try {
					let checklist = JSON.parse(data.Body.toString());

					setGenericPrintSpinnerMessage("Resolving drive references...");
					checklist = await prepareActivityForDirectSignedPrintUrls(checklist);

					setGenericPrintSpinnerMessage("Preparing content...");
					recurseReplaceSpeeds(checklist.children);
					recurseConvertChecklistToMarkdown(checklist.children, true, { checklist });

					let templateId;

					if (columns) {
						if (isChecklistItems(checklist)) {
							templateId = "ambifi-items-columns";
						} else if (isChecklistSections(checklist)) {
							templateId = "ambifi-sections-columns";
						} else if (isChecklistLists(checklist)) {
							templateId = "ambifi-lists-columns";
						}
					} else {
						if (isChecklistItems(checklist)) {
							if (checklist.publisher.toLowerCase() === "checkmate") {
								templateId = "miracheck-items-checkmate";
							} else {
								templateId = "ambifi-items";
							}
						} else if (isChecklistSections(checklist)) {
							if (checklist.publisher.toLowerCase() === "checkmate") {
								templateId = "miracheck-sections-checkmate";
							} else {
								templateId = "ambifi-sections";
							}
						} else if (isChecklistLists(checklist)) {
							if (checklist.publisher.toLowerCase() === "checkmate") {
								templateId = "miracheck-lists-checkmate";
							} else {
								templateId = "ambifi-lists";
							}
						}
					}

					const template = checklist.printTemplate;

					if (custom && template && template.trim().length > 0) {
						removeAlternatives(checklist);
						setGenericPrintSpinnerMessage("Generating PDF...");
						await printTemplateWithContent(document.name, checklist, template, orientation, config);
					} else if (custom && (_.isUndefined(template) || (template && template.trim.length === 0))) {
						hideGenericPrintSpinner();
						alert("You do not have a Print Template. You need to add a Print Template in the Checklist properties.");
					} else {
						setGenericPrintSpinnerMessage("Generating PDF...");
						await printTemplate(document.name, checklist, templateId, config);
					}
				} catch (printErr) {
					hideGenericPrintSpinner();
					console.error(printErr);
					showError2("Print failed", printErr);
				} finally {
					setGenericPrintSpinnerMessage("");
				}
			}
		});

	}).catch((err) => {
		hideGenericPrintSpinner();
		console.error(err);
		showError2("Print failed", err);
	});
}

export function printAiReport(document, config = {}) {
	showAiReportPreparationSpinner("Loading activity...");
	refreshCredentials().then(() => {
		const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get(), document);

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${document.id}.json` }, async (err, data) => {
			if (err) {
				hideAiReportPreparationSpinner();
				console.log(err, err.stack);
				alert(`${err}; ${err.stack}`);
			} else {
				try {
					let checklist = JSON.parse(data.Body.toString());

					setAiReportPreparationSpinnerMessage("Resolving drive references...");
					checklist = await prepareActivityForDirectSignedPrintUrls(checklist);

					setAiReportPreparationSpinnerMessage("Preparing content...");
					recurseReplaceSpeeds(checklist.children);
					recurseConvertChecklistToMarkdown(checklist.children, true, { checklist });

					setAiReportPreparationSpinnerMessage("Generating AI report PDF...");
					await printTemplate(document.name, checklist, "ambifi-ai-report", config);
				} catch (printErr) {
					hideAiReportPreparationSpinner();
					console.error(printErr);
					showError2("Print failed", printErr);
				} finally {
					setAiReportPreparationSpinnerMessage("");
				}
			}
		});
	}).catch((err) => {
		hideAiReportPreparationSpinner();
		console.error(err);
		showError2("Print failed", err);
	});
}

export function exportContentToJson(document, convertToCsv = false) {
	refreshCredentials().then(() => {
		const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get(), document);

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${document.id}.json` }, (err, data) => {
			if (err) {
				console.log(err, err.stack);
				alert(`${err}; ${err.stack}`);
			} else {
				let checklist = JSON.parse(data.Body.toString());
				recurseReplaceSpeeds(checklist.children);

				exportContentDumpToJson(checklist, convertToCsv);
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Export content as JSON failed", err);
	});

}

export function exportDocForReview(document) { // eslint-disable-line
	showGenericPrintSpinner("Loading activity...");
	refreshCredentials().then(() => {
		const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get(), document);

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${document.id}.json` }, async (err, data) => {
			if (err) {
				hideGenericPrintSpinner();
				console.log(err, err.stack);
				alert(`${err}; ${err.stack}`);
			} else {
				try {
					let checklist = JSON.parse(data.Body.toString());

					setGenericPrintSpinnerMessage("Resolving image references...");
					checklist = await prepareActivityForDirectSignedPrintUrls(checklist);

					setGenericPrintSpinnerMessage("Preparing content cards...");
					const contentReview = buildContentReviewV2Model(checklist);

					setGenericPrintSpinnerMessage("Generating document...");
					await printTemplate(
						document.name + " - " + document.id,
						contentReview,
						"content-review-v2",
						{
							"disablePrintEmojiImages": true,
							"docTypeExt": "docx"
						}
					);
				} catch (printErr) {
					hideGenericPrintSpinner();
					console.error(printErr);
					showError2("Export doc for review failed", printErr);
				} finally {
					setGenericPrintSpinnerMessage("");
				}
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Export doc for review failed", err);
	});
}

export function printShowMode(document, config = {}) {
	showGenericPrintSpinner("Loading activity...");
	refreshCredentials().then(() => {
		const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get(), document);

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${document.id}.json` }, async (err, data) => {
			if (err) {
				hideGenericPrintSpinner();
				console.log(err, err.stack);
				alert(`${err}; ${err.stack}`);
			} else {
				try {
					let checklist = JSON.parse(data.Body.toString());

					setGenericPrintSpinnerMessage("Resolving drive references...");
					checklist = await prepareActivityForDirectSignedPrintUrls(checklist);

					setGenericPrintSpinnerMessage("Preparing content...");
					recurseReplaceSpeeds(checklist.children);
					recurseConvertChecklistToMarkdown(checklist.children, true, { checklist });

					let templateId;

					console.log("Org ID: " + getOrgId());

					if (getOrgId() === "641d5a7f-4a87-11e9-a392-061714f61e3e" && isChecklistItems(checklist)) {
						templateId = "chop-orientation";
					} else if ((getOrgId() === "57c412f1-83a5-11e8-a392-061714f61e3e" || getOrgId() === "421433d6-c0d4-11e9-b530-066917b38554")) {
						if (isChecklistItems(checklist)) {
							templateId = "ambifi-items-orientation";
						} else if (isChecklistSections(checklist)) {
							templateId = "ambifi-sections-orientation";
						} else if (isChecklistLists(checklist)) {
							templateId = "ambifi-lists-orientation";
						}
					} else {
						if (isChecklistItems(checklist)) {
							templateId = "ambifi-items-show-mode";
						} else if (isChecklistSections(checklist)) {
							templateId = "ambifi-sections-show-mode";
						} else if (isChecklistLists(checklist)) {
							templateId = "ambifi-lists-show-mode";
						}
					}

					setGenericPrintSpinnerMessage("Generating PDF...");
					await printTemplate(document.name, checklist, templateId, config);
				} catch (printErr) {
					hideGenericPrintSpinner();
					console.error(printErr);
					showError2("Print failed", printErr);
				} finally {
					setGenericPrintSpinnerMessage("");
				}
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Print failed", err);
	});
}

function removeAlternatives(checklist) {
	let lists = checklist.children;
	removeAlternativesRecurse(lists, checklist, 0, 0);
}

function removeAlternativesRecurse(arr, listIndex, sectionIndex) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			listIndex = i;
			let nameList = arr[i].name;
			nameList = nameList.replace(" | ", "|");
			let nameListParts = nameList.split("|");
			if (nameListParts.length > 0) {
				arr[i].name = nameListParts[0];
			}
		} else if (arr[i].type === "section") {
			sectionIndex = i;
			let nameSection = arr[i].name;
			nameSection = nameSection.replace(" | ", "|");
			let nameSectionParts = nameSection.split("|");
			if (nameSectionParts.length > 0) {
				arr[i].name = nameSectionParts[0];
			}
		} else if (arr[i].type.startsWith("item")) { // eslint-disable-line
		}

		if (arr[i].hasOwnProperty("children")) {
			removeAlternativesRecurse(arr[i].children, listIndex, sectionIndex);
		}
	}
}

export function getExtractOld(sql = "", fields = [], filePrefix = "extract-") {
	refreshCredentials().then(() => {
		let event = {
			orgId: getOrgId(),
			identityId: getIdentityId(),
			csvFilename: filePrefix + moment().format() + ".csv"
		};

		if (sql !== "") {
			event.sql = sql;
			event.fields = fields;
		}

		let lambda = new AWS.Lambda({ region: "us-east-1", apiVersion: "2015-03-31" });
		let params = {
			FunctionName: env.lambda.extractHistoryCsvFunction,
			InvocationType: "RequestResponse",
			LogType: "None",
			Payload: JSON.stringify(event)
		};

		state.set(["appState", "documents", "showSpinner"], true);
		lambda.invoke(params, function (error, data) {
			if (error) {

				state.set(["appState", "documents", "showSpinner"], false);
				alert(error.message);
			} else {
				const result = data.Payload;

				const newResult = JSON.parse(result);
				console.log(newResult.outputLocation);
				console.log(JSON.stringify(result));
				// get s3 document
				const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "text/csv", ResponseCacheControl: "no-cache" } });
				bucket.getObject({ Key: newResult.outputFileLocation }, (err, data) => {
					state.set(["appState", "documents", "showSpinner"], false);
					if (err) {
						console.log(err, err.stack);
						alert(`${err}; ${err.stack}`);
					} else {
						const csv = data.Body;
						//console.log(csv);

						createBlobCsv2(csv, event.csvFilename);
					}
				});
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("Extract failed", err);
	});
}

export function getExtract(sql = "", fields = [], filePrefix = "extract-") {
	refreshCredentials().then(() => {
		let event = {
			orgId: getOrgId(),
			identityId: getIdentityId(),
			email: getEmail(),
			csvFilename: filePrefix + moment().format() + ".csv"
		};

		if (sql !== "") {
			event.sql = sql;
			event.fields = fields;
		}

		let lambda = new AWS.Lambda({ region: "us-east-1", apiVersion: "2015-03-31" });
		let params = {
			FunctionName: env.lambda.extractHistoryCsvFunction,
			InvocationType: "Event",
			LogType: "None",
			Payload: JSON.stringify(event)
		};

		state.set(["appState", "documents", "showSpinner"], true);
		lambda.invoke(params, function (error, data) {
			if (error) {

				state.set(["appState", "documents", "showSpinner"], false);
				alert(error.message);
			} else {

				showInfo("Extract", "You have successfuly submitted the extract. You will get an email when the extract is complete.");

				// const result = data.Payload;

				// const newResult = JSON.parse(result);
				// console.log(newResult.outputLocation);
				// console.log(JSON.stringify(result));
				// // get s3 document
				// const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "text/csv", ResponseCacheControl: "no-cache" } });
				// bucket.getObject({ Key: newResult.outputFileLocation }, (err, data) => {
				// 	state.set(["appState", "documents", "showSpinner"], false);
				// 	if (err) {
				// 		console.log(err, err.stack);
				// 		alert(`${err}; ${err.stack}`);
				// 	} else {
				// 		const csv = data.Body;
				// 		//console.log(csv);

				// 		createBlobCsv2(csv, event.csvFilename);
				// 	}
				// });
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("Extract failed", err);
	});
}
export function exportCsv(document) {
	refreshCredentials().then(() => {
		const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get(), document);

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${document.id}.json` }, (err, data) => {
			if (err) {
				console.log(err, err.stack);
				alert(`${err}; ${err.stack}`);
			} else {
				const checklist = JSON.parse(data.Body.toString());
				const resArr = [["list", "section", "label1", "label2", "labelOnly", "labelOnlyBackgroundColor", "mandatory"]];
				const lastList = "";
				const lastSection = "";

				recurseToFlatArray(checklist.children, lastList, lastSection, resArr);

				const lineArray = [];
				resArr.forEach((infoArray) => {
					const line = infoArray.join(",");
					lineArray.push(line);
				});
				const csvContent = lineArray.join("\n");

				createBlobCsv2(csvContent, `${checklist.name}.csv`);
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Export failed", err);
	});
}

export function exportCsvAdvanced(document) {
	refreshCredentials().then(() => {
		const keyPrefix = getKeyPrefix(state.select(["user", "identityId"]).get(), document);

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${document.id}.json` }, (err, data) => {
			if (err) {
				console.log(err, err.stack);
				alert(`${err}; ${err.stack}`);
			} else {
				const checklist = JSON.parse(data.Body.toString());
				const resArr = [
					[
						"checklistId",
						"checklistName",
						"checklistAudio",
						"checklistPrint",
						"checklistDescription",
						"checklistDontSpeakAudio",
						"checklistTrackData",
						"checklistTrackLocation",
						"checklistGenre",
						"checklistTags",
						"listId",
						"listName",
						"listAudio",
						"listPrint",
						"listDefaultView",
						"listColor",
						"listIgnoreCompletion",
						"listDontPrint",
						"sectionId",
						"sectionName",
						"sectionAudio",
						"sectionPrint",
						"sectionColor",
						"sectionIconColor",
						"sectionBackgroundColor",
						"sectionBorderColor",
						"sectionIgnoreCompletion",
						"sectionDontPrint",
						"itemId",
						"itemType",
						"itemShowModeTextAlign",
						"itemLabel1",
						"itemLabel2",
						"itemComments",
						"itemCommentsInline",
						"itemMandatory",
						"itemIgnoreCompletion",
						"itemLabelOnly",
						"itemLabelOnlyBackgroundColor",
						"itemLabel1Color",
						"itemLabel1Audio",
						"itemLabel1Print",
						"itemLabel2Color",
						"itemLabel2Audio",
						"itemLabel2Print",

						"textInputPlaceholder",
						"textInputDefaultValue",
						"textInputMaxLength",
						"textInputKeyboardType",
						"textInputKeyboardAutoCapitalize",
						"textInputKeyboardAutoCorrect",
						"textInputKeyboardReturnKeyType",
						"textInputKeyboardReturnKeySubmitsItem",
						"textInputMaskType",
						"textInputCustomMask",
						"textInputCustomMask2",
						"textInputCurrencySymbol",
						"textInputCurrencySeparator",
						"textInputNumberOfLines",
						"inputType",
						"inputMin",
						"inputMax",
						"inputStep",
						"inputPrecision",

						"pickerItemViewType",
						"pickerVisualStyle",
						"pickerVisualColumns",
						"pickerVisualItemMaxWidth",
						"pickerVisualItemMaxWidthWeb",
						"pickerVisualItemMaxWidthMobile",
						"pickerVisualImageFit",
						"pickerVisualImageKey",
						"pickerVisualColorKey",
						"itemsDatasource",
						"associatedContentTemplate",
						"pickerItemsDatasource",
						"pickerItemPlaceholder",
						"pickerItemDefaultValue",
						"pickerLockWhenLaunchVarProvided",
						"pickerAutoSelectSingleOption",
						"pickerLockSingleOption",
						"pickerItems",
						"items",
						"pickerAdvanceOnSelect",
						"pickerLinkOnSelect",
						"pickerLinkActionType",

						"yesNoLinkOnSelect",
						"yesNoLinkActionType",
						"yesLinkActionType",
						"noLinkActionType",
						"naLinkActionType",
						"yesNoYesLinkId",
						"yesNoNoLinkId",
						"yesNoNaLinkId",
						"yesNoShowNa",
						"yesNoAdvanceOnSelect",

						"dateTimeType",
						"dateTimeInitialDate",
						"dateTimeMinuteInterval",
						"dateTimeAdvanceOnSelect",
						"dateTimePickerInline",

						"barcodeTypes",
						"barcodeManualEntryMultiline",
						"barcodeAllowEditScannedValue",
						"barcodeNormalizeTrim",
						"barcodeNormalizeStripLineBreaks",
						"barcodeNormalizeCase",
						"barcodeNormalizeUpcAFromEan13",
						"barcodeExpectedValue",
						"barcodeExpectedMatchMode",
						"barcodeValidationPattern",
						"barcodeValidationMessage",

						"imagePickerAddMediaButton",
						"imagePickerUploadTitle",
						"imagePickerCaptureMediaTitle",

						"sketchPadBackgroundColor",
						"sketchPadPenColor",
						"sketchPadPenWidth",

						"itemDontPrint",
						"itemStartTimer",
						"itemStopTimer",

						"itemLinkOnCheck",
						"itemLinkId",
						"itemLinkActionType"
					]
				];
				const lastList = "";
				const lastSection = "";
				recurseToFlatArrayAdvanced(checklist, checklist.children, lastList, lastSection, resArr);

				const lineArray = [];
				resArr.forEach((infoArray) => {
					const line = infoArray.join(",");
					lineArray.push(line);
				});
				const csvContent = lineArray.join("\n");
				createBlobCsv2(csvContent, `${checklist.name}.csv`);
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("Export failed", err);
	});
}

export function convertImageUrlToBase64(imageUrl) {
	refreshCredentials().then(() => {
		const lambda = new AWS.Lambda({ region: env.aws.defaultRegion, apiVersion: "2015-03-31" });

		const params = {
			FunctionName: "convertImageUrlToBase64",
			InvocationType: "RequestResponse",
			LogType: "None",
			Payload: `{"imageUrl":"${imageUrl}"}`,
		};

		lambda.invoke(params, (error, data) => {
			if (error) {
				alert(error);
			} else {
				console.log(data.Payload);
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Convert failed", err);
	});
}

export function sendEmail(toAddresses = [], subject = "", body = "", htmlBody, ccAddresses = [], senderEmail = "support@ambifi.com", replyToAddresses, charset = "UTF-8") {
	refreshCredentials().then(async () => {
		const emailParams = {
			Destination: { ToAddresses: toAddresses ? toAddresses : [], CcAddresses: ccAddresses ? ccAddresses : [] },
			Message: {
				Body: {
					Html: {
						Charset: charset ? charset : "UTF-8",
						Data: htmlBody ? htmlBody : body
					},
					Text: {
						Charset: charset ? charset : "UTF-8",
						Data: body
					}
				},
				Subject: {
					Charset: charset ? charset : "UTF-8",
					Data: subject
				}
			},
			Source: senderEmail
		};

		if (replyToAddresses) {
			emailParams.ReplyToAddresses = replyToAddresses;
		}

		await new AWS.SES({ apiVersion: "2010-12-01" }).sendEmail(emailParams).promise();

		// const lambda = new AWS.Lambda({ region: env.aws.defaultRegion, apiVersion: "2015-03-31" });

		// const params = {
		// 	FunctionName: env.lambda.sendEmailFunction,
		// 	InvocationType: "RequestResponse",
		// 	LogType: "None",
		// 	Payload: JSON.stringify({
		// 		method: "sendEmail",
		// 		toEmails: toEmails,
		// 		ccEmails: ccEmails,
		// 		bccEmails: bccEmails,
		// 		subject: subject,
		// 		body: body,
		// 		htmlBody: htmlBody ? htmlBody : body,
		// 		senderEmail: senderEmail,
		// 		replyToAddresses: replyToAddresses,
		//		charset: charset
		// 	}),
		// };

		// lambda.invoke(params, (error, data) => {
		// 	if (error) {
		// 		alert(error);
		// 	} else {
		// 		console.log(data.Payload);
		// 	}
		// });

	}).catch((err) => {
		console.error(err);
		showError2("Send email failed", err);
	});
}

function showErrorNoDetail(title, err) {
	if (err === null) {
		showError(title, "Unknown error.");
	} else if (err.code === "NetworkingError") {
		showError(title, "Network error. Please check connectivity and try again.");
	} else {
		showError(title, err.message);
	}
}


/**
 * NEW FUNCTIONS added as part of the larger refactor, need to focus more on cohesion to ensure these modules don't grow into confusing monoliths.
 */


function getUtcTimestamp() {
	// ISO 8601
	return moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
}

export function getActivityInstance(key) {
	return new Promise(async (resolve, reject) => {
		try {
			const instance = await getObject(env.s3.contentBucket, key, false);
			resolve(instance);
		} catch (e) {
			reject(e);
		}
	});
}

export function saveActivityInstance(instance, prefix = getIdentityId()) {
	return new Promise(async (resolve, reject) => {
		const instanceForSave = withComputedPricingTotals(instance);
		const { instanceId, id } = instanceForSave;
		let lastTimestamp = instanceForSave.history && _.isArray(instanceForSave.history) && !_.isEmpty(instanceForSave.history) ? (instanceForSave.history[0].timestamp).replace(" ", "T") : getUtcTimestamp();
		let fileName = id + "/" + lastTimestamp + "_" + instanceId + ".json";

		try {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
			await bucket.putObject({ Bucket: env.s3.contentBucket, Key: prefix + "/" + fileName, Body: JSON.stringify(instanceForSave), ContentType: "application/json" }).promise();
			resolve(instanceForSave);
		} catch (e) {
			reject(e);
		}
	});
}

export async function getActivity(activityId, prefix = getIdentityId()) {
	let activity = await getObject(env.s3.contentBucket, `${prefix}/${activityId}.json`);
	// If you are a third party author then we need the identityId in the activity
	if (prefix !== getIdentityId()) {
		activity.identityId = prefix;
	}

	return activity;
}

const isItemContainerType = (type) => _.isString(type) && type.toLowerCase() === "itemcontainer";
function hasValidChildNodes(children = []) {
	return Array.isArray(children) && children.some((child) => _.isObject(child) && _.isString(child.type));
}

function getValidChildNodes(children = []) {
	return Array.isArray(children) ? children.filter((child) => _.isObject(child) && _.isString(child.type)) : [];
}

function buildChildrenSignature(children = []) {
	const validChildren = getValidChildNodes(children);
	return validChildren.map((child) => {
		const guid = _.isString(child.guid) ? child.guid : "";
		const id = _.isString(child.id) ? child.id : "";
		const type = _.isString(child.type) ? child.type : "";
		return `${type}:${guid}:${id}`;
	}).join("|");
}

function buildNodeLookupByIdentity(nodes = [], lookup = {}) {
	if (!Array.isArray(nodes)) {
		return lookup;
	}
	nodes.forEach((node) => {
		if (!_.isObject(node)) {
			return;
		}
		if (_.isString(node.guid) && node.guid !== "") {
			lookup[`guid:${node.guid}`] = node;
		}
		if (_.isString(node.id) && node.id !== "") {
			lookup[`id:${node.id}`] = node;
		}
		if (Array.isArray(node.children) && node.children.length > 0) {
			buildNodeLookupByIdentity(node.children, lookup);
		}
	});
	return lookup;
}

function getNodeByIdentityOrCompatibleIndex(sourceNode = {}, candidateLookup = {}, candidateNodes = [], sourceIndex = -1) {
	if (!_.isObject(sourceNode)) {
		return null;
	}
	if (_.isString(sourceNode.guid) && sourceNode.guid !== "" && candidateLookup[`guid:${sourceNode.guid}`]) {
		return candidateLookup[`guid:${sourceNode.guid}`];
	}
	if (_.isString(sourceNode.id) && sourceNode.id !== "" && candidateLookup[`id:${sourceNode.id}`]) {
		return candidateLookup[`id:${sourceNode.id}`];
	}
	// Only permit index fallback when identity keys are absent and node type matches.
	if (
		(!_.isString(sourceNode.guid) || sourceNode.guid === "") &&
		(!_.isString(sourceNode.id) || sourceNode.id === "") &&
		Array.isArray(candidateNodes) &&
		_.isObject(candidateNodes[sourceIndex])
	) {
		const candidateNode = candidateNodes[sourceIndex];
		const sourceType = _.isString(sourceNode.type) ? sourceNode.type.toLowerCase() : "";
		const candidateType = _.isString(candidateNode.type) ? candidateNode.type.toLowerCase() : "";
		if (sourceType !== "" && sourceType === candidateType) {
			return candidateNode;
		}
	}
	return null;
}

function sourceHasItemContainerWithMissingChildren(nodes = []) {
	if (!Array.isArray(nodes)) {
		return false;
	}
	for (let i = 0; i < nodes.length; i += 1) {
		const node = nodes[i];
		if (!_.isObject(node)) {
			continue;
		}
		if (isItemContainerType(node.type)) {
			if (!hasValidChildNodes(node.children)) {
				return true;
			}
		}
		if (Array.isArray(node.children) && node.children.length > 0) {
			if (sourceHasItemContainerWithMissingChildren(node.children)) {
				return true;
			}
		}
	}
	return false;
}

function hydrateMissingItemContainerChildrenFromRuntime(sourceNodes = [], runtimeLookup = {}, runtimeNodes = []) {
	if (!Array.isArray(sourceNodes)) {
		return;
	}
	sourceNodes.forEach((sourceNode, sourceIndex) => {
		if (!_.isObject(sourceNode)) {
			return;
		}

		const runtimeNode = getNodeByIdentityOrCompatibleIndex(sourceNode, runtimeLookup, runtimeNodes, sourceIndex);

		if (isItemContainerType(sourceNode.type) && !hasValidChildNodes(sourceNode.children)) {
			if (runtimeNode && hasValidChildNodes(runtimeNode.children)) {
				sourceNode.children = _.cloneDeep(runtimeNode.children);
			} else if (!Array.isArray(sourceNode.children)) {
				sourceNode.children = [];
			}
		}

		if (Array.isArray(sourceNode.children) && sourceNode.children.length > 0) {
			const runtimeChildren = runtimeNode && Array.isArray(runtimeNode.children) ? runtimeNode.children : [];
			hydrateMissingItemContainerChildrenFromRuntime(sourceNode.children, runtimeLookup, runtimeChildren);
		}
	});
}

function reconcileStaleItemContainerChildrenFromRuntime(sourceNodes = [], runtimeLookup = {}, runtimeNodes = [], sourceRevision = 0, runtimeRevision = 0) {
	if (!Array.isArray(sourceNodes)) {
		return;
	}

	sourceNodes.forEach((sourceNode, sourceIndex) => {
		if (!_.isObject(sourceNode)) {
			return;
		}

		const runtimeNode = getNodeByIdentityOrCompatibleIndex(sourceNode, runtimeLookup, runtimeNodes, sourceIndex);

		if (isItemContainerType(sourceNode.type) && runtimeNode && hasValidChildNodes(runtimeNode.children)) {
			const sourceChildren = getValidChildNodes(sourceNode.children);
			const runtimeChildren = getValidChildNodes(runtimeNode.children);
			const sourceSignature = buildChildrenSignature(sourceChildren);
			const runtimeSignature = buildChildrenSignature(runtimeChildren);

			const sourceMissing = sourceChildren.length === 0;
			const runtimeHasMore = runtimeChildren.length > sourceChildren.length;
			const runtimeIsSameOrNewerAndDifferent = runtimeRevision >= sourceRevision && sourceSignature !== runtimeSignature;

			if (sourceMissing || runtimeHasMore || runtimeIsSameOrNewerAndDifferent) {
				sourceNode.children = _.cloneDeep(runtimeNode.children);
			}
		}

		if (Array.isArray(sourceNode.children) && sourceNode.children.length > 0) {
			const runtimeChildren = runtimeNode && Array.isArray(runtimeNode.children) ? runtimeNode.children : [];
			reconcileStaleItemContainerChildrenFromRuntime(sourceNode.children, runtimeLookup, runtimeChildren, sourceRevision, runtimeRevision);
		}
	});
}

function reconcileItemContainerChildrenFromCandidate(targetActivity = null, candidateActivity = null) {
	if (!_.isObject(targetActivity) || !_.isObject(candidateActivity)) {
		return;
	}
	const targetChildren = _.isArray(targetActivity.children) ? targetActivity.children : [];
	const candidateChildren = _.isArray(candidateActivity.children) ? candidateActivity.children : [];
	const candidateLookup = buildNodeLookupByIdentity(candidateChildren, {});
	const getRevisionNumber = (activity) => (_.isObject(activity) && _.isNumber(activity.revision) ? activity.revision : 0);
	const targetRevision = getRevisionNumber(targetActivity);
	const candidateRevision = getRevisionNumber(candidateActivity);

	if (sourceHasItemContainerWithMissingChildren(targetChildren)) {
		hydrateMissingItemContainerChildrenFromRuntime(targetChildren, candidateLookup, candidateChildren);
	}
	reconcileStaleItemContainerChildrenFromRuntime(targetChildren, candidateLookup, candidateChildren, targetRevision, candidateRevision);
}

export async function getActivityForAuthoring(activityId, prefix = getIdentityId()) {
	const sourceKey = `${prefix}/source/${activityId}.json`;
	const legacySourceKey = `${prefix}/${activityId}-source.json`;
	const runtimeKey = `${prefix}/${activityId}.json`;
	const isMissingSource = (err) => err && (err.code === "NoSuchKey" || err.code === "NotFound" || err.statusCode === 404);
	const getRevisionNumber = (activity) => (_.isObject(activity) && _.isNumber(activity.revision) ? activity.revision : 0);

	try {
		const sourceActivity = await getObject(env.s3.contentBucket, sourceKey);
		try {
			const runtimeActivity = await getObject(env.s3.contentBucket, runtimeKey);
			reconcileItemContainerChildrenFromCandidate(sourceActivity, runtimeActivity);
		} catch (hydrateErr) {
			console.warn("Unable to reconcile itemContainer children from runtime fallback", hydrateErr);
		}
		try {
			const legacySourceActivity = await getObject(env.s3.contentBucket, legacySourceKey);
			reconcileItemContainerChildrenFromCandidate(sourceActivity, legacySourceActivity);
		} catch (legacyHydrateErr) {
			if (!isMissingSource(legacyHydrateErr)) {
				console.warn("Unable to reconcile itemContainer children from legacy source fallback", legacyHydrateErr);
			}
		}
		if (prefix !== getIdentityId()) {
			sourceActivity.identityId = prefix;
		}
		return {
			activity: sourceActivity,
			sourceUsed: true,
			key: sourceKey
		};
	} catch (err) {
		if (!isMissingSource(err)) {
			throw err;
		}
	}

	// Backward compatibility for old source naming while we migrate to /source/.
	try {
		const legacySourceActivity = await getObject(env.s3.contentBucket, legacySourceKey);
		try {
			const runtimeActivity = await getObject(env.s3.contentBucket, runtimeKey);
			reconcileItemContainerChildrenFromCandidate(legacySourceActivity, runtimeActivity);
			if (getRevisionNumber(runtimeActivity) > getRevisionNumber(legacySourceActivity)) {
				reconcileItemContainerChildrenFromCandidate(runtimeActivity, legacySourceActivity);
				if (prefix !== getIdentityId()) {
					runtimeActivity.identityId = prefix;
				}
				return {
					activity: runtimeActivity,
					sourceUsed: false,
					key: runtimeKey
				};
			}
		} catch (runtimeErr) {
			if (!isMissingSource(runtimeErr)) {
				console.warn("Unable to reconcile legacy source against runtime", runtimeErr);
			}
		}

		if (prefix !== getIdentityId()) {
			legacySourceActivity.identityId = prefix;
		}
		return {
			activity: legacySourceActivity,
			sourceUsed: true,
			key: legacySourceKey
		};
	} catch (err) {
		if (!isMissingSource(err)) {
			throw err;
		}
	}

	const runtimeActivity = await getObject(env.s3.contentBucket, runtimeKey);
	if (prefix !== getIdentityId()) {
		runtimeActivity.identityId = prefix;
	}
	return {
		activity: runtimeActivity,
		sourceUsed: false,
		key: runtimeKey
	};
}

export function getActivityIfExists(activityId, prefix = getIdentityId()) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			objectExists(env.s3.contentBucket, `${prefix}/${activityId}.json`).then(exists => {
				if (exists) {
					getObject(env.s3.contentBucket, `${prefix}/${activityId}.json`).then(content => {
						resolve(content);
					}).catch(err => {
						reject(err);
					});
				} else {
					resolve();
				}
			}).catch(err => {
				reject(err);
			});
		}).catch(err => {
			reject(err);
		});
	});
}

export function activityExists(activityId, prefix = getIdentityId()) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			objectExists(env.s3.contentBucket, `${prefix}/${activityId}.json`).then(exists => {
				resolve(exists);
			}).catch(err => {
				reject(err);
			});
		}).catch(err => {
			reject(err);
		});
	});
}

export function getObject(bucketName, key, skipParse = false) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
			bucket.getObject({ Key: key }, (err, data) => {
				if (err) {
					reject(err);
				} else {
					// console.log(data, data.Body.toString());
					if (skipParse) {
						resolve(data.Body);
					} else {
						let content = _.trim(data.Body.toString());
						try {
							const parsed = JSON.parse(content);
							contractRevisions.remember(`${bucketName}/${key}`, parsed, data.ETag);
							resolve(parsed);
						} catch (e) {
							resolve(content);
						}

					}
				}
			});
		}).catch(err => {
			reject(err);
		});
	});
}

export function getObjectVersion(bucketName, key, versionId, skipParse = false) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
			bucket.getObject({ Key: key, VersionId: versionId }, (err, data) => {
				if (err) {
					reject(err);
				} else if (skipParse) {
					resolve(data.Body);
				} else {
					let content = _.trim(data.Body.toString());
					try {
						resolve(JSON.parse(content));
					} catch (e) {
						resolve(content);
					}
				}
			});
		}).catch(err => {
			reject(err);
		});
	});
}

export function listObjectVersionsForKey(bucketName, key) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(async () => {
			try {
				const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
				let keyMarker;
				let versionIdMarker;
				const versions = [];

				do {
					const response = await bucket.listObjectVersions({
						Bucket: bucketName,
						Prefix: key,
						KeyMarker: keyMarker,
						VersionIdMarker: versionIdMarker
					}).promise();

					(response.Versions || [])
						.filter((version) => version.Key === key)
						.forEach((version) => versions.push(version));

					keyMarker = response.IsTruncated ? response.NextKeyMarker : null;
					versionIdMarker = response.IsTruncated ? response.NextVersionIdMarker : null;
				} while (keyMarker);

				resolve(versions.sort((a, b) => {
					if (a.IsLatest && !b.IsLatest) {
						return -1;
					}
					if (!a.IsLatest && b.IsLatest) {
						return 1;
					}
					return new Date(b.LastModified).getTime() - new Date(a.LastModified).getTime();
				}));
			} catch (err) {
				reject(err);
			}
		}).catch(err => {
			reject(err);
		});
	});
}

async function getVersionRevisionMeta(bucketName, key, version) {
	try {
		const content = await getObjectVersion(bucketName, key, version.VersionId);
		return {
			versionId: version.VersionId,
			lastModified: version.LastModified,
			isLatest: !!version.IsLatest,
			revision: _.isNumber(_.get(content, "revision")) ? content.revision : null,
			revisionTs: _.isNumber(_.get(content, "revisionTs")) ? content.revisionTs : null
		};
	} catch (err) {
		return {
			versionId: version.VersionId,
			lastModified: version.LastModified,
			isLatest: !!version.IsLatest,
			revision: null,
			revisionTs: null,
			error: _.toString(_.get(err, "message", err) || "Unable to inspect version")
		};
	}
}

export async function listActivityRevisionHistory(activityId, prefix = getIdentityId()) {
	const bucketName = env.s3.contentBucket;
	const runtimeKey = `${prefix}/${activityId}.json`;
	const sourceKey = `${prefix}/source/${activityId}.json`;
	const legacySourceKey = `${prefix}/${activityId}-source.json`;
	let sourceVersions = await listObjectVersionsForKey(bucketName, sourceKey);
	let resolvedSourceKey = sourceKey;

	if (sourceVersions.length === 0) {
		sourceVersions = await listObjectVersionsForKey(bucketName, legacySourceKey);
		resolvedSourceKey = legacySourceKey;
	}

	const runtimeVersions = await listObjectVersionsForKey(bucketName, runtimeKey);
	const [sourceEntries, runtimeEntries] = await Promise.all([
		Promise.all(sourceVersions.map((version) => getVersionRevisionMeta(bucketName, resolvedSourceKey, version))),
		Promise.all(runtimeVersions.map((version) => getVersionRevisionMeta(bucketName, runtimeKey, version)))
	]);

	const runtimeEntriesByRevision = _.groupBy(runtimeEntries.filter((entry) => _.isNumber(entry.revision)), (entry) => String(entry.revision));
	const entries = sourceEntries.map((sourceEntry) => {
		let runtimeEntry = null;
		if (_.isNumber(sourceEntry.revision) && runtimeEntriesByRevision[String(sourceEntry.revision)] && runtimeEntriesByRevision[String(sourceEntry.revision)].length > 0) {
			runtimeEntry = runtimeEntriesByRevision[String(sourceEntry.revision)][0];
		} else if (_.isNumber(sourceEntry.revisionTs)) {
			const timestampMatches = runtimeEntries.filter((entry) => _.isNumber(entry.revisionTs));
			runtimeEntry = _.minBy(timestampMatches, (entry) => Math.abs(entry.revisionTs - sourceEntry.revisionTs)) || null;
		}

		return {
			revision: sourceEntry.revision,
			revisionTs: sourceEntry.revisionTs,
			sourceVersionId: sourceEntry.versionId,
			sourceLastModified: sourceEntry.lastModified,
			sourceIsLatest: sourceEntry.isLatest,
			sourceError: sourceEntry.error || null,
			runtimeVersionId: runtimeEntry ? runtimeEntry.versionId : null,
			runtimeLastModified: runtimeEntry ? runtimeEntry.lastModified : null,
			runtimeRevision: runtimeEntry ? runtimeEntry.revision : null,
			runtimeRevisionTs: runtimeEntry ? runtimeEntry.revisionTs : null,
			runtimeError: runtimeEntry ? runtimeEntry.error || null : null,
			isLatest: sourceEntry.isLatest
		};
	});

	return {
		activityId,
		prefix,
		sourceKey: resolvedSourceKey,
		runtimeKey,
		entries
	};
}

export function getInventory(prefix = getIdentityId()) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const Key = `${prefix}/${env.artifacts.inventoryFileName}`;
			const Bucket = env.s3.contentBucket;

			objectExists(Bucket, Key).then((res) => {
				if (res) {
					const bucket = new AWS.S3({ useDualStack: true, params: { Bucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
					bucket.getObject({ Key }, (err, data) => {
						if (err) {
							reject(err);
						} else {
							resolve(JSON.parse(data.Body.toString()));
						}
					});
				} else {
					// Doesn't exist yet!
					uploadObject([], Bucket, Key).then(() => {
						resolve([]);
					}).catch(err => {
						reject(err);
					});
				}
			}).catch(err => {
				reject(err);
			});
		}).catch(err => {
			reject(err);
		});
	});
}

// export function getTimerTemplates(prefix = getIdentityId()) {
// 	return new Promise(async (resolve, reject) => {
// 		try {
// 			const s3 = new AWS.S3({ useDualStack: true });
// 			const timerTemplatesData = await s3.getObject({ Bucket: env.s3.contentBucket, Key: prefix + "/" + TIMER_TEMPLATES_FILE_NAME }).promise();
// 			const newTimerTemplates = JSON.parse(timerTemplatesData.Body.toString());

// 			resolve(newTimerTemplates);
// 			// If exists then set otherwise set a template of timers
// 		} catch (err) {
// 			if (err.statusCode === 404) {
// 				await putJsonFileToS3(env.s3.contentBucket, "timerTemplates.json", timerTemplates);
// 				resolve(timerTemplates);
// 			} else {
// 				reject(err);
// 			}
// 		}
// 	});
// }


/**
 * This function will filter out all non essential properties from shared/external artifacts.
 * There are only a certain amount of properties that can remain in the users inventory.
 * @param {*} activities 
 */
function filterExternalActivityProperties(activities) {
	const result = [];

	activities.forEach(activity => {
		if (activity.hasOwnProperty("identityId") && !_.isEmpty(activity.identityId)) {
			result.push(_.pick(activity, INVENTORY_EXTERNAL_CONTENT_PERSISTENT_PROPS));
		} else {
			result.push(activity);
		}
	});

	return result;
}

export function putInventory(inventory, prefix = getIdentityId()) {

	// Make sure that when this is put that blank entries are removed
	const _inventory = _.filter(inventory, (o) => !o.newDoc);

	return uploadObject(
		filterExternalActivityProperties(
			// Create stripped down experiences inventory
			createExperiencesInventoryFromActivities(
				filterLearningActivities(_inventory)
			)
		),
		env.s3.contentBucket, `${prefix}/${env.artifacts.inventoryFileName}`);
}


export function copyObject(sourceBucket, sourceKey, destinationBucket, destinationKey, additionalParams = {}) {
	return new Promise((resolve, reject) => {
		const copySourceKey = encodeS3CopySourceKey(sourceKey);
		let params = {
			CopySource: `/${sourceBucket}/${copySourceKey}`,
			Key: destinationKey
		};

		_.each(additionalParams, (value, key) => {
			params[key] = value;
		});
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: destinationBucket } });
		bucket.copyObject(params, function (err, data) {
			if (err) {
				reject(err);
			} else {
				resolve(data);
			}
		});
	});
}

export function moveObject(sourceBucket, sourceKey, destinationBucket, destinationKey) {
	return new Promise((resolve, reject) => {
		copyObject(sourceBucket, sourceKey, destinationBucket, destinationKey).then(() => {
			deleteObject(sourceBucket, sourceKey).then(() => {
				resolve();
			}).catch(err => {
				reject(err);
			});
		}).catch(err => {
			reject(err);
		});
	});
}

export function uploadObject(content, bucketName, key, skipRefreshSession = false) {
	return new Promise(async (resolve, reject) => {
		try {
			if (!skipRefreshSession) {
				await refreshCredentials();
			}
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
			const params = { Key: key, ContentType: "application/json", Body: !_.isString(content) ? JSON.stringify(content) : content };
			bucket.upload(params, (err) => {
				if (err) {
					reject(err);
				} else {
					resolve();
				}
			});
		} catch (err) {
			reject(err);
		}
	});
}

export function deleteObject(bucketName, key) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
			bucket.deleteObject({ Key: key }, err => {
				if (err) {
					reject(err);
				} else {
					resolve();
				}
			});
		}).catch((err) => {
			reject(err);
		});
	});

}
export function deleteObjects(bucketName, objects) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
			bucket.deleteObjects({ Delete: { Objects: objects } }, err => {
				if (err) {
					reject(err);
				} else {
					resolve();
				}
			});
		}).catch((err) => {
			reject(err);
		});
	});

}
export function objectExists(bucketName, key) {

	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
			bucket.headObject({ Key: key }, function (err) {
				if (err && err.code === "NotFound") {
					resolve(false);
				} else if (err) {
					reject(err);
				} else {
					resolve(true);
				}
			});
		}).catch((err) => {
			reject(err);
		});
	});
}

export function objectExists2(bucketName, key) { // eslint-disable-line
	return new Promise((resolve) => {
		resolve(true);
	});
}


export function listAllObjects(bucketName, prefix) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			recursiveListObjects(bucketName, prefix, (err, data) => {
				if (err) {
					reject(err);
				} else {
					resolve(data);
				}
			});
		}).catch((err) => {
			reject(err);
		});
	});
}

function recursiveListObjects(bucketName, prefix = null, cb = () => { }, marker = null, files = []) {
	const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
	const params = {
		Bucket: bucketName
	};

	// are we paging from a specific point?
	if (marker) {
		params.Marker = marker;
	}

	if (prefix) {
		params.Prefix = prefix;
	}

	bucket.listObjects(params, function (err, data) {
		if (err) {
			return cb(err);
		}

		// concat the list of files into our collection
		files = files.concat(data.Contents);

		// are we paging?
		if (data.IsTruncated) {
			let length = data.Contents.length;
			let marker = data.Contents[length - 1].Key;
			// recursion!
			recursiveListObjects(bucketName, prefix, cb, marker, files);
		} else {
			cb(undefined, files);
		}

	});
}

export function batchGetActivities(activities) {
	return new Promise((resolve, reject) => {
		Promise.all(activities.map((activity) => {

			let keyPrefix = getIdentityId();
			if (activity.hasOwnProperty("identityId")) {
				keyPrefix = activity.identityId;
			}

			return getActivityIfExists(activity.id, keyPrefix);
		})).then(results => {
			resolve(_.filter(results, (o) => { return !_.isUndefined(o) && !_.isNull(o); }));
		}).catch(err => {
			reject(err);
		});
	});
}

export function getObjectTags(bucketName, key) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
			bucket.getObjectTagging({ Key: key }, (err, data) => {
				if (err) {
					reject(err);
				} else {
					resolve(data.TagSet);
				}
			});
		}).catch((err) => {
			reject(err);
		});
	});
}

export function getObjectTag(bucketName, key, tagName) {
	return new Promise((resolve, reject) => {
		const multipleTagNames = _.isArray(tagName);
		getObjectTags(bucketName, key).then(tags => {
			let result = null;
			tags.forEach(tag => {
				if (!multipleTagNames && tag.Key === tagName) {
					result = tag.Value;
				} else if (multipleTagNames && _.indexOf(tagName, tag.Key) !== -1) {
					if (!result) {
						result = {};
					}
					result[tag.Key] = tag.Value;
				}
			});
			resolve(result);
		}).catch(err => {
			reject(err);
		});
	});
}

export function getActivityTag(activityId, tagName, prefix = getIdentityId()) {
	return getObjectTag(env.s3.contentBucket, `${prefix}/${activityId}.json`, tagName);
}

export function putObjectTags(bucketName, key, tags) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
			bucket.putObjectTagging({ Key: key, Tagging: { TagSet: tags } }, (err, data) => {
				if (err) {
					reject(err);
				} else {
					resolve(data);
				}
			});
		}).catch((err) => {
			reject(err);
		});
	});
}

/**
 * Will put the provided content into the specified bucket and under the specified key. Converts content to string if not yet a string.
 * @param {*} bucketName 
 * @param {*} key 
 * @param {*} content 
 * @param {*} contentType default to "application/json"
 */
export function putObject(bucketName, key, content, contentType = "application/json") {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
			// await s3.putObject({ Bucket: bucketName, Key: keyPrefix + "/" + fileName, Body: body }).promise();

			const Body = !_.isString(content) ? JSON.stringify(content) : content;

			bucket.putObject({ Key: key, Body, ContentType: contentType }, (err, data) => {
				if (err) {
					reject(err);
				} else {
					resolve(data);
				}
			});
		}).catch((err) => {
			reject(err);
		});
	});
}

export function putActivityTag(activityId, tagName, tagValue, prefix = getIdentityId()) {
	return putActivityTags(activityId, { [tagName]: tagValue }, prefix);
}

/**
 * 
 * @param {*} activityId activity that shall receive the tags (will be added to existing tags)
 * @param {Object} tagsObj key/value map
 * @param {*} prefix 
 */
export function putActivityTags(activityId, tags, prefix = getIdentityId()) {
	return new Promise((resolve, reject) => {
		const BucketName = env.s3.contentBucket;
		const Key = `${prefix}/${activityId}.json`;
		getObjectTags(BucketName, Key).then(existingTags => {
			const existingTagsMap = existingTags && existingTags.length > 0 ? arrayToMap(existingTags, "Key") : {};
			_.keys(tags).forEach(key => {
				existingTagsMap[key] = tags[key];
			});
			console.log(existingTagsMap);
			const newTags = _.keys(existingTagsMap).map(Key => {
				return {
					Key,
					Value: existingTagsMap[Key]
				};
			});
			console.log(newTags);
			putObjectTags(BucketName, Key, newTags).then(res => {
				resolve(res);
			}).catch(err => {
				reject(err);
			});
		});
	});
}


/**
 * options.silent suppresses the blocking error dialog and only rejects. For callers
 * that load an instance speculatively — a dashboard hydrating rows it did not choose
 * — a missing object is an ordinary outcome, and a modal per row is not.
 */
export function loadActivityInstanceFromS3(bucketName, fileName, options = {}) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
			bucket.getObject({ Key: `${fileName}` }, (err, data) => {
				if (err) {
					if (!options.silent) {
						showError("Unable to get activity", err);
					}
					reject(err);
				} else {
					// Set previewChecklist
					let jsonChecklist = JSON.parse(data.Body.toString());
					// Should convert to make sure has at least one list and one section and set proper type
					jsonChecklist = normalizeActivity(jsonChecklist);
					const revision = contractRevisions.remember(`${bucketName}/${fileName}`, jsonChecklist, data.ETag);
					resolve(options.withRevision ? { instance: jsonChecklist, revision } : jsonChecklist);
				}
			});
		}).catch((err) => {
			console.error(err);
			if (!options.silent) {
				showError2("Unable to load activity", err);
			}
			reject(err);
		});
	});

}

/**
 * Checks for invalid S3 paths when saving activities. 
 * 
 * Paths cannont contain null or undefined.
 * 
 * @param {*} strPath 
 * @returns boolean indicating whether or not the path is valid
 */
export function isValidActivitySavePathPrefix(strPath) {
	if (!strPath) {
		return false;
	}

	let strPathLowerCase = strPath.toLowerCase();

	if (strPathLowerCase.includes("null") ||
		strPathLowerCase.includes("undefined") ||
		strPathLowerCase === "/") {
		return false;
	}

	return true;
}
